/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 54);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(62);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(61)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(9);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.11
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.11';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(5), __webpack_require__(55).setImmediate))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Comprar_Rentus__ = __webpack_require__(17);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    ComprarRentus: __WEBPACK_IMPORTED_MODULE_1__Comprar_Rentus__["a" /* default */]
  },
  data: function data() {
    return {
      usuarios: {
        mail: '',
        pasw: '',
        empresa: '1'
      },
      pase: '',
      permisos: '',
      verComprar: false,
      cargando: false,
      version: 'V 3.4'
    };
  },

  methods: {
    hoy: function hoy() {
      // regresa la fecha actual en formato YYYY-mm-dd
      var fech = new Date();
      var dia = fech.getDate();
      if (dia < 10) dia = '0' + dia;
      var mes = fech.getMonth() + 1;
      if (mes < 10) mes = '0' + mes;
      var año = fech.getFullYear();
      return año + '-' + mes + '-' + dia;
    },
    checarUsuario: function checarUsuario() {
      var _this = this;

      var router = this.$router;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/checaUsuario2.php?elmail=' + this.usuarios.mail + '&laClave=' + this.usuarios.pasw + '&laEmpresa=' + this.usuarios.empresa).then(function (respuesta) {
        if (respuesta) {
          var laRespuesta = respuesta.data;
          if (laRespuesta.includes('sies')) {
            // autorizado
            _this.pase = 'vealo';
            _this.cargando = true;
            // pasa el vector de permisos
            var indice = laRespuesta.indexOf('*');
            _this.permisos = laRespuesta.substring(indice + 1);

            // actualiza los cargos de rentas al día de hoy
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/agregaRentas.php?fa=' + _this.hoy()).then(function (respue) {
              if (respue) {
                // actualiza los saldos y fechas de saldos en el archivo propiedades

                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/actualizaSaldos.php?fa=' + _this.hoy()).then(function (respue) {
                  _this.cargando = false;
                  // alert('\n\n     Bienvenido\n     a RENTUS');
                }).catch(function (error) {
                  alert('No se pudieron actualizar los saldos al día. Error: ' + error);
                });
              }
            }).catch(function (error) {
              alert('No se pudieron actualizar las rentas al día. Error: ' + error);
            });
            // router.push('/location').catch(err => {})
            router.push('/App');
          } else {
            alert("Usuario sin autorizacion");
          }
        } else {
          alert("El servidor no respondio con acceso");
          return;
        }
      }).catch(function (error) {
        alert('No se puede accesar el servidor ' + error.message);
      });
    },
    emem: function emem() {
      // pide el contrato en caso de que sea usuario para pedir su edo de cuenta
      var cualContrato = prompt("\n\nContrato folio ?");
      // valida el contrato y el mail
      if (cualContrato <= 0 || cualContrato > 10000) {
        alert("\n\n Ingrese su contrato y su mail que puso en su contrato por favor ");
        return;
      }

      // pide el mail en caso de que sea usuario para pedir su edo de cuenta
      var cualMail = prompt("\n\nIngrese aqui el mail que puso en su contrato");
      // valida el contrato y el mail
      if (cualMail.length == 0 || !cualMail.includes('@')) {
        alert("\n\n Falta el mail de su contrato");
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/enviarEdoMail.php?edcpm=' + cualMail + '&ecde=' + cualContrato).then(function (respue) {
        if (respue.statusText == 'OK') {
          alert('\n\n     Estado de cuenta enviado a: \n     ' + cualMail);
        }
      }).catch(function (error) {
        alert('No se pudo enviar el estado de cuenta.  ' + error);
      });
    },
    licfun: function licfun() {
      // pide el contrato en caso de que sea usuario para pedir su edo de cuenta
      var cualContrato2 = prompt("\n\nContrato folio ?");
      // valida el contrato y el mail
      if (cualContrato2 <= 0 || cualContrato2 > 10000) {
        alert("\n\n Ingrese su contrato por favor ");
        return;
      }

      // pide el mail en caso de que sea usuario para pedir su edo de cuenta
      var cualMail2 = prompt("\n\nIngrese aqui el mail de su contrato");
      // valida el contrato y el mail
      if (cualMail2.length == 0 || !cualMail2.includes('@')) {
        alert("\n\n Falta el mail de su contrato");
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/enviarDocLF.php?edcpm=' + cualMail2 + '&ecde=' + cualContrato2).then(function (respue) {
        if (respue.statusText == 'OK') {
          alert('\n\n     Estado de cuenta enviado a: \n     ' + cualMail2);
        }
      }).catch(function (error) {
        alert('No se pudo enviar el estado de cuenta.  ' + error);
      });
    }
  }

});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(4);
var normalizeHeaderName = __webpack_require__(67);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(13);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(13);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var settle = __webpack_require__(68);
var buildURL = __webpack_require__(10);
var buildFullPath = __webpack_require__(70);
var parseHeaders = __webpack_require__(73);
var isURLSameOrigin = __webpack_require__(74);
var createError = __webpack_require__(14);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(75);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(69);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comprar_Rentus_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6583646_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comprar_Rentus_vue__ = __webpack_require__(78);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comprar_Rentus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6583646_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comprar_Rentus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'agrega-inquilino',
    props: ['vector', 'elusuario'],
    data: function data() {
        return {
            inquilinos: {
                nombreCompleto: '',
                email: '',
                celular: '',
                telefonoFijo: '',
                whatsapp: '',
                facebook: '',
                dirCalle: '',
                dirNumero: '',
                dirInterior: '',
                dirColonia: '',
                dirCodigo: '',
                dirCiudad: '',
                dirEstado: '',
                status: '',
                fechaModifica: '',
                quienModifico: ''
            },
            wVentas: "4423226293",
            eMailVentas: "rentusqro@gmail.com"
        };
    },

    methods: {
        guardarInquilino: function guardarInquilino() {
            var inquilinos1 = this.inquilinos;
            var router = this.$router;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/agregaInquilino.php?nombreCompleto=' + inquilinos1.nombreCompleto + '&email=' + inquilinos1.email + '&celular=' + inquilinos1.celular + '&telefonoFijo=' + inquilinos1.telefonoFijo + '&whatsapp=' + inquilinos1.whatsapp + '&facebook=' + inquilinos1.facebook + '&dirCalle=' + inquilinos1.dirCalle + '&dirNumero=' + inquilinos1.dirNumero + '&dirInterior=' + inquilinos1.dirInterior + '&dirColonia=' + inquilinos1.dirColonia + '&dirCodigo=' + inquilinos1.dirCodigo + '&dirCiudad=' + inquilinos1.dirCiudad + '&dirEstado=' + inquilinos1.dirEstado + '&status=A' + '&fechaModifica=' + this.fechaActual() + '&quienModifico=' + this.elusuario).then(function (respue) {
                if (respue.statusText == 'OK') {
                    router.push('/inq');
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        fechaActual: function fechaActual() {
            var currentDate = new Date(); //hoy
            var day = currentDate.getDate();
            var month = currentDate.getMonth() + 1;
            var year = currentDate.getFullYear();
            var my_date = year + "-" + month + "-" + day;
            return my_date;
        }
    }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Inquilinos',
	mounted: function mounted() {
		this.getInquilinos();
	},

	props: ['vector'],
	data: function data() {
		return {
			inquilinosTodos: null,
			abuscar: ''
		};
	},

	methods: {
		getInquilinos: function getInquilinos() {
			var _this = this;

			// checa si tiene autorizacion
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Inquilinos')) {
					alert('Seccion no autorizada');
					return;
				}
			}

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeInquilinos.php').then(function (respuesta) {
				_this.inquilinosTodos = respuesta.data;
				console.log('fffff ' + respuesta.data[1]['email']);
			});
		}
	},

	computed: {
		buscando: function buscando() {
			var _this2 = this;

			return this.inquilinosTodos.filter(function (item) {
				return item.nombreCompleto.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.email.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.celular.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.status.toUpperCase().includes(_this2.abuscar.toUpperCase());
			});
		}
	}

});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Propiedades',
  mounted: function mounted() {
    this.getPropiedades();
  },

  props: ['vector', 'empresa'],
  data: function data() {
    return {
      propiedadesTodas: null,
      abuscar: ''
    };
  },

  methods: {
    getPropiedades: function getPropiedades() {
      var _this = this;

      // checa si tiene autorizacion
      if (!this.vector.includes('MASTERGGUV')) {
        if (!this.vector.includes('Propiedades')) {
          alert('Seccion no autorizada');
          return;
        }
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leePropiedades.php').then(function (respuesta) {
        _this.propiedadesTodas = respuesta.data;
      });
    },
    formateaNumero: function formateaNumero(valor1) {
      return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
    }
  },

  computed: {
    buscando: function buscando() {
      var _this2 = this;

      return this.propiedadesTodas.filter(function (item) {
        return item.familia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.subfamilia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.dueno.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.nombreCompleto.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.dirCalle.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.dirNumero.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.tipo.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.status.toUpperCase().includes(_this2.abuscar.toUpperCase());
      });
    }
  }

});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Contrato_editar_vue__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Contratos',
  components: {
    EditarIndividual: __WEBPACK_IMPORTED_MODULE_1__Contrato_editar_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.getContratos();
  },

  props: ['vector'],
  data: function data() {
    return {
      contratosTodos: null,
      abuscar: '',
      verIndividual: false,
      verTodos: false
    };
  },

  methods: {
    getContratos: function getContratos() {
      var _this = this;

      // checa si tiene autorizacion
      if (!this.vector.includes('MASTERGGUV')) {
        if (!this.vector.includes('Contratos')) {
          alert('Seccion no autorizada');
          return;
        }
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php').then(function (respuesta) {
        _this.contratosTodos = respuesta.data;
      });
    },


    vencido: function vencido(fecha, status) {

      var fecha1 = new Date(fecha);
      fecha1.setHours(0);

      var hoy = new Date();
      hoy.setHours(0);

      var fechams = fecha1.getTime(); // en milisegundos				
      var hoyms = hoy.getTime(); // en milisegundos
      var unMes = 30 * 24 * 60 * 60 * 1000;

      var diferencia = hoyms - fechams;

      if (fechams < hoyms) {
        if (status == "FINALIZADO") {
          return ".";
        }
        return "CONTRATO VENCIDO EL " + this.formateaFecha(fecha) + ", HACE " + (diferencia / unMes).toFixed(0) + " MESES, FAVOR DE RENOVARLO";
      }

      // si no esta vencido entonces checa si vencera en dos meses o menos
      if (fechams - unMes - unMes < hoyms) {
        return "CONTRATO POR VENCER EL " + this.formateaFecha(fecha) + " EN  " + (-diferencia / unMes).toFixed(0) + " MESES **";
      }
    },

    formateaFecha: function formateaFecha(fecha) {
      var d = new Date(fecha);
      if (Date.parse(d)) {
        // pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
        d.setHours(0);
        var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
        d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
        return d;
      } else {
        return "sin fecha";
      }
    },

    formateaNumero: function formateaNumero(valor1) {
      return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
    },
    formateaNumeroSimple: function formateaNumeroSimple(valor1) {
      return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 0 });
    },
    fechaActual: function fechaActual() {
      var currentDate = new Date(); //hoy
      var day = currentDate.getDate();
      var month = currentDate.getMonth() + 1;
      var year = currentDate.getFullYear();
      var my_date = year + "-" + month + "-" + day;
      return my_date;
    },
    verContrato: function verContrato(num) {
      this.numContrato = num;
      this.verIndividual = true;
      this.cualContratoVer = num;
    },
    cambioIncluye: function cambioIncluye() {
      this.verTodos = !this.verTodos;
      this.getContratos();
    }
  },
  computed: {
    buscando: function buscando() {
      var _this2 = this;

      return this.contratosTodos.filter(function (item) {
        return item.propiedad.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.inquilino.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.familia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.giro.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.id.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.nombreComercial.toUpperCase().includes(_this2.abuscar.toUpperCase());
      });
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contrato_editar_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_755a1dfb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contrato_editar_vue__ = __webpack_require__(92);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contrato_editar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_755a1dfb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contrato_editar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editar-contrato',
	props: ['vector', 'cualContrato'],

	mounted: function mounted() {
		var _this = this;

		var con = '';
		var contratos2 = '';

		// checa si tiene autorizacion
		if (!this.vector.includes('MASTERGGUV')) {
			if (!this.vector.includes('Contratos Editar')) {
				document.getElementById('contra-editar').hidden = true;
				alert('Seccion no autorizada');
				return;
			}
		}

		this.id = this.$route.params.id;
		this.id = this.cualContrato;

		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeUnContrato.php?id=' + this.id).then(function (respue) {
			con = respue.data;

			contratos2 = con[0];

			_this.contratos.id = contratos2.id;
			_this.contratos.inquilinoId = contratos2.inquilinoId;
			_this.contratos.propiedadId = contratos2.propiedadId;
			_this.contratos.inquilino = contratos2.inquilino;
			_this.contratos.propiedad = contratos2.propiedad;
			_this.contratos.nombreComercial = contratos2.nombreComercial;
			_this.contratos.giro = contratos2.giro;
			_this.contratos.importeMes = contratos2.importeMes;
			_this.contratos.familia = contratos2.familia;

			_this.contratos.fechaModificacion = contratos2.fechaModificacion;
			_this.contratos.quienModifico = contratos2.quienModifico;
			_this.contratos.fechaInicio = contratos2.fechaInicio;
			_this.contratos.fechaTerminacion = contratos2.fechaTerminacion;
			_this.contratos.status = contratos2.status;
			_this.contratos.finalizo = contratos2.finalizo;
			_this.contratos.depositarA = contratos2.depositarA;

			if (_this.contratos.status == "FINALIZADO") {
				document.getElementById('status').style.display = "none";
				document.getElementById('fechaFinalizo').disabled = "true";
			}
		});
	},
	data: function data() {
		return {
			id: null,
			contratos: {
				id: '',
				inquilinoId: '',
				propiedadId: '',
				inquilino: '',
				propiedad: '',
				nombreComercial: '',
				giro: '',
				importeMes: '',
				fechaModificacion: '',
				quienModifico: '',
				depositarA: '',
				status: ''
			}
		};
	},

	methods: {
		guardarContrato: function guardarContrato() {
			var _this2 = this;

			var contratos3 = this.contratos;
			var router = this.$router;

			if (contratos3.status == "FINALIZADO") {
				if (!contratos3.finalizo) {
					alert("\n\nEn cual fecha finalizo ?");
					return;
				}
				if (confirm("Cuidado\nya no se cargarán las rentas mensuales\npara este contrato a partir del " + this.formateaFecha(contratos3.finalizo) + "\n\nestá de acuerdo ?")) {
					// sigue adelante 
				} else return;
			}

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/modificaContrato.php?id=' + contratos3.id + '&inquilinoId=' + contratos3.inquilinoId + '&propiedadId=' + contratos3.propiedadId + '&inquilino=' + contratos3.inquilino + '&propiedad=' + contratos3.propiedad + '&nombreComercial=' + contratos3.nombreComercial + '&giro=' + contratos3.giro + '&importeMes=' + contratos3.importeMes + '&fechaModificacion=' + contratos3.fechaModificacion + '&quienModifico=' + contratos3.quienModifico + '&finalizo=' + contratos3.finalizo + '&depA=' + contratos3.depositarA + '&status=' + contratos3.status).then(function (respue) {
				if (respue.statusText == 'OK') {
					alert('Modificado');
					//router.push('/con')
					_this2.$emit('cerrar');
				}
			}).catch(function (error) {
				console.log(error);
			});
		},


		formateaFecha: function formateaFecha(fecha) {
			var d = new Date(fecha);
			if (Date.parse(d)) {
				// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				d.setHours(0);
				var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
				d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
				return d;
			} else {
				return "sin fecha";
			}
		}

	}
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
		name: 'Movimientos',
		mounted: function mounted() {
				this.getMovimientos();
		},

		props: ['vector'],
		data: function data() {
				return {
						movimientosTodos: null,
						abuscar: ''
				};
		},

		methods: {
				getMovimientos: function getMovimientos() {
						var _this = this;

						// checa si tiene autorizacion
						if (!this.vector.includes('MASTERGGUV')) {
								if (!this.vector.includes('Movimientos')) {
										alert('Seccion no autorizada');
										return;
								}
						}

						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeMovimientos.php').then(function (respuesta) {
								_this.movimientosTodos = respuesta.data;
						});
				},


				formateaFecha: function formateaFecha(fecha) {
						var d = new Date(fecha);
						d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
						d.setHours(0);

						if (Date.parse(d)) {
								//var opciones = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
								var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
								d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
								return d;
						} else {
								return "sin fecha";
						}
				},

				formateaNumero: function formateaNumero(valor1) {
						return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
				}
		},

		computed: {
				buscando: function buscando() {
						var _this2 = this;

						return this.movimientosTodos.filter(function (item) {
								return item.tipo.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.contrato.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.inquilinoNombre.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.propiedadNombre.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.giro.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.familia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.concepto.toUpperCase().includes(_this2.abuscar.toUpperCase());
						});
				}
		}

});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Usuarios',
  mounted: function mounted() {
    this.getUsuarios();
  },

  props: ['vector'],
  data: function data() {
    return {
      usuariosTodos: null
    };
  },

  methods: {
    getUsuarios: function getUsuarios() {
      var _this = this;

      // checa si tiene autorizacion
      if (!this.vector.includes('MASTERGGUV')) {
        if (!this.vector.includes('Usuarios')) {
          alert('Seccion no autorizada');
          return;
        }
      }
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeUsuarios.php').then(function (respuesta) {
        _this.usuariosTodos = respuesta.data;
      });
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'inquilino-ver',

	mounted: function mounted() {
		this.entrar();
	},

	props: ['vector'],
	data: function data() {
		return {
			id: null,
			inquilinoSolo: null
		};
	},

	methods: {
		entrar: function entrar() {
			var _this = this;

			// checa si tiene autorizacion
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Inquilinos Ver detalle')) {
					document.getElementById('captura').hidden = true;
					alert('Seccion no autorizada');
					return;
				}
			}
			this.id = this.$route.params.id;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeUnInquilino.php?id=' + this.id).then(function (respue) {
				_this.inquilinoSolo = respue.data;
			});
		}
	}
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'agrega-inquilino',
	props: ['vector', 'elusuario', 'empresa'],
	mounted: function mounted() {
		this.valida();
	},
	data: function data() {
		return {
			inquilinos: {
				nombreCompleto: '',
				email: '',
				celular: '',
				telefonoFijo: '',
				whatsapp: '',
				facebook: '',
				dirCalle: '',
				dirNumero: '',
				dirInterior: '',
				dirColonia: '',
				dirCodigo: '',
				dirCiudad: '',
				dirEstado: '',
				status: '',
				fechaModifica: '',
				quienModifico: ''
			}
		};
	},

	methods: {
		valida: function valida() {
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Inquilinos Altas')) {
					alert('Seccion no autorizada');
					document.getElementById('captura').hidden = true;
				}
			}
		},
		guardarInquilino: function guardarInquilino() {
			var inquilinos1 = this.inquilinos;
			var router = this.$router;
			var statusA = 'A';

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/agregaInquilino.php?nombreCompleto=' + inquilinos1.nombreCompleto + '&email=' + inquilinos1.email + '&celular=' + inquilinos1.celular + '&telefonoFijo=' + inquilinos1.telefonoFijo + '&whatsapp=' + inquilinos1.whatsapp + '&facebook=' + inquilinos1.facebook + '&dirCalle=' + inquilinos1.dirCalle + '&dirNumero=' + inquilinos1.dirNumero + '&dirInterior=' + inquilinos1.dirInterior + '&dirColonia=' + inquilinos1.dirColonia + '&dirCodigo=' + inquilinos1.dirCodigo + '&dirCiudad=' + inquilinos1.dirCiudad + '&dirEstado=' + inquilinos1.dirEstado + '&status=' + statusA + '&fechaModifica=' + this.fechaActual() + '&quienModifico=' + this.elusuario).then(function (respue) {
				if (respue.statusText == 'OK') {
					alert("Inquilino dado de alta satisfactoriamente");
					router.push('/inq');
				}
			}).catch(function (error) {
				console.log(error);
			});
		},
		fechaActual: function fechaActual() {
			var currentDate = new Date(); //hoy
			var day = currentDate.getDate();
			var month = currentDate.getMonth() + 1;
			var year = currentDate.getFullYear();
			var my_date = year + "-" + month + "-" + day;
			return my_date;
		}
	}
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editar-inquilino',
	mounted: function mounted() {
		var _this = this;

		var inq = '';
		var inquilinos2 = '';

		this.id = this.$route.params.id;
		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeUnInquilino.php?id=' + this.id).then(function (respue) {
			inq = respue.data;

			var x;
			for (x in inq) {
				inquilinos2 = inq[x];
			}

			_this.inquilinos.id = inquilinos2.id;
			_this.inquilinos.nombreCompleto = inquilinos2.nombreCompleto;
			_this.inquilinos.email = inquilinos2.email;
			_this.inquilinos.celular = inquilinos2.celular;
			_this.inquilinos.telefonoFijo = inquilinos2.telefonoFijo;
			_this.inquilinos.whatsapp = inquilinos2.whatsapp;
			_this.inquilinos.facebook = inquilinos2.facebook;
			_this.inquilinos.dirCalle = inquilinos2.dirCalle;
			_this.inquilinos.dirNumero = inquilinos2.dirNumero;
			_this.inquilinos.dirInterior = inquilinos2.dirInterior;
			_this.inquilinos.dirColonia = inquilinos2.dirColonia;
			_this.inquilinos.dirCodigo = inquilinos2.dirCodigo;
			_this.inquilinos.dirCiudad = inquilinos2.dirCiudad;
			_this.inquilinos.dirEstado = inquilinos2.dirEstado;
		});
	},
	data: function data() {
		return {
			id: null,
			inquilinos: {
				id: '',
				nombreCompleto: '',
				email: '',
				celular: '',
				telefonoFijo: '',
				whatsapp: '',
				facebook: '',
				dirCalle: '',
				dirNumero: '',
				dirInterior: '',
				dirColonia: '',
				dirCodigo: '',
				dirCiudad: '',
				dirEstado: '',
				status: '',
				fechaModifica: '',
				quienModifico: ''
			}
		};
	},

	methods: {
		guardarInquilino: function guardarInquilino() {
			var inquilinos3 = this.inquilinos;
			var router = this.$router;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/modificaInquilino.php?id=' + inquilinos3.id + '&nombreCompleto=' + inquilinos3.nombreCompleto + '&email=' + inquilinos3.email + '&celular=' + inquilinos3.celular + '&telefonoFijo=' + inquilinos3.telefonoFijo + '&whatsapp=' + inquilinos3.whatsapp + '&facebook=' + inquilinos3.facebook + '&dirCalle=' + inquilinos3.dirCalle + '&dirNumero=' + inquilinos3.dirNumero + '&dirInterior=' + inquilinos3.dirInterior + '&dirColonia=' + inquilinos3.dirColonia + '&dirCodigo=' + inquilinos3.dirCodigo + '&dirCiudad=' + inquilinos3.dirCiudad + '&dirEstado=' + inquilinos3.dirEstado + '&fechaModifica=' + '01-01-18' + '&quienModifico=GGUV').then(function (respue) {
				if (respue.statusText == 'OK') {
					router.push('/inq');
				}
			}).catch(function (error) {
				console.log(error);
			});
		}
	}
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'propiedad-ver',

	mounted: function mounted() {
		this.entrar();
	},

	props: ['vector'],
	data: function data() {
		return {
			id: null,
			propiedadSola: null
		};
	},

	methods: {
		entrar: function entrar() {
			var _this = this;

			// checa si tiene autorizacion
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Propiedades Ver detalle')) {
					document.getElementById('propi').hidden = true;
					alert('Seccion no autorizada');
					return;
				}
			}
			this.id = this.$route.params.id;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeUnaPropiedad.php?id=' + this.id).then(function (respue) {
				_this.propiedadSola = respue.data;
				console.log(respue.data);
			});
		}
	}
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
				name: 'agrega-propiedad',
				mounted: function mounted() {
								this.valida();
								this.leeDatosSelects();
				},

				props: ['vector', 'elusuario', 'empresa'],
				data: function data() {
								return {
												propiedades: {
																nombreCompleto: '',
																familia: '',
																subfamilia: '',
																dueno: '',
																tipo: '',
																claveCatastral: '',
																pais: '',
																dirCalle: '',
																dirNumero: '',
																dirInterior: '',
																dirCiudad: '',
																dirEstado: '',
																dirCodigo: '',
																metrosCuadrados: '',
																status: '',
																fechaModifica: '',
																quienModifico: '',
																medidasYcol: ''
												},
												duenosPropiedades: {
																dueno: ''

												},
												ciudadesPropiedades: {
																dirCiudad: ''

												},
												estadosPropiedades: {
																dirEstado: ''

												},
												familiasPropiedades: {
																familia: ''
												},
												nuevoDueno: '',
												nuevoEstado: '',
												nuevoCiudad: '',
												nuevoFamilia: ''
								};
				},

				methods: {
								valida: function valida() {
												if (!this.vector.includes('MASTERGGUV')) {
																if (!this.vector.includes('Propiedades Altas')) {
																				alert('Seccion no autorizada');
																				document.getElementById('captura').hidden = true;
																}
												}
								},
								guardarPropiedad: function guardarPropiedad() {
												var propiedades1 = this.propiedades;
												var router = this.$router;
												propiedades1.fechaModifica = this.fechaActual();

												propiedades1.quienModifico = this.elusuario;

												if (propiedades1.dueno = 'OTRO') propiedades1.dueno = this.nuevoDueno;
												if (propiedades1.dirCiudad = 'OTRO') propiedades1.dirCiudad = this.nuevoCiudad;
												if (propiedades1.dirEstado = 'OTRO') propiedades1.dirEstado = this.nuevoEstado;

												__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/agregaPropiedad.php?emp=' + this.empresa + '&nombreCompleto=' + propiedades1.nombreCompleto + '&familia=' + propiedades1.familia + '&subfamilia=' + propiedades1.subfamilia + '&dueno=' + propiedades1.dueno + '&tipo=' + propiedades1.tipo + '&claveCatastral=' + propiedades1.claveCatastral + '&pais=' + propiedades1.pais + '&dirCalle=' + propiedades1.dirCalle + '&dirNumero=' + propiedades1.dirNumero + '&dirInterior=' + propiedades1.dirInterior + '&dirCiudad=' + propiedades1.dirCiudad + '&dirEstado=' + propiedades1.dirEstado + '&dirCodigo=' + propiedades1.dirCodigo + '&metrosCuadrados=' + propiedades1.metrosCuadrados + '&status=DISPONIBLE' + '&fechaModifica=' + propiedades1.fechaModifica + '&quienModifico=' + propiedades1.quienModifico + '&medidasYcol=' + propiedades1.medidasYcol).then(function (respue) {
																if (respue.statusText == 'OK') {
																				alert('Propiedad agregada satisfactoriamente');
																				router.push('/pro');
																}
												}).catch(function (error) {
																console.log(error);
												});
								},
								fechaActual: function fechaActual() {
												var currentDate = new Date(); //hoy
												var day = currentDate.getDate();
												var month = currentDate.getMonth() + 1;
												var year = currentDate.getFullYear();
												var my_date = year + "-" + month + "-" + day;
												return my_date;
								},
								leeDatosSelects: function leeDatosSelects() {
												var _this = this;

												__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeDuenosPropiedades.php?cuale=' + this.empresa).then(function (respuesta) {
																_this.duenosPropiedades = respuesta.data;

																var selector = document.getElementById("duenosSelect");

																for (var x in _this.duenosPropiedades) {
																				// agrega los duenos al select
																				selector.add(new Option(_this.duenosPropiedades[x].dueno, _this.duenosPropiedades[x].dueno));
																}
												});

												__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeCiudadesPropiedades.php?cuale=' + this.empresa).then(function (respuesta) {
																_this.ciudadesPropiedades = respuesta.data;

																var selector = document.getElementById("ciudadesSelect");

																for (var x in _this.ciudadesPropiedades) {
																				// agrega los duenos al select
																				selector.add(new Option(_this.ciudadesPropiedades[x].dirCiudad, _this.ciudadesPropiedades[x].dirCiudad));
																}
												});

												__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeEstadosPropiedades.php?cuale=' + this.empresa).then(function (respuesta) {
																_this.estadosPropiedades = respuesta.data;

																var selector = document.getElementById("estadosSelect");

																for (var x in _this.estadosPropiedades) {
																				// agrega los duenos al select
																				selector.add(new Option(_this.estadosPropiedades[x].dirEstado, _this.estadosPropiedades[x].dirEstado));
																}
												});

												__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeFamiliasPropiedades.php?cuale=' + this.empresa).then(function (respuesta) {
																_this.leeFamiliasPropiedades = respuesta.data;

																var selector = document.getElementById("familiasSelect");

																for (var x in _this.leeFamiliasPropiedades) {
																				// agrega los duenos al select
																				selector.add(new Option(_this.leeFamiliasPropiedades[x].familia, _this.leeFamiliasPropiedades[x].familia));
																}
												});
								}
				}
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editar-propiedad',
	mounted: function mounted() {
		this.entrar();
	},

	props: ['vector'],
	data: function data() {
		return {
			id: null,
			propiedades: {
				nombreCompleto: '',
				familia: '',
				subfamilia: '',
				dueno: '',
				tipo: '',
				claveCatastral: '',
				pais: '',
				dirCalle: '',
				dirNumero: '',
				dirInterior: '',
				dirCiudad: '',
				dirEstado: '',
				dirCodigo: '',
				metrosCuadrados: '',
				medidorElec: '',
				contratoElec: '',
				AnombreDeElec: '',
				comentarioMedidorE: '',
				medidorAgua: '',
				contratoAgua: '',
				AnombreDeAgua: '',
				comentarioAgua: '',
				medidasYcol: ''
			}

		};
	},

	methods: {
		entrar: function entrar() {
			var _this = this;

			// checa si tiene autorizacion
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Propiedades Editar')) {
					document.getElementById('propiedad-ver').hidden = true;
					alert('Seccion no autorizada');
					return;
				}
			}
			var pro = '';
			var propiedades2 = '';

			this.id = this.$route.params.id;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeUnaPropiedad.php?id=' + this.id).then(function (respue) {
				pro = respue.data;

				var x;
				for (x in pro) {
					propiedades2 = pro[x];
				}

				_this.propiedades.nombreCompleto = propiedades2.nombreCompleto;
				_this.propiedades.familia = propiedades2.familia;
				_this.propiedades.subfamilia = propiedades2.subfamilia;
				_this.propiedades.dueno = propiedades2.dueno;
				_this.propiedades.tipo = propiedades2.tipo;
				_this.propiedades.claveCatastral = propiedades2.claveCatastral;
				_this.propiedades.pais = propiedades2.pais;
				_this.propiedades.dirCalle = propiedades2.dirCalle;
				_this.propiedades.dirNumero = propiedades2.dirNumero;
				_this.propiedades.dirInterior = propiedades2.dirInterior;
				_this.propiedades.dirCiudad = propiedades2.dirCiudad;
				_this.propiedades.dirEstado = propiedades2.dirEstado;
				_this.propiedades.dirCodigo = propiedades2.dirCodigo;
				_this.propiedades.metrosCuadrados = propiedades2.metrosCuadrados;
				_this.propiedades.medidorElec = propiedades2.medidorElec;
				_this.propiedades.contratoElec = propiedades2.contratoElec;
				_this.propiedades.AnombreDeElec = propiedades2.AnombreDeElec;
				_this.propiedades.comentarioMedidorE = propiedades2.comentarioMedidorE;
				_this.propiedades.medidorAgua = propiedades2.medidorAgua;
				_this.propiedades.contratoAgua = propiedades2.contratoAgua;
				_this.propiedades.AnombreDeAgua = propiedades2.AnombreDeAgua;
				_this.propiedades.comentarioAgua = propiedades2.comentarioAgua;
				_this.propiedades.medidasYcol = propiedades2.medidasYcol;

				;
			});
		},
		guardarPropiedad: function guardarPropiedad() {
			var propiedades2 = this.propiedades;
			var router = this.$router;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/modificaPropiedad.php?id=' + this.id + '&nombreCompleto=' + propiedades2.nombreCompleto + '&familia=' + propiedades2.familia + '&subfamilia=' + propiedades2.subfamilia + '&dueno=' + propiedades2.dueno + '&tipo=' + propiedades2.tipo + '&claveCatastral=' + propiedades2.claveCatastral + '&pais=' + propiedades2.pais + '&dirCalle=' + propiedades2.dirCalle + '&dirNumero=' + propiedades2.dirNumero + '&dirInterior=' + propiedades2.dirInterior + '&dirCiudad=' + propiedades2.dirCiudad + '&dirEstado=' + propiedades2.dirEstado + '&dirCodigo=' + propiedades2.dirCodigo + '&mel=' + propiedades2.medidorElec + '&anomel=' + propiedades2.AnombreDeElec + '&comel=' + propiedades2.comentarioMedidorE + '&mea=' + propiedades2.medidorAgua + '&coagu=' + propiedades2.contratoAgua + '&anoma=' + propiedades2.AnombreDeAgua + '&comagu=' + propiedades2.comentarioAgua + '&conele=' + propiedades2.contratoElec + '&medYcol=' + propiedades2.medidasYcol + '&metrosCuadrados=' + propiedades2.metrosCuadrados + '&status=A&fechaModifica=01-01-18&quienModifico=GGUV').then(function (respue) {
				if (respue.statusText == 'OK') {
					router.push('/pro');
				}
			}).catch(function (error) {
				console.log(error);
			});
		}
	}
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'contrato-detalle',
	prueba: 'funciona',
	mounted: function mounted() {
		this.entrar();
	},

	props: ['vector'],
	data: function data() {
		return {
			id: null,
			contratoSolo: null
		};
	},

	methods: {
		entrar: function entrar() {
			var _this = this;

			// checa si tiene autorizacion
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Contratos Ver detalle')) {
					document.getElementById('captura').hidden = true;
					alert('Seccion no autorizada');
					return;
				}
			}
			this.id = this.$route.params.id;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeUnContrato.php?id=' + this.id).then(function (respue) {
				_this.contratoSolo = respue.data;
				console.log(respue.data);
			});
		},


		formateaFecha: function formateaFecha(fecha) {
			var d = new Date(fecha);
			if (Date.parse(d)) {
				// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				d.setHours(0);
				var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
				d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
				return d;
			} else {
				return "sin fecha";
			}
		},

		formateaNumero: function formateaNumero(valor1) {
			return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
		}
	}
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Propiedades_buscar_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Inquilinos_buscar_vue__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pre_o_Contratos_buscar_vue__ = __webpack_require__(131);
var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'agrega-contrato',

	components: { hijo1: __WEBPACK_IMPORTED_MODULE_1__Propiedades_buscar_vue__["a" /* default */], hijo2: __WEBPACK_IMPORTED_MODULE_2__Inquilinos_buscar_vue__["a" /* default */], hijo3: __WEBPACK_IMPORTED_MODULE_3__Pre_o_Contratos_buscar_vue__["a" /* default */] },
	props: ['vector', 'elusuario'],

	mounted: function mounted() {
		this.contratos.fechaSaldoInicial = this.hoy();
		this.visibleInicio();
	},
	data: function data() {
		var _contratos;

		return {
			contratos: (_contratos = {
				id: '',
				inquilinoId: '',
				propiedadId: '',
				inquilino: '',
				propiedad: '',
				nombreComercial: '',
				giro: '',
				familia: '',
				subfamilia: '',
				idInquilino: '',
				comDomInquilino: '',
				dueno: '',
				dirI: '',
				celI: '',
				email: '',
				wappI: '',
				importeMes: 0,
				fechaInicio: '',
				fechaFinal: '',
				fechaModificacion: '',
				quienModifico: 'GGUV',
				saldoInicial: 0,
				fechaSaldoInicial: ''
			}, _defineProperty(_contratos, 'email', ''), _defineProperty(_contratos, 'celular', ''), _defineProperty(_contratos, 'telefono', ''), _defineProperty(_contratos, 'facebook', ''), _defineProperty(_contratos, 'nombreAval', ''), _defineProperty(_contratos, 'direccionAval', ''), _defineProperty(_contratos, 'emailAval', ''), _defineProperty(_contratos, 'celularAval', ''), _defineProperty(_contratos, 'telefonoAval', ''), _defineProperty(_contratos, 'facebookAval', ''), _defineProperty(_contratos, 'whatsapp', ''), _defineProperty(_contratos, 'idInquilino', ''), _defineProperty(_contratos, 'comDomInquilino', ''), _defineProperty(_contratos, 'metrosCuadrados', ''), _defineProperty(_contratos, 'medidasYcol', ''), _defineProperty(_contratos, 'status', ''), _defineProperty(_contratos, 'depositarA', ''), _defineProperty(_contratos, 'claveCat', ''), _contratos),
			idPro: '',
			buscar: false,
			buscar1: false,
			buscarProf: false,
			poc: '',
			conpre: 'P',
			rentaDiaria: '',
			primerCargo: 0,
			primeraFecha: ''

		};
	},

	methods: (_methods = {
		aBuscar: function aBuscar() {
			this.buscar = true;
			document.getElementById('visible').style.height = "0";
			document.getElementById('visible').style.visibility = "hidden";
		},
		aBuscarI: function aBuscarI() {
			this.buscar1 = true;
			document.getElementById('visible').style.height = "0";
			document.getElementById('visible').style.visibility = "hidden";
		},
		aBuscarPre_o_Con: function aBuscarPre_o_Con(profOcontra) {
			this.poc = profOcontra;
			this.buscarProf = true;
			document.getElementById('visible').style.height = "0";
			document.getElementById('visible').style.visibility = "hidden";
		},
		hoy: function hoy() {
			// regresa la fecha actual en formato YYYY-mm-dd
			var fech = new Date();
			var dia = fech.getDate();
			if (dia < 10) dia = '0' + dia;
			var mes = fech.getMonth() + 1;
			if (mes < 10) mes = '0' + mes;
			var año = fech.getFullYear();
			return año + '-' + mes + '-' + dia;
		},

		recibeP: function recibeP(id, prop2, fam2, subfam2, dueno, area, medidas, claveCat) {

			this.contratos.propiedadId = id;
			this.contratos.propiedad = prop2;
			this.contratos.familia = fam2;
			this.contratos.subfamilia = subfam2;
			this.contratos.dueno = dueno;
			this.contratos.metrosCuadrados = area;
			this.contratos.medidasYcol = medidas;
			this.contratos.claveCat = claveCat;

			this.buscar = false;
			document.getElementById('visible').style.visibility = "visible";
		},
		recibeI: function recibeI(id, prop2, email, celular, telefono, whatsapp, facebook, dirI, celI, fbI, wappI) {

			this.contratos.inquilinoId = id;
			this.contratos.inquilino = prop2;
			this.contratos.email = email;
			this.contratos.celular = celular;
			this.contratos.telefono = telefono;
			this.contratos.facebook = facebook;
			this.contratos.dirI = dirI;
			this.contratos.celI = celI;
			this.contratos.fbI = fbI;
			this.contratos.wappI = wappI;

			this.buscar1 = false;
			document.getElementById('visible').style.visibility = "visible";
		},

		recibePro_o_Con: function recibePro_o_Con(inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta, cel, fb, dirI, wappI, iniciaC, finC, idI, comprob, nomAval, dirAval, celAval, mailAval, fbAval, nombreComercial, medidas, area, claveCat) {

			this.contratos.inquilinoId = inId;
			this.contratos.inquilino = inq;
			this.contratos.email = elmail;
			this.contratos.giro = gir;

			this.contratos.celular = cel;
			this.contratos.facebook = fb;
			this.contratos.dirI = dirI;
			this.contratos.nombreComercial = nombreComercial;

			this.contratos.wappI = wappI;
			this.contratos.fechaInicio = iniciaC;
			this.contratos.fechaFinal = finC;
			this.contratos.idInquilino = idI;
			this.contratos.comDomInquilino = comprob;
			this.contratos.nombreAval = nomAval;
			this.contratos.direccionAval = dirAval;
			this.contratos.celularAval = celAval;
			this.contratos.emailAval = mailAval;
			this.contratos.facebookAval = fbAval;

			this.contratos.propiedadId = prId;
			this.contratos.propiedad = pr;
			this.contratos.familia = fam;
			this.contratos.subfamilia = subfam;
			this.contratos.dueno = dueno;
			this.contratos.importeMes = renta;

			this.contratos.metrosCuadrados = area;
			this.contratos.medidasYcol = medidas;
			this.contratos.claveCat = claveCat;

			// actualiza en pantalla la renta diaria
			this.diaria(this.contratos.importeMes);

			this.buscarProf = false;
			document.getElementById('visible').style.visibility = "visible";
		},

		diaria: function diaria(rentaMes) {
			this.rentaDiaria = rentaMes / 30;
		},
		visibleInicio: function visibleInicio() {
			// hace invisible la fecha del saldo si es que es un pre-contrato
			var fi = document.getElementById('fechaSaldo');
			if (this.conpre == 'P') {
				fi.style.visibility = "hidden";
			} else fi.style.visibility = "visible";
		},


		formateaFecha: function formateaFecha(fecha) {
			var d = new Date(fecha);
			if (Date.parse(d)) {
				// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				d.setHours(0);
				var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
				d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
				return d;
			} else {
				return "sin fecha";
			}
		},

		guardarContrato: function guardarContrato() {
			var _this = this;

			// valida entradas
			var contratos1 = this.contratos;

			if (contratos1.inquilinoId == '' || contratos1.propiedadId == '') {
				alert('Falta Propiedad Num. o Inquilino Num.');
				return;
			};

			if (this.fechams(contratos1.fechaFinal) < this.fechams(contratos1.fechaInicio)) {
				alert('La fecha final del contrato debe ser mayor a la fecha de inicio');
				return;
			};

			if (contratos1.direccionAval.includes('#')) {
				alert("caracter no permitido en direccion aval: #");
				return;
			};

			if (confirm("\n\n           Es correcta la informacion ?\n\n" + "Inquilino: " + contratos1.inquilino + "\nPropiedad: " + contratos1.propiedad + "\nNombre Comercial: " + contratos1.nombreComercial + "\nGiro: " + contratos1.giro + "\nFamilia: " + contratos1.familia + "\nSub familia: " + contratos1.subfamilia + "\nFecha inicio: " + this.formateaFecha(contratos1.fechaInicio) + "\nFecha final: " + this.formateaFecha(contratos1.fechaFinal) + "\nRenta mensual: $ " + this.formateaNumero(contratos1.importeMes) + "\nSaldo inicial: " + contratos1.saldoInicial + "\nFecha saldo inicial: " + contratos1.fechaSaldoInicial + "\n\nComprobante dom: " + contratos1.comDomInquilino + "\nDireccion: " + contratos1.dirI + "\nCelular: " + contratos1.celular + "\nEmail: " + contratos1.email + "\nFacebook: " + contratos1.fbI + "\n\nAval: " + contratos1.nombreAval + "\nAval celular: " + contratos1.celularAval + "\nAval direccion:" + contratos1.direccionAval + "\nAval email: " + contratos1.emailAval + "\nAval facebook: " + contratos1.facebookAval + "\nDepositar A: " + contratos1.depositarA + "\nClave catastral: " + contratos1.claveCat + "\n\n           Es correcta la informacion ?")) {} else {
				return;
			}

			// checa is es pre-contrato o ya es contrato
			var esProforma = this.conpre;

			if (esProforma.toUpperCase() === "P") contratos1.status = "PRE-CONTRATO";
			if (esProforma.toUpperCase() === "C") contratos1.status = "RENTADO";
			if (!esProforma.toUpperCase() === "C" && !esProforma.toUpperCase() === "P") return;

			//this.ultimoContrato = 'uno';
			var cadena = 'https://www.directodo.com/Rentus/accesosdb/agregaContrato.php?inquilinoId=' + contratos1.inquilinoId + '&propiedadId=' + contratos1.propiedadId + '&inquilino=' + contratos1.inquilino + '&propiedad=' + contratos1.propiedad + '&nombreComercial=' + contratos1.nombreComercial + '&giro=' + contratos1.giro + '&fam=' + contratos1.familia + '&subfam=' + contratos1.subfamilia + '&importeMes=' + contratos1.importeMes + '&fechaModificacion=' + this.fechaActual() + '&fechaFin=' + contratos1.fechaFinal + '&fechaInicio=' + contratos1.fechaInicio + '&quienModifico=' + this.elusuario + '&saldoInicial=' + contratos1.saldoInicial + '&fechaSaldo=' + contratos1.fechaSaldoInicial + '&nombreAval=' + contratos1.nombreAval + '&direccionAval=' + contratos1.direccionAval + '&celularAval=' + contratos1.celularAval + '&emailAval=' + contratos1.emailAval + '&idI=' + contratos1.idInquilino + '&comDomI=' + contratos1.comDomInquilino + '&dirI=' + contratos1.dirI + '&celI=' + contratos1.celI + '&emailI=' + contratos1.email + '&fbI=' + contratos1.fbI + '&fbAval=' + contratos1.facebookAval + '&wapp=' + contratos1.whatsapp + '&status=' + contratos1.status + '&dueno=' + contratos1.dueno + '&area=' + contratos1.metrosCuadrados + '&depA=' + contratos1.depositarA + '&claveC=' + contratos1.claveCat + '&medidas=' + contratos1.medidasYcol;

			// le quita los gatitos # porque al dar de alta en mysql en php corta la cadena de parametros si va un gato #
			var cadena2 = cadena.replace(/#/g, '');

			// da de alta el contrato en archivo de contratos
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(cadena2).then(function (respue) {
				if (respue.statusText == 'OK') {
					// si es proforma no da de alta los movimientos
					if (esProforma.toUpperCase() === "P") return;

					// agrega los cargos de renta mensual de cada contrato.
					__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/agregaRentas.php?fa=' + _this.hoy()).then(function (respue) {
						if (respue.statusText == 'OK') {
							alert('Rentas agregadas');
						}
					}).catch(function (error) {
						alert('No se pudieron agregar las rentas en movimientos. Error: ' + error);
					});
				}
			}).catch(function (error) {
				alert('No se pudo dar de alta el contrato. Error: ' + error);
			});

			var router = this.$router;
			router.push('/con'); // se va al menu con

		},
		// termina guardaContrato

		fechaActual: function fechaActual() {
			var currentDate = new Date(); //hoy
			var day = currentDate.getDate();
			var month = currentDate.getMonth() + 1;
			var year = currentDate.getFullYear();
			var my_date = year + "-" + month + "-" + day;
			return my_date;
		},
		fechams: function fechams(fecha) {
			var laFecha = new Date(fecha);
			return laFecha.getTime(); // obtiene los milisegundos de la fecha
		}
	}, _defineProperty(_methods, 'formateaFecha', function formateaFecha(fecha) {
		var d = new Date(fecha);
		if (Date.parse(d)) {
			// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
			d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
			d.setHours(0);
			var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
			d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
			return d;
		} else {
			return "sin fecha";
		}
	}), _defineProperty(_methods, 'formateaNumero', function formateaNumero(valor1) {
		return Number(valor1).toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: true });
	}), _methods)

});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Propiedades-buscar',
  mounted: function mounted() {
    this.getPropiedades();
  },
  data: function data() {
    return {
      propiedadesTodas: null,
      abuscar: ''
    };
  },

  methods: {
    lanza: function lanza(idProp, nombre1, familia1, subfamilia1, dueno, area, medidas, claveC, status) {
      if (status == "RENTADO") {
        alert("Esta propiedad ya esta rentada");
        return;
      }

      this.$emit('eventoP', idProp, nombre1, familia1, subfamilia1, dueno, area, medidas, claveC);
    },
    getPropiedades: function getPropiedades() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leePropiedades.php').then(function (respuesta) {
        _this.propiedadesTodas = respuesta.data;
      });
    }
  },
  computed: {
    buscando: function buscando() {
      var _this2 = this;

      return this.propiedadesTodas.filter(function (item) {
        return item.nombreCompleto.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.familia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.subfamilia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.status.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.tipo.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.dirCalle.toUpperCase().includes(_this2.abuscar.toUpperCase());
      });
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Inquilinos-buscar',

  mounted: function mounted() {
    this.getInquilinos();
  },
  data: function data() {
    return {
      inquilinosTodos: null,
      abuscar: ''
    };
  },


  methods: {
    lanza: function lanza(idInq, nombre1, email, celular, telefonoFijo, facebook, dirI, celI, fbI, wappI) {
      this.$emit('eventoI', idInq, nombre1, email, celular, telefonoFijo, facebook, dirI, celI, fbI, wappI);
    },
    getInquilinos: function getInquilinos() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeInquilinos.php').then(function (respuesta) {
        _this.inquilinosTodos = respuesta.data;
      });
    }
  },

  computed: {
    buscando: function buscando() {
      var _this2 = this;

      return this.inquilinosTodos.filter(function (item) {
        return item.nombreCompleto.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.email.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.dirCiudad.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.id.includes(_this2.abuscar.toUpperCase());
      });
    }

  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PreContratos-buscar',
  mounted: function mounted() {
    this.getContratos();
  },

  props: ['esProformaOcontrato'],
  data: function data() {
    return {
      contratosTodos: null,
      abuscar: ''
    };
  },

  methods: {
    lanza: function lanza(inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta, celularInquilino, fbInquilino, dirInquilino, wappInquilino, fechaInicio, fechaTerminacion, idInquilino, comDomInquilino, nombreAval, direccionAval, celularAval, mailAval, fbAval, nomComercial, medidasYcol, area) {
      this.$emit('eventoProf', inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta, celularInquilino, fbInquilino, dirInquilino, wappInquilino, fechaInicio, fechaTerminacion, idInquilino, comDomInquilino, nombreAval, direccionAval, celularAval, mailAval, fbAval, nomComercial, medidasYcol, area);
    },
    getContratos: function getContratos() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php').then(function (respuesta) {
        _this.contratosTodos = respuesta.data;
      });
    },


    vencido: function vencido(fecha, status) {
      var fecha1 = new Date(fecha);
      fecha1.setHours(0);

      var hoy = new Date();
      hoy.setHours(0);

      var fechams = fecha1.getTime(); // en milisegundos        
      var hoyms = hoy.getTime(); // en milisegundos

      if (fechams < hoyms) {
        if (status == "FINALIZADO") {
          return ".";
        }
        return "Contrato Vencido";
      } else return ".";
    },

    formateaFecha: function formateaFecha(fecha) {
      var d = new Date(fecha);
      if (Date.parse(d)) {
        // pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
        d.setHours(0);
        var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
        d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
        return d;
      } else {
        return "sin fecha";
      }
    }

  },
  computed: {
    buscando: function buscando() {
      var _this2 = this;

      return this.contratosTodos.filter(function (item) {
        return item.giro.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.inquilino.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.propiedad.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.familia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.subfamilia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.nombreComercial.toUpperCase().includes(_this2.abuscar.toUpperCase());
      });
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contrato_estado_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08828d7f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contrato_estado_vue__ = __webpack_require__(138);
function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contrato_estado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08828d7f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contrato_estado_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'contrato-estado',
	prueba: 'funciona',
	mounted: function mounted() {
		this.hoy = new Date();
		this.entrar();
	},

	props: ['vector', 'cualContrato'],
	data: function data() {
		return {
			id: null,
			contratoSolo: null,
			movimientos: null,
			movimientos2: null,
			movimientos3: null,
			saldo: 0,
			saldoInicial: 0,
			saldoTotal: 0,
			numero: 0,
			hoy: '',
			numContrato: 0,
			mailInquilino1: '',
			fecha1: '',
			fecha2: '',
			leyenda: '',
			cualFotoId: ''
		};
	},

	methods: {
		enviar: function enviar() {

			var elMail = document.getElementById('pormail').value;
			var desde = document.getElementById('de').value;
			var hasta = document.getElementById('al').value;

			var liga = 'https://www.directodo.com/Rentus/accesosdb/enviarEdoMail.php?edcpm=' + this.mailInquilino1 + '&ecde=' + this.numContrato + '&fede=' + desde + '&feha=' + hasta + '&otroMail=' + elMail;

			/*axios.get(liga)
          .then((respue) => {
            if (respue.statusText == 'OK'){
                alert('\n\n     Estado de cuenta enviado a: \n\n     ' + elMail);
            }
           })
           .catch((error) =>{
               alert('No se pudo enviar el estado de cuenta  ' + error);
           }
           );
                 */
		},
		pasaContrato: function pasaContrato(contrat) {
			this.numContrato = contrat;
		},
		entrar: function entrar() {
			var _this = this;

			// checa si tiene autorizacion
			console.log("guv " + this.vector);
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Contratos Ver detalle')) {
					document.getElementById('captura').hidden = true;
					alert('Seccion no autorizada');
					return;
				}
			}

			// trae la informacion del contrato con el número del contrato
			//this.id=this.$route.params.id;
			this.id = this.cualContrato;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://directodo.com/Rentus/accesosdb/leeUnContrato.php?id=' + this.id).then(function (respue) {
				_this.contratoSolo = respue.data; // pasa de json a array

				// obtiene el saldo inicial
				_this.saldoInicial = _this.contratoSolo[0].saldoInicial;
				_this.mailInquilino1 = _this.contratoSolo[0].emailInquilino;
				document.getElementById('pormail').value = _this.mailInquilino1;
			});

			// trae los movimientos del contrato en orden de edo de cuenta
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://directodo.com/Rentus/accesosdb/leeEstadoDeCuenta.php?idc=' + this.id).then(function (respues) {
				_this.movimientos = respues.data;

				// copia movimientos a un nuevo array llamado movimientos2 y luego le agrega un campo adicional con el acumulado
				_this.movimientos2 = _this.movimientos.map(function (a) {
					return _extends({}, a);
				});

				// primero agrega el saldo inicial del control del sistema
				var acum = 0;
				var primerRegistro = true;
				_this.movimientos2.forEach(function (p) {
					if (primerRegistro) {
						acum += parseFloat(p.importe) + parseFloat(_this.saldoInicial);
						primerRegistro = false;
					} else {
						acum += parseFloat(p.importe);
					}

					p.acum = acum; // agrego esta propiedad para guardar el acumulado
				});

				// obtiene el saldo total
				_this.saldoTotal = _this.movimientos2[_this.movimientos2.length - 1].acum;

				// movimientos2 siempre tendrá TODOS los movimientos
				// y movimientos3 será reactivo para filtrar
				_this.movimientos3 = _this.movimientos2;

				// pone las fechas actuales en la form
				var hoy = new Date();
				var haceUnMes = hoy;

				document.getElementById('al').valueAsDate = hoy;

				// calcula la fecha de hace un año
				haceUnMes.setMonth(haceUnMes.getMonth() - 12);
				document.getElementById('de').valueAsDate = haceUnMes;

				_this.fecha1 = hoy;
				_this.fecha2 = haceUnMes;

				_this.rangos();
			});
		},


		verStatus: function verStatus(status) {
			if (status == "RENTADO") {
				return false;
			} else return true;
		},

		verFoto: function verFoto(cual) {
			this.cualFotoId = cual;
		},

		formateaFecha: function formateaFecha(fecha) {

			var d = new Date(fecha);
			if (Date.parse(d)) {
				// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				//d.setHours(0);
				var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
				d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
				return d;
			} else {
				return "sin fecha";
			}
		},

		formateaNumero: function formateaNumero(valor1) {
			return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
		},
		rangos: function rangos() {
			// pasa las fechas a milisegundos para compararlas
			var desde = document.getElementById('de').value;
			var hasta = document.getElementById('al').value;

			var de = new Date(desde);
			// lo ajusta a la zona horaria local:
			de.setMinutes(de.getMinutes() + de.getTimezoneOffset());
			de.setHours(0); // para que no tome la hora que trae

			var al = new Date(hasta);
			// lo ajusta a la zona horaria local:
			al.setMinutes(al.getMinutes() + al.getTimezoneOffset());
			al.setHours(0); // para que no tome la hora que trae

			var dems = de.getTime(); // en milisegundos				
			var alms = al.getTime(); // en milisegundos

			// solo pasa los registros que están dentro de las fechas
			this.movimientos3 = this.movimientos2.filter(function (movimiento) {
				// toma cada registro y su fecha la pasa a milisegundos
				var lafecha2 = new Date(movimiento.fecha);
				lafecha2.setMinutes(lafecha2.getMinutes() + lafecha2.getTimezoneOffset());
				lafecha2.setHours(0); // le pone las horas en ceros
				var lafechams = lafecha2.getTime();

				if (lafechams >= dems && lafechams <= alms) {
					var concep = document.getElementById("losConceptos").value;
					if (concep != "Todos") {
						if (movimiento.concepto.includes(concep)) {
							movimiento.acum = 0;
							return movimiento;
						}
					} else return movimiento;
				}
			});

			// actualiza letretos de fechas
			this.fecha1 = de;
			this.fecha2 = al;
		},

		imprimir: function imprimir(divName) {
			var printContents = document.getElementById(divName).innerHTML;
			var originalContents = document.body.innerHTML;
			document.body.innerHTML = printContents;
			window.print();
		}

	},
	computed: {
		movimientos4: function movimientos4() {
			return this.movimientos3;
		}
	}

});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Contratos-renovacion',
    mounted: function mounted() {
        this.getContratos();
    },

    props: ['vector'],
    data: function data() {
        return {
            contratosTodos: null,
            abuscar: '',
            total: '',
            mailRentus: 'rentusqro@gmail.com',
            datosActuales: 'https://www.directodo.com/Rentus/renovacion.php?w=4423382549&cont78357='
        };
    },

    methods: {
        getContratos: function getContratos() {
            var _this = this;

            // checa si tiene autorizacion
            if (!this.vector.includes('MASTERGGUV')) {
                if (!this.vector.includes('Contratos')) {
                    alert('Seccion no autorizada');
                    return;
                }
            }
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php').then(function (respuesta) {
                _this.contratosTodos = respuesta.data;
                // agregamos dos columnas vacias para usarlas despues
                _this.contratosTodos.newCol("rentaSugerida");
                _this.contratosTodos.newCol("rentaNueva");
                _this.contratosTodos.newCol("vencidoEsta");
                _this.contratosTodos.newCol("mensaje");
            });
        },


        vencido: function vencido(fecha, status) {

            var fecha1 = new Date(fecha);
            fecha1.setHours(0);

            var hoy = new Date();
            hoy.setHours(0);

            var fechams = fecha1.getTime(); // en milisegundos              
            var hoyms = hoy.getTime(); // en milisegundos

            var unMes = 30 * 24 * 60 * 60 * 1000; // en milisegundos

            if (fechams < hoyms + unMes + unMes) {
                // checa si se vencera en los proximos 2 meses
                var diferencia = hoyms - fechams;

                if (fechams < hoyms) {
                    return "Contrato VENCIDO el " + this.formateaFecha(fecha) + " \nHACE " + (diferencia / unMes).toFixed(0) + " MESES \nFavor de RENOVARLO";
                } else {
                    return "POR VENCER el " + this.formateaFecha(fecha) + " \nEN " + (-diferencia / unMes).toFixed(0) + " MESES ; ";
                }
            } else {
                return "";
            }
        },

        formateaFecha: function formateaFecha(fecha) {
            var d = new Date(fecha);
            if (Date.parse(d)) {
                // pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
                d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
                d.setHours(0);
                var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
                d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
                return d;
            } else {
                return "sin fecha";
            }
        },

        formateaNumero: function formateaNumero(valor1) {
            return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
        },
        formateaNumeroSimple: function formateaNumeroSimple(valor1) {
            return Number(valor1).toLocaleString('en-US', { maximumFractionDigits: 0 });
        },
        fechaActual: function fechaActual() {
            var currentDate = new Date(); //hoy
            var day = currentDate.getDate();
            var month = currentDate.getMonth() + 1;
            var year = currentDate.getFullYear();
            var my_date = year + "-" + month + "-" + day;
            return my_date;
        },
        enviaMail: function enviaMail(mail, rentaNueva, elMensaje, contrato) {
            // envia mail y agerga bandera de ya enviado al tal mail
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/enviaMailInquilino.php?mai11=' + mail + "&ren11=" + rentaNueva + "&men11=" + elMensaje + "&con11=" + contrato).then(function (respuesta) {
                alert("\n\n\nMail enviado a " + mail);
            });
        }
    },
    computed: {
        buscando: function buscando() {
            var _this2 = this;

            return this.contratosTodos.filter(function (item) {
                return item.propiedad.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.inquilino.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.familia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.giro.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.id.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.nombreComercial.toUpperCase().includes(_this2.abuscar.toUpperCase());
            });
        }
    }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'movimiento-detalle',

	mounted: function mounted() {
		var _this = this;

		this.id = this.$route.params.id;
		__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeUnMovimiento.php?id=' + this.id).then(function (respue) {
			_this.movimientoSolo = respue.data;
		});
	},
	data: function data() {
		return {
			id: null,
			movimientoSolo: null
		};
	}
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Contratos_buscar_vue__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'agrega-movimiento',
	components: {
		hijo1: __WEBPACK_IMPORTED_MODULE_1__Contratos_buscar_vue__["a" /* default */]
	},
	props: ['vector', 'elusuario'],
	mounted: function mounted() {
		this.validar();
	},
	data: function data() {
		return {
			movimientos: {
				tipo: '',
				contrato: '',
				inquilinoNombre: '',
				propiedadNombre: '',
				inquilinoNum: '',
				propiedadNum: '',
				concepto: '',
				importe: '',
				formaDePago: '',
				fechaCaptura: '',
				fecha: '',
				quienCapturo: '',
				quienPago: '',
				donde: '',
				refDeposito: '',
				referencia: '',
				comentario: '',
				recibo: '',
				recibio: '',
				familia: '',
				subFamilia: '',
				dueno: '',
				giro: ''
			},
			idCon: '',
			buscar: false,
			buscar1: false
		};
	},

	methods: {
		validar: function validar() {
			// checa si tiene autorizacion
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Movimientos Altas')) {
					document.getElementById('moviAdd').hidden = true;
					alert('Seccion no autorizada');
					return;
				}
			}
			this.movimientos.quienCapturo = this.elusuario;
		},
		aBuscar: function aBuscar() {
			this.buscar = true;
			document.getElementById('visible').style.height = "0";
			document.getElementById('visible').style.visibility = "hidden";
		},


		recibeC: function recibeC(id, inum, pnum, ino, pno, giro, fam, subf, dueno, mail, renta) {
			this.movimientos.contrato = id;
			this.movimientos.inquilinoNombre = ino;
			this.movimientos.propiedadNombre = pno;
			this.movimientos.inquilinoNum = inum;
			this.movimientos.propiedadNum = pnum;
			this.movimientos.familia = fam;
			this.movimientos.subFamilia = subf;
			this.movimientos.dueno = dueno;
			this.movimientos.giro = giro;

			this.buscar = false;

			document.getElementById('visible').style.visibility = "visible";
		},

		visibles: function visibles() {
			var tipo = document.getElementById('tipo');
			var valor = tipo.options[tipo.selectedIndex].value;

			if (valor == "COBRO" || valor == "AJUSTE NEGATIVO") {
				this.esCobro = true;
			} else {
				this.esCobro = false;
			}
		},

		formateaFecha: function formateaFecha(fecha) {
			var d = new Date(fecha);
			if (Date.parse(d)) {
				// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				d.setHours(0);
				var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
				d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
				return d;
			} else {
				return "sin fecha";
			}
		},

		guardarMovimiento: function guardarMovimiento() {
			var mov = this.movimientos;
			var router = this.$router;

			// valida algunas entradas
			if (this.movimientos.concepto == "Renta-Mes") {
				alert("El concepto no puede ser Renta-Mes.\nLos cargos de renta los hace \n el sistema automáticamente.\nCambie la redaccion por favor");
			}

			// si es deposito inicial no lo suma y guarda la info
			// como referencia.
			if (this.movimientos.concepto == 'DEPOSITO EN GARANTIA' || this.movimientos.tipo == 'DEPOSITO EN GARANTIA') {
				var ref = "Deposito en garantia $ " + parseFloat(this.movimientos.importe) + ' ' + this.movimientos.fecha;
				this.movimientos.referencia = ref + this.movimientos.referencia;
				this.movimientos.importe = 0;
			}

			// si es movimiento pago lo agrega como negativo
			if (this.movimientos.tipo == 'PAGO' || this.movimientos.tipo == 'AJUSTE NEGATIVO') {
				this.movimientos.importe = -parseFloat(this.movimientos.importe);
			}

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/agregaMovimiento.php?' + '&tipo=' + this.movimientos.tipo + '&contrato=' + this.movimientos.contrato + '&inquilinoNombre=' + this.movimientos.inquilinoNombre + '&propiedadNombre=' + this.movimientos.propiedadNombre + '&inquilinoNum=' + this.movimientos.inquilinoNum + '&propiedadNum=' + this.movimientos.propiedadNum + '&concepto=' + this.movimientos.concepto + '&importe=' + this.movimientos.importe + '&formaDePago=' + this.movimientos.formaDePago + '&fechaCaptura=' + this.movimientos.fechaCaptura + '&fecha=' + this.movimientos.fecha + '&quienCapturo=' + this.movimientos.quienCapturo + '&quienPago=' + this.movimientos.quienPago + '&donde=' + this.movimientos.donde + '&refDeposito=' + this.movimientos.refDeposito + '&referencia=' + this.movimientos.referencia + '&comentario=' + this.movimientos.comentario + '&recibo=' + this.movimientos.recibo + '&recibio=' + this.movimientos.recibio + '&familia=' + this.movimientos.familia + '&subFamilia=' + this.movimientos.subFamilia + '&dueno=' + this.movimientos.dueno + '&giro=' + this.movimientos.giro).then(function (respue) {
				if (respue.statusText == 'OK') {
					router.push('/mov');
				}
			}).catch(function (error) {
				console.log(error);
			});
		}
	}
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contratos_buscar_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2af2e8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contratos_buscar_vue__ = __webpack_require__(150);
function injectStyle (ssrContext) {
  __webpack_require__(148)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contratos_buscar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2af2e8a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contratos_buscar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Contratos-buscar',
  mounted: function mounted() {
    this.getContratos();
  },
  data: function data() {
    return {
      contratosTodos: null,
      abuscar: ''
    };
  },

  methods: {
    lanza: function lanza(idCon, inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta) {
      this.$emit('eventoC', idCon, inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta);
    },
    getContratos: function getContratos() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php').then(function (respuesta) {
        _this.contratosTodos = respuesta.data;
      });
    },
    esRentado: function esRentado(status) {
      if (status == 'RENTADO') {
        return true;
      } else return false;
    }
  },
  computed: {
    buscando: function buscando() {
      var _this2 = this;

      return this.contratosTodos.filter(function (item) {
        return item.giro.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.inquilino.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.id.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.propiedad.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.familia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.subfamilia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.nombreComercial.toUpperCase().includes(_this2.abuscar.toUpperCase());
      });
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Propiedades',
  mounted: function mounted() {
    this.getPropiedades();
  },
  data: function data() {
    return {
      propiedadesTodas: null
    };
  },

  methods: {
    getPropiedades: function getPropiedades() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leePropiedades.php').then(function (respuesta) {
        _this.propiedadesTodas = respuesta.data;
      });
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
		name: 'Contratos',

		mounted: function mounted() {
				this.getContratos();
		},
		data: function data() {
				return {
						contratosTodos: [],
						abuscar: ''
				};
		},


		methods: {
				getContratos: function getContratos() {
						var _this = this;

						__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php').then(function (respuesta) {
								_this.contratosTodos = respuesta.data;
						});
				},

				lasuma: function lasuma(arreglo) {
						var sum2 = arreglo.reduce(function (prevVal, elem) {
								return prevVal + parseFloat(elem.importeMes);
						}, 0);
						return sum2;
				},

				seleccion: function seleccion(id) {
						return 0;
				},
				imprimir: function imprimir(divName) {
						var printContents = document.getElementById(divName).innerHTML;
						var originalContents = document.body.innerHTML;
						document.body.innerHTML = printContents;
						window.print();
						document.body.innerHTML = originalContents;
				},
				ordenar: function ordenar(n, donde) {
						var table,
						    rows,
						    switching,
						    i,
						    x,
						    y,
						    shouldSwitch,
						    dir,
						    switchcount = 0;
						table = document.getElementById(donde);
						switching = true;
						dir = "asc";

						while (switching) {
								switching = false;
								rows = table.getElementsByTagName("TR");
								var esNumero = true;
								var esFecha = false;
								var esFechaM = false;
								var esFechaD = false;
								var date1 = new Date();
								var miliseg1 = 0;
								var date2 = new Date();
								var miliseg2 = 0;

								for (i = 0; i < rows.length - 1; i++) {
										shouldSwitch = false;
										x = rows[i].getElementsByTagName("TD")[n];
										y = rows[i + 1].getElementsByTagName("TD")[n];

										'DETERMINA SI ES NUMERO O LETRAS';
										var elemento1 = x.innerHTML.toLowerCase();
										var elemento2 = y.innerHTML.toLowerCase();

										'QUITAS COMAS Y PUNTOS PARA COMPARAR SOLO NUMEROS EN SU CASO';
										var sinComas1 = elemento1.replace(',', '');
										var sinComas2 = elemento2.replace(',', '');

										esNumero = true;
										if (isNaN(sinComas1) || isNaN(sinComas2)) {
												esNumero = false;
										}

										if (esNumero) {
												if (dir == "asc") {
														if (parseFloat(sinComas1) > parseFloat(sinComas2)) {
																shouldSwitch = true;
																break;
														}
												} else if (dir == "desc") {
														if (parseFloat(sinComas1) < parseFloat(sinComas2)) {
																shouldSwitch = true;
																break;
														}
												}
										} else {
												'NO ES NUMERO';

												'ES FECHA ?';
												esFecha = false;
												if (true) {
														esFecha = true;
												}

												if (esFecha) {
														'ES FECHA';
														console.log('es fecha' + elemento1);

														date1 = new Date(elemento1);
														miliseg1 = date1.getTime();
														date2 = new Date(elemento2);
														miliseg2 = date2.getTime();

														if (dir == "asc") {
																if (miliseg1 > miliseg2) {
																		shouldSwitch = true;
																		break;
																}
														} else if (dir == "desc") {
																if (miliseg1 < miliseg2) {
																		shouldSwitch = true;
																		break;
																}
														}
												} else {
														'NO ES FECHA';
														console.log('no es fecha');
														if (dir == "asc") {
																if (elemento1 > elemento2) {
																		shouldSwitch = true;
																		break;
																}
														} else if (dir == "desc") {
																if (elemento1 < elemento2) {
																		shouldSwitch = true;
																		break;
																}
														}
												}
										}
								}

								if (shouldSwitch) {
										rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
										switching = true;
										switchcount++;
								} else {
										if (switchcount == 0 && dir == "asc") {
												dir = "desc";
												switching = true;
										}
								}
						}
				}
		},

		filters: {
				Upper: function Upper(value) {
						return value.toUpperCase();
				},
				FormateaNumero: function FormateaNumero(valor1) {
						return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
				},
				FormateaFecha: function FormateaFecha(fecha) {
						var d = new Date(fecha);
						if (Date.parse(d)) {
								d = new Intl.DateTimeFormat('en-US').format(d);
								return d;
						} else {
								return "sin fecha";
						}
				}
		},

		computed: {
				buscando: function buscando() {
						var _this2 = this;

						this.tot = 0;
						return this.contratosTodos.filter(function (item) {
								return item.propiedad.includes(_this2.abuscar) || item.inquilino.includes(_this2.abuscar);
						});
				},
				cuentalos: function cuentalos() {
						return this.buscando.length;
				}
		}

});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Contratos_buscar_vue__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Pago',
	components: {
		hijo1: __WEBPACK_IMPORTED_MODULE_1__Contratos_buscar_vue__["a" /* default */]
	},
	mounted: function mounted() {
		this.autorizar();
	},

	props: ['vector', 'elusuario'],
	data: function data() {
		return {
			movimientos: {
				tipo: '',
				contrato: '',
				inquilinoNombre: '',
				propiedadNombre: '',
				inquilinoNum: '',
				propiedadNum: '',
				concepto: 'A CUENTA RENTA',
				importe: '',
				formaDePago: 'TRANSFERENCIA',
				fechaCaptura: '',
				fecha: '',
				quienCapturo: '',
				quienPago: '',
				donde: '',
				refDeposito: '',
				referencia: '',
				comentario: '',
				recibo: '',
				recibio: '',
				giro: '',
				familia: '',
				subfamilia: '',
				dueno: ''

			},
			envioMail: '',
			renta: 0,
			idCon: '',
			buscar: false,
			buscar1: false,
			elArchivo: ''
		};
	},

	methods: {
		formateaNumero: function formateaNumero(valor1) {
			return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
		},
		archivoAsubir: function archivoAsubir() {
			// obtiene el archivo seleccionado en el input llamado cualFile en ref parametro
			this.elArchivo = this.$refs.cualFile.files[0];

			// obtiene solo el nombre del archivo
			//console.log(this.elArchivo.name);
		},
		enviaElArchivo: function enviaElArchivo() {

			var formData = new FormData();

			// Se debe llamar igual el id del input y asi tambien 
			// al recibirlo en subeArchivos.php el primero en el arreglo
			// de $_FILES se debe llamar tambien igual y en el
			// move_uploaded_file del .php, en este 
			// caso miArchivoRentus en los 4 lugares

			formData.append('miArchivoRentus', this.elArchivo);

			//Make the request to the POST /single-file URL				        
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/subeArchivos.php', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(function () {
				console.log('SUBIDO!!');
			}).catch(function () {
				console.log('FALLO!!');
			});
		},
		autorizar: function autorizar() {
			// checa si tiene autorizacion
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Cobros Altas')) {
					alert('Seccion no autorizada');
					document.getElementById('altaCobro').hidden = true;
					return;
				}
			}

			this.movimientos.fecha = this.hoy();

			// llena campos si vienen parametros en la llamada de contratos
			this.movimientos.contrato = this.$route.params.id;

			this.movimientos.inquilinoNum = this.$route.params.inum;
			this.movimientos.propiedadNum = this.$route.params.pnum;
			this.movimientos.inquilinoNombre = this.$route.params.ino;
			this.movimientos.propiedadNombre = this.$route.params.pno;
			this.movimientos.giro = this.$route.params.gir;
			this.movimientos.familia = this.$route.params.fam;
			this.movimientos.subfamilia = this.$route.params.subf;
			this.movimientos.dueno = this.$route.params.dueno;

			this.envioMail = this.$route.params.mail;
			this.renta = this.$route.params.rentaMes;
			this.movimientos.importe = this.$route.params.rentaMes;

			// el usuario lo toma de los props que se mandan desde otros con v-bind
			this.movimientos.quienCapturo = this.elusuario;
		},
		hoy: function hoy() {
			// regresa la fecha actual
			var fech = new Date();
			var dia = fech.getDate();
			if (dia < 10) dia = '0' + dia;
			var mes = fech.getMonth() + 1;
			if (mes < 10) mes = '0' + mes;
			var año = fech.getFullYear();
			return año + '-' + mes + '-' + dia;
		},
		aBuscar: function aBuscar() {
			this.buscar = true;
			document.getElementById('visible').style.height = "0";
			document.getElementById('visible').style.visibility = "hidden";
		},

		recibeC: function recibeC(id, inum, pnum, ino, pno, gir, fam, subf, dueno, elmail, renta) {
			this.movimientos.contrato = id;
			this.movimientos.inquilinoNombre = ino;
			this.movimientos.propiedadNombre = pno;
			this.movimientos.inquilinoNum = inum;
			this.movimientos.propiedadNum = pnum;
			this.movimientos.giro = gir;
			this.movimientos.familia = fam;
			this.movimientos.subfamilia = subf;
			this.movimientos.dueno = dueno;
			this.movimientos.importe = renta;

			this.envioMail = elmail;
			this.renta = renta;

			this.buscar = false;
			document.getElementById('visible').style.visibility = "visible";
		},

		folio: function folio() {
			var d = new Date();
			d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
			var a = d.getYear();
			var m = d.getMonth();
			var dia = d.getDate();
			var h = d.getHours();
			var m = d.getMinutes();
			var s = d.getSeconds();
			return a + m + dia + h + m + s;
		},


		formateaFecha: function formateaFecha(fecha) {
			var d = new Date(fecha);
			if (Date.parse(d)) {
				// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				d.setHours(0);
				var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
				d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
				return d;
			} else {
				return "sin fecha";
			}
		},

		fechaActual: function fechaActual() {
			var currentDate = new Date(); //hoy
			var day = currentDate.getDate();
			var month = currentDate.getMonth() + 1;
			var year = currentDate.getFullYear();
			var my_date = year + "-" + month + "-" + day;
			return my_date;
		},
		guardarMovimiento: function guardarMovimiento() {
			// valida
			if (this.movimientos.contrato == '') {
				alert('falta el contrato');
				return;
			}

			if (confirm("\n\n           Es correcta la informacion ?\n\n" + "Inquilino: " + this.movimientos.inquilinoNombre + "\nPropiedad: " + this.movimientos.propiedadNombre + "\nGiro: " + this.movimientos.giro + "\nFamilia: " + this.movimientos.familia + "\nSub familia: " + this.movimientos.subfamilia + "\nDueno: " + this.movimientos.dueno + "\nConcepto: " + this.movimientos.concepto + "\nImporte: $ " + this.formateaNumero(this.movimientos.importe) + "\nForma de pago: " + this.movimientos.formaDePago + "\nReferencia: " + this.movimientos.referencia + "\nComentario: " + this.movimientos.comentario + "\nFecha de pago: " + this.formateaFecha(this.movimientos.fecha) + "\nQuien capturó: " + this.movimientos.quienCapturo + "\nQuien pagó: " + this.movimientos.quienPago + "\nDonde pagó: " + this.movimientos.donde + "\nQuien recibió: " + this.movimientos.recibio + "\nEnviar al mail: " + this.envioMail + "\n\n           Es correcta la informacion ?")) {} else {
				return;
			}

			var mov = this.movimientos;
			var router = this.$router;

			// genera folio del recibo					
			this.movimientos.recibo = this.movimientos.inquilinoNum + this.movimientos.propiedadNum + this.movimientos.contrato + this.folio();

			this.movimientos.fechaCaptura = this.fechaActual();

			// lo guardamos como negativo porque es un pago del inquilino
			this.movimientos.importe = -parseFloat(this.movimientos.importe);

			var nombreArchivo = '';
			if (this.elArchivo.name) {
				nombreArchivo = this.elArchivo.name;
			} else nombreArchivo = "";

			// se va a insertar el movimiento y a enviar los mails del recibo en imagen
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/agregaMovimiento.php?tipo=PAGO&contrato=' + this.movimientos.contrato + '&inquilinoNombre=' + this.movimientos.inquilinoNombre + '&propiedadNombre=' + this.movimientos.propiedadNombre + '&inquilinoNum=' + this.movimientos.inquilinoNum + '&propiedadNum=' + this.movimientos.propiedadNum + '&concepto=' + this.movimientos.concepto + '&importe=' + this.movimientos.importe + '&formaDePago=' + this.movimientos.formaDePago + '&fechaCaptura=' + this.movimientos.fechaCaptura + '&fecha=' + this.movimientos.fecha + '&quienCapturo=' + this.movimientos.quienCapturo + '&quienPago=' + this.movimientos.quienPago + '&donde=' + this.movimientos.donde + '&referencia=' + this.movimientos.referencia + '&comentario=' + this.movimientos.comentario + '&recibo=' + this.movimientos.recibo + '&familia=' + this.movimientos.familia + '&subFamilia=' + this.movimientos.subfamilia + '&dueno=' + this.movimientos.dueno + '&giro=' + this.movimientos.giro + '&recibio=' + this.movimientos.recibio + '&envioMail=' + this.envioMail + '&direccionFoto=' + nombreArchivo).then(function (respue) {
				if (respue.statusText == 'OK') {
					alert("Pago agregado");
					router.push('/con');
				}
			}).catch(function (error) {
				alert("No se agregó el pago por problema en la base de datos");
				console.log(error);
			});
		}
	}
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// ESTE CODIGO ES UN REPORTEADOR DE ARCHIVOS DE CUALQUIER BASE DE DATOS.
// SOLO HAY QUE CAMBIARLE LA URL DEL LUGAR DONDE ESTÁ EL PROGRAMA QUE LEE
// LA TABLA DE LA BASE DE DATOS (O SEA EL BACKEND). Y CAMBIANDO LOS NOMBRES DE LAS TABLAS EN EL PRIMER DROPDOWN (SELECT).
// ESTO SE HACE EN getRegistros() y llenaNombreArchivos() 



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Reporteador2',
	mounted: function mounted() {
		this.getRegistros();
		this.llenaNombreArchivos();
	},

	props: ['vector', 'elusuario'],
	data: function data() {
		return {
			registrosTodos: [],
			probando1: 'GMO',
			aparece: true,
			registrosTodos2: null,
			contando: true,
			delRenglon: 0,
			alRenglon: 0,
			columna: '',
			direccion: '',
			tipo: '',
			orden: [], // contiene los nombres de las columnas que se ordenaran
			camposIncluye: [],
			titulosDeColumnas: [],
			camposFechados: [],
			camposNumericos: [],
			camposTotales: [], // contiene los nombres de las columnas a totalizar
			columnasDeTotales: [],
			camposFiltrar: [],
			totales: [],
			llav: 'inquilino',
			seleccion: '',
			seleccion2: '',
			seleccion3: '',
			col1: '',
			col2: '',
			generando: false,
			elemento: '',
			anterior: '',
			esSubtotal: true,
			cualArchivo2: '',
			filtroTexto: '',
			filtroTexto2: '',
			filtroActual: '',
			banerFiltros: '',
			leerDirReporte: false,
			nombreDelReporte: ""
		};
	},


	methods: {
		getRegistros: function getRegistros() {
			var _this = this;

			// Valida usuario si tiene autorizacion para esta seccion o usa el paswword maestro  
			var archiSel = document.getElementById('elArchivo').value;
			if (!this.vector.includes('MASTERGGUV')) {
				if (this.vector.includes('Reportes')) {
					if (!this.vector.includes('Reportes de ' + archiSel)) {
						alert('Seccion no autorizada');
						return;
					}
				} else return;
			}

			this.registrosTodos = [];
			var renglon = [];
			var cualArchivo = document.getElementById('elArchivo').value;

			if (cualArchivo) {

				var cadena = 'https://www.directodo.com/Rentus/accesosdb/lee' + cualArchivo + '.php';

				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(cadena).then(function (respuesta) {

					_this.registrosTodos = respuesta.data; // recibe un objeto

					// llena el selector de los campos
					_this.llenaCampos();

					// llama a los totales antes de llamar a ordenar porque puede ser que no 
					// haya registros a ordenar y suspenda la continuacion de la ejecucion
					// tambien llama a mi SORTUSTotals para totalizar las columnas seleccionadas a totalizar
					if (!_this.camposTotales == "" && !_this.registrosTodos == "") {
						_this.totales = _this.$sortusTotals(_this.registrosTodos, _this.camposTotales);
					}

					// ordena el resultado con MI SORTUS pasando el objeto a ordenar y 
					// el array que contiene los nombres de los campos a ordenar
					if (!_this.registrosTodos == "" && !_this.orden == "") {
						_this.registrosTodos = _this.$sortus(_this.registrosTodos, _this.orden);
					}
				});
			}
		},


		limpia: function limpia() {
			this.cualArchivo2 = document.getElementById('elArchivo').value;
			document.getElementById('elArchivo').hidden = true;
		},

		iniciaDrop: function iniciaDrop() {
			// al cambiar el archivo seleccionado inicializa los selects
			var selectBox = document.getElementById("loscampos");
			selectBox.innerHTML = "";
			this.seleccion = "";
			this.seleccion2 = "";
			this.seleccion3 = "";
			var selectBox = document.getElementById("losorden");
			selectBox.innerHTML = "";
			var selectBox = document.getElementById("losfiltros");
			selectBox.innerHTML = "";

			document.getElementById("elReporte").innerHTML = "Campos incluidos:";
			document.getElementById("elOrden").innerHTML = "Orden:";
			document.getElementById("elFiltro").innerHTML = "Filtros:";
		},


		filtrar: function filtrar() {
			this.registrosTodos = this.filtrando;
			// tambien llama a recalcular totales
			this.totales = this.$sortusTotals(this.registrosTodos, this.camposTotales);

			this.cualFiltroTexto2 = "";
			this.cualFiltroTexto = "";
		},

		ponCampo: function ponCampo(campo) {
			// agrega campo al reporte. Lo corre despues 
			// de ponCampo
			// AGREGA EL BOTON CAMPO						
			document.getElementById("elReporte").innerHTML += '&nbsp&nbsp&nbsp<button class="campos" id="' + campo + '">' + campo + ' x </button>';

			// AGREGA EL BOTON FECHA
			var nombre = campo + 'F';
			document.getElementById("elReporte").innerHTML += '<button class="fecha" style="background-color:white;" id="' + nombre + '"> F </button>';

			// AGREGA EL BOTON NUMERICO
			var nombre = campo + 'N';
			document.getElementById("elReporte").innerHTML += '<button class="numero" style="background-color:white;" id="' + nombre + '"> # </button>';

			// AGREGA EL BOTON TOTAL
			var nombre = campo + 'T';
			document.getElementById("elReporte").innerHTML += '<button class="total" style="background-color:white;" id="' + nombre + '"> T </button>';
		},

		ponCampoOrden: function ponCampoOrden(campo) {
			// agrega campo a ordenar en el reporte
			var nombre = campo + '.';
			document.getElementById("elOrden").innerHTML += '&nbsp&nbsp&nbsp<button class="ordenar" id="' + nombre + '">' + nombre + ' x </button>';
		},

		ponCampoFiltro: function ponCampoFiltro(campo) {
			// agrega campo a filtrar en el reporte
			var nombre = campo + '*';
			document.getElementById("elFiltro").innerHTML += '&nbsp&nbsp&nbsp<button class="filtrar" id="' + nombre + '">' + nombre + ' x </button>';
		},

		generaCampo: function generaCampo() {
			// genera el reporte la parte a incluir
			var item = '';
			var elms = document.getElementById('elReporte').getElementsByClassName("campos");

			// les agrega funciones a los botones.
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {
					// al click borra este botón y el de fecha y el de Total
					this.remove();
					document.getElementById(this.id + 'F').remove();
					document.getElementById(this.id + 'N').remove();
					document.getElementById(this.id + 'T').remove();
				};
			}
			this.llenaCamposOrdenar(); // llena el select aordenar
			this.llenaCamposFiltrar(); // llena el select afiltrar
		},

		generaCampoOrden: function generaCampoOrden() {
			// agrega la parte del reporte los campos a ordenar
			var item = '';
			var elm = {};
			var elms = document.getElementById('elOrden').getElementsByClassName("ordenar");

			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {
					this.remove(); // borra el componente
				};
			}
		},

		generaCampoFiltro: function generaCampoFiltro() {
			// agrega la parte del reporte los campos a filtrar
			var item = '';
			var elm = {};
			var elms = document.getElementById('elFiltro').getElementsByClassName("filtrar");

			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {
					this.remove(); // borra el componente
				};
			}
		},

		generaCampoFechas: function generaCampoFechas() {
			var item = '';
			var elms = document.getElementById('elReporte').getElementsByClassName("fecha");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {
					if (this.style.backgroundColor == 'fuchsia') {
						this.style.backgroundColor = 'white';
					} else {
						this.style.backgroundColor = 'fuchsia';
					}
				};
			}
		},

		generaCampoNumeros: function generaCampoNumeros() {
			var item = '';
			var elms = document.getElementById('elReporte').getElementsByClassName("numero");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {
					if (this.style.backgroundColor == 'yellow') {
						this.style.backgroundColor = 'white';
					} else {
						this.style.backgroundColor = 'yellow';
					}
				};
			}
		},

		generaCampoTotales: function generaCampoTotales() {
			var item = '';
			var elms = document.getElementById('elReporte').getElementsByClassName("total");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {

					switch (this.style.backgroundColor) {
						case "white":
							this.style.backgroundColor = 'lime';
							this.innerHTML = "Contar";
							break;
						case "lime":
							this.style.backgroundColor = 'aqua';
							this.innerHTML = "Sumar";
							break;
						case "aqua":
							this.style.backgroundColor = 'white';
							this.innerHTML = "T";
							break;
					}
				};
			}
		},

		generaReporte: function generaReporte() {

			// obtiene el nombre del archivo en cuestion para sugerirlo como nombre del reporte
			if (this.nombreDelReporte == "") {
				var cualArchivo = document.getElementById('elArchivo').value;
				this.nombreDelReporte = cualArchivo;
			}

			this.nombreDelReporte = prompt("Encabezado del reporte ?", cualArchivo);

			this.generando = true; // resetea reporte y bandera que es nuevo reporte
			this.banerFiltros = ''; // limpia baner de los filtros.

			var item,
			    itemColor = '';
			var elm = {};
			this.orden = [];
			this.camposIncluye = [];
			this.camposFechados = [];
			this.titulosDeColumnas = [];
			this.camposNumericos = [];
			this.camposTotales = [];
			this.camposFiltrar = [];
			this.registrosTodos = [];

			// crea el array de los campos a incluir
			elms = document.getElementById('elReporte').getElementsByClassName("campos");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				//en 'camposIncluye' deja los campos a incluir en el reporte
				this.camposIncluye.push(item);
			};

			// crea el array de los campos a ordenar. Les quita el punto decimal
			// que le agregamos al nombre al final para diferenciarlos de los demas
			var elms = document.getElementById('elOrden').getElementsByClassName("ordenar");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				this.orden.push(item.replace('.', '')); // en el campo 'orden' deja los campos a ordenar
			};

			// crea el array de los campos a formatear como fecha. los de fondo rojo
			elms = document.getElementById('elReporte').getElementsByClassName("fecha");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				itemColor = elms[i].style.backgroundColor;
				//en 'camposFechados' deja los campos a formatear como fecha
				// y le quita la F
				item = item.replace('F', '');
				if (itemColor == 'fuchsia') {
					this.camposFechados.push(item);
					// MODIFICA EL ARRAY DE ORDEN PARA QUE SE VAYA AL SORTUS CON LOS
					// PARÁMETROS ADECUADOS
					for (var elemento in this.orden) {
						if (this.orden[elemento] == item) {
							this.orden[elemento] = item + '+D';
						}
					}
				}
			};

			// crea el array de los campos a formatear como NUMERO. los de fondo AMARILLO
			elms = document.getElementById('elReporte').getElementsByClassName("numero");

			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				itemColor = elms[i].style.backgroundColor;

				//en 'camposFechados' deja los campos a formatear como fecha
				// y le quita la N
				item = item.replace('N', '');
				if (itemColor == 'yellow') {
					this.camposNumericos.push(item);

					// MODIFICA EL ARRAY DE ORDEN PARA QUE SE VAYA AL SORTUS CON LOS
					// PARÁMETROS ADECUADOS
					for (var elemento in this.orden) {
						if (this.orden[elemento] == item) {
							this.orden[elemento] = item + '+N';
						}
					}
				}
			};

			// crea el array de los campos a totalizar. Los de fondo lime
			elms = document.getElementById('elReporte').getElementsByClassName("total");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				itemColor = elms[i].style.backgroundColor;

				//en 'camposTotales' deja los nombres de las columnas a totalizar 
				// y le quita la T
				item = item.replace('T', '');

				if (itemColor == 'lime' || itemColor == "aqua") {
					if (itemColor == "aqua") item = item + "*";
					this.camposTotales.push(item);
				}
			};

			// llena el array de los campos a filtrar
			elms = document.getElementById('elFiltro').getElementsByClassName("filtrar");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				//en 'camposIncluye' deja los campos a incluir en el reporte
				this.camposFiltrar.push(item);
			};

			// llena el select de filtros
			var selector = document.getElementById('cualFiltroUsar');
			selector.length = 0; // lo limpia primero
			for (var i in this.camposFiltrar) {
				var campo = this.camposFiltrar[i].replace('*', '');
				selector.add(new Option(campo));
			}

			this.getRegistros();
		},

		imprimir: function imprimir(divName) {
			var printContents = document.getElementById(divName).innerHTML;
			var originalContents = document.body.innerHTML;
			document.body.innerHTML = printContents;
			window.print();
		},

		llenaNombreArchivos: function llenaNombreArchivos() {
			// llena los select
			// son los nombres de los archivos del backend
			var loscampos2 = ['Archivo', 'Contratos', 'Inquilinos', 'Movimientos', 'Propiedades'];
			var selector1 = document.getElementById('elArchivo');

			var c1;
			for (c1 in loscampos2) {
				selector1.add(new Option(loscampos2[c1]));
			};
		},

		llenaCampos: function llenaCampos() {
			var loscampos1 = [];
			// toma los titulos de los campos
			for (var key in this.registrosTodos[0]) {
				// lee campo por campo del registro primero y llena un array con los nombres de las columnas
				loscampos1.push(key);
			}

			var selector2 = document.getElementById('loscampos');
			selector2.length = 0; // lo limpia primero

			var c;
			for (c in loscampos1) {
				// lo llena con los nombres de los campos
				selector2.add(new Option(loscampos1[c]));
			};
		},

		llenaCamposOrdenar: function llenaCamposOrdenar() {
			// llena el select losorden

			var selectBox = document.getElementById("losorden");
			selectBox.innerHTML = ""; // lo limpia

			// extrae los elementos del select campos
			var elms = document.getElementById('elReporte').getElementsByClassName("campos");
			var item;
			var loscampos3;
			this.titulosDeColumnas = [];

			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				this.titulosDeColumnas.push(item.replace('.', '')); // en el campo 'consec' deja los campos a ordenar
			};

			loscampos3 = this.camposIncluye;
			var selector3 = document.getElementById('losorden');
			selector3.length = 0; // lo limpia

			for (var c in this.titulosDeColumnas) {
				selector3.add(new Option(this.titulosDeColumnas[c]));
			};
		},

		llenaCamposFiltrar: function llenaCamposFiltrar() {
			// llena el select losorden
			// primero lo limpia
			var selectBox = document.getElementById("losfiltros");
			selectBox.innerHTML = "";
			// extrae los elementos del select LOSCAMPOS
			var elms = document.getElementById('elReporte').getElementsByClassName("campos");
			var item;
			var loscampos3;
			this.titulosDeColumnas = [];
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				this.titulosDeColumnas.push(item.replace('.,', '')); // en el campo 'consec' deja los campos a ordenar
			};
			loscampos3 = this.camposIncluye;
			var selector3 = document.getElementById('losfiltros');
			selector3.length = 0; // lo limpia

			if (this.titulosDeColumnas.length > 0) {
				//vailida si existe
				for (var c in this.titulosDeColumnas) {
					selector3.add(new Option(this.titulosDeColumnas[c]));
				};
			}
		},

		colum: function colum(columna, registro) {
			// CREA LAS COLUMNAS EN EL REPORTE
			// recibe todo el registro 
			// checa si es la primera vez (generando = true) nuevo reporte y cambia los 
			// campos como se desplegarán. Solo lo hace una vez cada nuevo registro

			if (this.generando == true) {
				// si es nuevo reporte toma encabezados
				this.titulosDeColumnas = [];
				for (var cada in this.camposIncluye) {
					//lee campos que se incluirán
					for (var titulo in registro) {
						// lee campo por campo del registro
						if (this.camposIncluye[cada] == titulo) {
							this.titulosDeColumnas.push(titulo); //guarda la posición del
							break; //campo que si se incluirá
						}
					}
				}

				this.generando = false; // apaga la bandera de que es nuevo
			}

			// despliega los campos en el orden que se pidió el reporte.
			// checa si este campo debe llevar formato de fecha o numero y lo formatea
			var elemento = this.titulosDeColumnas[parseInt(columna)];

			var esfecha = this.camposFechados.includes(elemento);
			if (esfecha) {
				// es con formato de fecha
				return this.formateaFecha2(registro[elemento]);
			} else {
				var esnumero = this.camposNumericos.includes(elemento);
				if (esnumero) {
					// es con formato de numero
					return this.FormateaNumero2(registro[elemento]);
				} else {
					// no es ni fecha ni numero
					return registro[this.titulosDeColumnas[parseInt(columna)]];
				}
			}
		},

		titulo: function titulo(tit) {
			//con el numero de columna regresa el titulo de la columna
			return this.titulosDeColumnas[tit];
		},

		formateaFecha2: function formateaFecha2(fecha) {

			var d = new Date(fecha);
			if (Date.parse(d)) {
				// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				//d.setHours(0);
				var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
				d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
				return d;
			} else {
				return "sin fecha";
			}
		},

		guardarReporte: function guardarReporte() {
			var _this2 = this;

			var nombreReporte = prompt("Nombre del reporte ?", "");

			if (nombreReporte == "") return;

			var archiSel = document.getElementById('elArchivo').value;

			// guarda los array en formato json para despues poderlos desserializar de json a array
			var cadena = 'https://www.directodo.com/Rentus/accesosdb/guardaReporte.php?cliente=RGGUV1' + '&nombreReporte=' + nombreReporte + '&archivo=' + archiSel + '&encabezado=' + this.nombreDelReporte + '&descripcion=' + this.banerFiltros + '&camposIncluye=' + JSON.stringify(this.camposIncluye) + '&orden=' + JSON.stringify(this.orden) + '&camposTotales=' + JSON.stringify(this.camposTotales) + '&camposFiltrar=' + JSON.stringify(this.camposFiltrar) + '&filtrosAplicados=' + '&autor=' + this.elusuario + '&status=' + "A";

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(cadena).then(function (respuesta) {
				_this2.registrosTodos = respuesta.data; // recibe un objeto
			});
		},
		leerReporte: function leerReporte() {

			// llena el select de los reportes disponibles
			var selectorRep = document.getElementById('selReportes');

			var cadena = 'https://www.directodo.com/Rentus/accesosdb/leeReporte.php';

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(cadena).then(function (respuesta) {
				var todosLosReportes = respuesta.data; // recibe un objeto

				// llena el select de reportes		
				selectorRep.length = 0; // lo limpia primero
				for (var rep in todosLosReportes) {
					// lee cada registro
					var campo = "";
					for (campo in todosLosReportes[rep]) {
						// lee cada campo del registro
						if (campo = "nombreReporte") break;
					}
					// agrega el elemento del campo
					var opcion = document.createElement("option");

					opcion.value = todosLosReportes[rep]["consec"];
					opcion.text = todosLosReportes[rep][campo];

					selectorRep.add(opcion, null);
				}
			});

			this.leerDirReporte = true;
		},
		reporteSeleccionado: function reporteSeleccionado() {
			var _this3 = this;

			var selectorRep1 = document.getElementById('selReportes');

			var cadena = 'https://www.directodo.com/Rentus/accesosdb/leeUnReporte.php?repnum=' + selectorRep1.value;

			var cualArchivo = document.getElementById('elArchivo');

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(cadena).then(function (respue) {
				var losReportes = respue.data;

				// llena los selects del reporte.
				// los array vienen en formato JSON por eso los pasa a array
				cualArchivo.value = losReportes[0]["archivo"];

				_this3.camposIncluye = JSON.parse(losReportes[0]["camposIncluye"]);
				_this3.orden = JSON.parse(losReportes[0]["orden"]);
				_this3.camposFiltrar = JSON.parse(losReportes[0]["camposFiltrar"]);
				_this3.camposTotales = JSON.parse(losReportes[0]["camposTotales"]);
				_this3.nombreDelReporte = losReportes[0]["encabezado"];
				_this3.banerFiltros = losReportes[0]["descripcion"];

				_this3.llenaCamposOrdenar();
				_this3.llenaCamposFiltrar();
				_this3.generando = true;

				_this3.getRegistros();

				// llena el select de filtros
				var selector = document.getElementById('cualFiltroUsar');
				selector.length = 0; // lo limpia primero
				for (var i in _this3.camposFiltrar) {
					var campo = _this3.camposFiltrar[i].replace('*', '');
					selector.add(new Option(campo));
				}

				//this.limpia();
				//this.iniciaDrop();		   		
			});
		},
		quitarParametros: function quitarParametros() {
			this.filtroTexto = "";
			this.filtroTexto2 = "";
			// tambien llama a recalcular totales
			this.totales = this.$sortusTotals(this.registrosTodos, this.camposTotales);
		},
		FormateaNumero2: function FormateaNumero2(valor1) {
			return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
		},


		total: function total(columna) {
			var titulo = this.titulosDeColumnas[columna];

			// les quita a los campos totales el * en el caso de que lo tengan
			var camposT = [];
			for (var i in this.camposTotales) {
				camposT.push(this.camposTotales[i].replace("*", ""));
			}

			var lugar = camposT.indexOf(titulo);

			var contenido = this.totales[lugar];

			if (isNaN(contenido)) return contenido;else return this.FormateaNumero2(contenido);
		},

		limpiar: function limpiar() {
			var filtro1 = document.getElementById('cualFiltroTexto');
			var filtro2 = document.getElementById('cualFiltroTexto2');
			filtro1.value = "";
			filtro2.value = "";
		}

		// terminan las funciones
	},

	computed: {
		filtrando: function filtrando() {
			var _this4 = this;

			var campoSeleccionado = document.getElementById('cualFiltroUsar').selectedOptions[0].value;
			// si está vacio entonces iguala los campos
			if (this.filtroTexto2 == '') this.filtroTexto2 = this.filtroTexto;
			// pone letreros informativos de los filtros que se usarán.
			this.banerFiltros = this.banerFiltros + ' (EN ' + campoSeleccionado + ' DE ' + this.filtroTexto + ' A ' + this.filtroTexto2 + ')';

			// aplica los filtros en el array registrosTodos y devuelve filtrado en esta computada solo los que estan en el rango señalado. el 1 lo agregamos para que funcione correcto el filtro
			return this.registrosTodos.filter(function (item) {
				return item[campoSeleccionado] >= _this4.filtroTexto && item[campoSeleccionado] <= _this4.filtroTexto2 + '1';
			});
		}
	}

});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'agrega-usuario',
	mounted: function mounted() {
		this.autorizar();
	},

	props: ['vector', 'empresa'],
	data: function data() {
		return {
			usuarios: {
				nombreCompleto: '',
				email: '',
				pase1: '',
				pase2: '',
				clave: '',
				celular: '',
				whatsapp: '',
				status: '',
				fechaModifica: '',
				quienModifico: ''
			},
			seleccion: '',
			cadenaSeleccion: ''
		};
	},

	methods: {
		autorizar: function autorizar() {
			// checa si tiene autorizacion
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Usuarios Altas')) {
					alert('Seccion no autorizada');
					document.getElementById('usuAdd').hidden = true;
					return;
				}
			}
		},
		agregaSeleccion: function agregaSeleccion(selec) {
			if (!this.cadenaSeleccion.includes(selec)) {
				this.cadenaSeleccion += '-' + selec + '\n';
			}
		},
		guardarUsuario: function guardarUsuario() {
			var _this = this;

			var usuarios1 = this.usuarios;
			var router = this.$router;
			if (usuarios1.pase2 != usuarios1.pase1) {
				//alert('Su clave debe coincidir');					
				return;
			}

			// primero checamos is existe o no
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/checaUsuario.php?elmail=' + usuarios1.email).then(function (respue) {
				if (respue.statusText == 'OK') {
					_this.mail2 = respue.data; // pasamos de objeto a string normal.
					if (_this.mail2.includes(usuarios1.email)) {
						alert('Usuario mail ya existe');
						return; // ya existe
					};

					// no existe, es nuevo entonces lo da de alta
					__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/agregaUsuario.php?nombreCompleto=' + usuarios1.nombreCompleto + '&email=' + usuarios1.email + '&celular=' + usuarios1.celular + '&suclave=' + usuarios1.pase1 + '&whatsapp=' + usuarios1.whatsapp + '&status=A' + '&fechaModifica=' + _this.fechaActual() + '&quienModifico=' + 'MASTER' + '&cadenaPermisos=' + _this.cadenaSeleccion).then(function (respue) {
						if (respue.statusText == 'OK') {
							router.push('/inq');
						}
					}).catch(function (error) {
						console.log('Este usuario ya existe ' + error);
					});
				}
			}).catch(function (error) {
				console.log('Error acceso a base ' + error);
			});
		},
		fechaActual: function fechaActual() {
			var currentDate = new Date(); //hoy
			var day = currentDate.getDate();
			var month = currentDate.getMonth() + 1;
			var year = currentDate.getFullYear();
			var my_date = year + "-" + month + "-" + day;
			return my_date;
		}
	}
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'editar-usuario',
	mounted: function mounted() {
		this.entrar();
	},

	props: ['vector'],
	data: function data() {
		return {
			id: null,
			usuarios: {
				mail: '',
				nombreCompleto: '',
				suClave: '',
				celular: '',
				whatsapp: '',
				status: '',
				fechaModifica: '',
				quienModifico: '',
				permisos: ''
			},
			seleccion: '',
			seleccionQ: '',
			cadenaSeleccion: ''
		};
	},

	methods: {
		entrar: function entrar() {
			var _this = this;

			// checa si tiene autorizacion
			if (!this.vector.includes('MASTERGGUV')) {
				if (!this.vector.includes('Usuarios Editar')) {
					document.getElementById('usuario-ver').hidden = true;
					alert('Seccion no autorizada');
					return;
				}
			}
			var pro = '';
			var usuarios2 = '';

			this.id = this.$route.params.idparam;
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeUnUsuario.php?idu=' + this.id).then(function (respue) {
				pro = respue.data;

				usuarios2 = pro[0]; // lee el unico registro cero

				_this.usuarios.idu = _this.id;
				_this.usuarios.mail = usuarios2.mail;
				_this.usuarios.nombreCompleto = usuarios2.nombreCompleto;
				_this.usuarios.suClave = usuarios2.suClave;
				_this.usuarios.celular = usuarios2.celular;
				_this.usuarios.whatsapp = usuarios2.whatsapp;
				_this.usuarios.status = usuarios2.status;
				_this.usuarios.fechaModifica = usuarios2.fechaModifica;
				_this.usuarios.quienModifico = usuarios2.quienModifico;
				_this.cadenaSeleccion = usuarios2.permisos;
			});
		},
		guardarUsuario: function guardarUsuario() {
			var propiedades2 = this.usuarios;
			var router = this.$router;

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://www.directodo.com/Rentus/accesosdb/modificaUsuario.php?idu=' + this.usuarios.idu + '&suClave=' + this.usuarios.suClave + '&celular=' + this.usuarios.celular + '&whatsapp=' + this.usuarios.whatsapp + '&status=' + this.usuarios.status + '&fechaModifica=' + this.fechaActual() + '&quienModifico=' + this.usuarios.quienModifico + '&permisos=' + this.cadenaSeleccion).then(function (respue) {
				if (respue.statusText == 'OK') {
					router.push('/usu');
				}
			}).catch(function (error) {
				console.log(error);
			});
		},
		agregaSeleccion: function agregaSeleccion(selec) {
			if (!this.cadenaSeleccion.includes(selec)) {
				this.cadenaSeleccion += '-' + selec + '\n';
			}
		},
		quitarSeleccion: function quitarSeleccion(selec) {
			this.cadenaSeleccion = this.cadenaSeleccion.replace('-' + selec, '');
		},
		fechaActual: function fechaActual() {
			var currentDate = new Date(); //hoy
			var day = currentDate.getDate();
			var month = currentDate.getMonth() + 1;
			var year = currentDate.getFullYear();
			var my_date = year + "-" + month + "-" + day;
			return my_date;
		}
	}
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContratosY_pre_contratos_buscar_vue__ = __webpack_require__(171);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'agrega-formato',
	components: {
		hijo1: __WEBPACK_IMPORTED_MODULE_1__ContratosY_pre_contratos_buscar_vue__["a" /* default */]
	},
	mounted: function mounted() {
		this.leeLosCampos();
		document.getElementById('bModificar').hidden = true;
	},
	data: function data() {
		return {
			seleccion: '',
			idContrato: '',
			contratos: '',
			contratoSolo: '',
			ultimaPosicion: '',
			contenidoEnFormato: '',
			buscar: false

		};
	},


	methods: {

		leerFormato: function leerFormato(e) {
			// lee un archivo de texto de la computadora del usuario
			// pero si se vuelve a leer el mismo formato que se selecciono 
			// exactamente antes no lo vuelve a leer.
			var input = event.target;

			var archivo = new FileReader();

			archivo.onload = function () {
				var text = archivo.result;
				// graba el contenido de archivo en elemento contenido
				var nodo = document.getElementById('contenido');
				nodo.value = text;
			};

			archivo.readAsText(input.files[0]);
		},

		formateaNumero: function formateaNumero(valor1) {
			return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
		},


		formateaFecha: function formateaFecha(fecha) {
			var d = new Date(fecha);
			if (Date.parse(d)) {
				// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				d.setHours(0);
				var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
				d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
				return d;
			} else {
				return "sin fecha";
			}
		},

		obtieneContenido: function obtieneContenido() {
			var elContenido = document.getElementById('contenido');
			return elContenido.value;
		},

		aBuscar: function aBuscar() {
			this.buscar = true;
			document.getElementById('esVisible').style.height = "0";
			document.getElementById('esVisible').style.visibility = "hidden";
		},


		recibeC: function recibeC(id, inum, pnum, ino, pno, gir, fam, subf, dueno, elmail, renta) {

			this.leeContrato(id);
			this.buscar = false;
			document.getElementById('esVisible').style.visibility = "visible";
		},

		guardarFor: function guardarFor(contenido) {
			// valida si hay algo para guardar
			if (contenido.search('<<<') == -1) {
				// no contiene campos de formato
				alert('\n\nIncluya algunos campos en el formato o vea el formato');
				return;
			}

			var nombre = prompt("\n\nNombre del formato ?");
			if (nombre == '') return;

			// pide el nombre del archivo a guardar
			// crea y guarda un archivo de texto. E incluso lo baja al usuario
			var atag = document.createElement("a");
			var file = new Blob([contenido], { type: 'text/html' });
			atag.href = URL.createObjectURL(file);
			atag.download = nombre + '.for';
			atag.click();
		},

		guardarCon: function guardarCon(contenido) {
			// valida si hay algo para guardar
			if (contenido.length == 0) {
				// no contiene campos de formato
				alert('\n\n Contrato vacio');
				return;
			}

			if (contenido.search('<<<') != -1) {
				// no contiene campos de formato
				alert('\n\n Este es un formato, no es un contrato\n puede usar el boton GENERAR CONTRATO');
				return;
			}

			var nombre = prompt("Nombre del contrato ?");
			if (nombre == '') return;
			// pide el nombre del archivo a guardar
			// crea y guarda un archivo de texto. E incluso lo baja al usuario
			var atag = document.createElement("a");
			var file = new Blob([contenido], { type: 'text/plain' });
			atag.href = URL.createObjectURL(file);
			atag.download = nombre + '.con';
			atag.click();
		},

		modificar: function modificar() {
			document.getElementById('bModificar').hidden = true;
			document.getElementById('bRemplazar').hidden = false;
			var elContenido = document.getElementById('contenido');
			elContenido.disabled = false;
			elContenido.value = this.contenidoEnFormato;
		},

		remplazar: function remplazar() {

			var elContenido = document.getElementById('contenido');
			var campos = document.getElementById('loscampos');

			if (elContenido.value.search('<<<') == -1) {
				// no contiene campos de formato
				alert('\n\nIncluya algunos campos en el formato');
				return;
			}

			var elContrato = document.getElementById('contra');
			if (elContrato.value <= 0) {
				alert('\n\nSeleccione un contrato');
				return;
			}

			// guarda el contenido actual por si hay que hacer undo
			this.contenidoEnFormato = elContenido.value;

			for (var i = 1; i < campos.length; i++) {
				// lee campo por campo del archivo encabezados
				var elCampo = campos[i].value;
				var elValor = this.contratoSolo[elCampo]; //toma el valor de c/campo de este contrato


				var cadenaRemplazo = "<<<" + elCampo + ">>>";
				var nuevo;

				// crea la cadena a buscar globalmente para remplazar todas de una vez
				var cadenaRemplazo2 = new RegExp(cadenaRemplazo, "g");

				if (elCampo.includes("importeMes") || elCampo.includes("saldo")) {
					elValor = "$ " + this.formateaNumero(elValor);
				}

				if (elCampo.includes("fecha")) {
					elValor = this.formateaFecha(elValor);
				}

				nuevo = elContenido.value.replace(cadenaRemplazo2, elValor);

				elContenido.value = nuevo;

				// inhabilito la modificacion del contenido
				elContenido.disabled = true;
				document.getElementById('bModificar').hidden = false;
				document.getElementById('bRemplazar').hidden = true;
			};
		},

		agrega: function agrega() {
			var elContenido = document.getElementById('contenido');

			if (elContenido.disabled == true) {
				alert('\n\n No se agregó. Debe estar en modo formato');
				return;
			}
			var primeraParte = elContenido.value.substring(0, parseInt(this.ultimaPosicion));
			var segundaParte = elContenido.value.substring(parseInt(this.ultimaPosicion), elContenido.length);

			// es importante que deje antes de los <<< y despues de >>> un espacio
			var todo1 = primeraParte + ' <<<' + this.seleccion + '>>> ' + segundaParte;
			elContenido.value = todo1;

			this.seleccion = "";
		},

		posicion: function posicion() {
			// obtiene la posicion dentro del contenido
			var contiene = document.getElementById('contenido');
			this.ultimaPosicion = contiene.selectionStart;
		},

		leeContrato: function leeContrato(cualContrato) {
			var _this = this;

			var elContrato1 = document.getElementById('contra');

			// lee el registro del contrato
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeUnContrato.php?id=' + cualContrato).then(function (respue) {
				_this.contratos = respue.data;
				_this.contratoSolo = _this.contratos[0]; //el primer registro, el unico.
				elContrato1.value = _this.contratoSolo.id;
			});
		},

		leeLosCampos: function leeLosCampos() {
			var _this2 = this;

			var cadena = 'https://www.directodo.com/Rentus/accesosdb/leeContratos.php';
			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(cadena).then(function (respuesta) {
				_this2.registrosTodos = respuesta.data; // recibe un objeto
				// llena el select de los campos
				_this2.llenaCampos();
			});
		},

		llenaCampos: function llenaCampos() {
			var loscampos1 = [];
			// toma los titulos de los campos
			for (var nombreCampo in this.registrosTodos[0]) {
				// lee campo por campo del registro primero y llena un arreglo con 
				// los nombres de cada campo
				loscampos1.push(nombreCampo);
			}

			var selector2 = document.getElementById('loscampos');
			selector2.length = 0; // lo limpia primero

			var c;
			for (c in loscampos1) {
				// lo llena
				selector2.add(new Option(loscampos1[c]));
			};
		},

		imprimir: function imprimir(divName) {
			var printContents = document.getElementById(divName);

			//var originalContents = document.body.innerHTML;
			document.body.innerHTML = printContents.value;

			// remplaza los saltos de renglon con hipertexto
			document.body.innerHTML = document.body.innerHTML.replace(/\n/g, '<br>\n');

			window.print();

			// document.body.innerHTML = originalContents;					

			var router = this.$router;
			router.push('/for-agerga');
		},

		keymonitor: function keymonitor(evento) {
			this.posicion(); // actualiza la posicion del cursor				

			var contiene = document.getElementById('contenido');
			var anterior = contiene.value.substr(this.ultimaPosicion - 1, 1);
			var anterior3 = contiene.value.substr(this.ultimaPosicion - 3, 3);

			var posterior = contiene.value.substr(this.ultimaPosicion, 1);
			var posicionCarAnterior = this.ultimaPosicion - 1;
			var posicionCarPosterior = this.ultimaPosicion;

			var caracterTecleado = evento.key;
			var c = this.ultimaPosicion;
			var posicionInicial = c;
			var caracteres = "";
			var caracteres1 = "";
			var caracteres2 = "";
			var caracteres3 = "";

			while (c >= 0) {
				// termina de buscar si hay un caracter en blanco
				//if(contiene.value.substring(c, c ) === " ") c = -1;

				// si los 3 caracteres anteriores son <<< entonces encontro un campo y deja la edicion intacta
				caracteres = contiene.value.substring(c - 3, c);
				caracteres1 = contiene.value.substring(c - 2, c + 1);
				caracteres2 = contiene.value.substring(c - 1, c + 2);

				if (caracteres === "<<<" || caracteres1 === "<<<" || caracteres2 === "<<<" || caracteres3 === "<<<") {
					// encontro un campo. Restituye entonces la edicion
					// devuelve el caracter eliminado a su lugar
					if (evento.key === "Backspace" || evento.key === "Enter") {
						var nuevoTexto = contiene.value.slice(0, posicionCarAnterior) + anterior + contiene.value.slice(posicionCarAnterior + 1);
						// solo funciona si le agrego ciertos caracteres antes para remplazar el valor, por eso quito esos caracteres despues
						contiene.value = "#?*&&" + nuevoTexto;
						contiene.value = contiene.value.replace("#?*&&", "");

						// cancela el evento
						evento.preventDefault();

						// posiciona el cursor antes de los signos <<<
						contiene.setSelectionRange(c - 3, c - 3);
					}

					if (evento.key === "Delete") {
						var elCampo = contiene.value.substring(c - 3, posicionInicial);
						//alert (elCampo + "   " + posicionInicial + "   " + c);
						var borrarDesde = c - 3;
						var borrarHasta = 0;
						var cont = posicionInicial;

						while (cont <= contiene.value.length - 1) {

							if (contiene.value.substring(cont, cont + 3) === ">>>") {

								borrarHasta = cont + 3;
								// ya encontro la terminacion del campo a borrar, ahora determina cual es el campo y lo borra. Le agrega caracteres basura para no confundir con otros campos
								var campoAborrar = contiene.value.substring(borrarDesde, borrarHasta) + "&4$#*";
								var nuevoTexto = contiene.value.slice(0, borrarDesde) + campoAborrar + contiene.value.slice(borrarHasta);
								// solo funciona si le agrego ciertos caracteres antes para remplazar el valor, por eso quito esos caracteres despues
								contiene.value = nuevoTexto;
								contiene.value = contiene.value.replace(campoAborrar, "");
								break; // termina el while
							}

							cont = cont + 1;
						}

						// cancela el evento
						evento.preventDefault();
						// posiciona el mouse antes del campo que borro con delete
						contiene.setSelectionRange(borrarDesde, borrarDesde);
					}

					// checa si fue espacio u otro caracter
					if (evento.key != "Delete" && !evento.key != "Backspace" && !evento.key != "Enter") {

						var nuevoTexto = contiene.value.slice(0, posicionCarAnterior + 1) + posterior + contiene.value.slice(posicionCarPosterior + 1);
						// solo funciona si le agrego ciertos caracteres antes para remplazar el valor, por eso quito esos caracteres despues
						contiene.value = "#?*" + nuevoTexto;
						contiene.value = contiene.value.replace("#?*", "");
						// cancela el evento
						evento.preventDefault();
						// posiciona el mouse antes del campo que borro con delete
						contiene.setSelectionRange(c - 3, c - 3);
					}
				}

				c = c - 1;
				if (caracteres.includes(" ")) c = -1;
			}
		}

	}
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContratosYpre-buscar',
  mounted: function mounted() {
    this.getContratos();
  },
  data: function data() {
    return {
      contratosTodos: null,
      abuscar: ''
    };
  },

  methods: {
    lanza: function lanza(idCon, inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta, claveCa) {
      this.$emit('eventoConYpre', idCon, inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta, claveCa);
    },
    getContratos: function getContratos() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php').then(function (respuesta) {
        _this.contratosTodos = respuesta.data;
      });
    },
    esRentado: function esRentado(status) {
      if (status == 'RENTADO' || status == 'PRE-CONTRATO') {
        return true;
      } else return false;
    }
  },
  computed: {
    buscando: function buscando() {
      var _this2 = this;

      return this.contratosTodos.filter(function (item) {
        return item.giro.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.inquilino.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.id.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.propiedad.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.familia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.subfamilia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.nombreComercial.toUpperCase().includes(_this2.abuscar.toUpperCase());
      });
    }
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Contrato_estado_vue__ = __webpack_require__(37);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Estados',
  components: {
    EstadoIndividual: __WEBPACK_IMPORTED_MODULE_1__Contrato_estado_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.verEstadoCta = false;
    this.getContratos();
  },

  props: ['vector'],
  data: function data() {
    return {
      contratosTodos: null,
      abuscar: '',
      verEstadoCta: false,
      numContrato: '',
      cualContratoVer: '',
      ifin: 'nop'
    };
  },


  methods: {
    getContratos: function getContratos() {
      var _this = this;

      // checa si tiene autorizacion
      if (!this.vector.includes('MASTERGGUV')) {
        if (!this.vector.includes('Contratos')) {
          alert('Seccion no autorizada');
          return;
        }
      }

      var incluyeFinalizados2 = document.getElementById("incluyeFinalizados").checked;
      this.ifin = "nop";
      if (incluyeFinalizados2 == true) this.ifin = "sip";

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/leeSaldos.php?ifi=' + this.ifin).then(function (respuesta) {
        _this.contratosTodos = respuesta.data;
      });
    },
    verContrato: function verContrato(num) {
      this.numContrato = num;
      this.verEstadoCta = true;
      this.cualContratoVer = num;
    },
    enviaMails: function enviaMails() {
      if (confirm("\nSe enviarán los estados de cuenta" + "\na cada Inquilino por Mail" + "\nen este momento\n\n" + "\nEsta de acuerdo ?")) {
        // continua 

      } else {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://www.directodo.com/Rentus/accesosdb/enviarEstadosDeCuentaTodos.php').then(function (respuesta) {
        alert("\n\nMails enviados");
      });
    },


    vencido: function vencido(fecha, status) {

      var fecha1 = new Date(fecha);
      fecha1.setHours(0);

      var hoy = new Date();
      hoy.setHours(0);

      var fechams = fecha1.getTime(); // en milisegundos				
      var hoyms = hoy.getTime(); // en milisegundos

      if (fechams < hoyms) {
        if (status == "FINALIZADO") {
          return ".";
        }
        return "Contrato Vencido";
      } else return ".";
    },

    formateaFecha: function formateaFecha(fecha) {
      var d = new Date(fecha);
      if (Date.parse(d)) {
        // pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
        d.setHours(0);
        var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
        d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
        return d;
      } else {
        return "sin fecha";
      }
    },

    formateaNumero: function formateaNumero(valor1) {
      return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
    },
    formateaNumeroRedondo: function formateaNumeroRedondo(valor1) {
      return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 0, useGrouping: true });
    },
    fechaActual: function fechaActual() {
      var currentDate = new Date(); //hoy
      var day = currentDate.getDate();
      var month = currentDate.getMonth() + 1;
      var year = currentDate.getFullYear();
      var my_date = year + "-" + month + "-" + day;
      return my_date;
    },
    cambioIncluye: function cambioIncluye() {
      this.verEstadoCta = false;

      this.contratosTodos = "";
      this.getContratos();
    }
  },

  computed: {
    contratosTodosBuscar: function contratosTodosBuscar() {
      var _this2 = this;

      if (this.contratosTodos) {
        return this.contratosTodos.filter(function (item) {
          return item.propiedad.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.familia.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.giro.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.contrato.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.dueno.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.status.toUpperCase().includes(_this2.abuscar.toUpperCase()) || item.nombreComercial.toUpperCase().includes(_this2.abuscar.toUpperCase());
        });
      }
    },

    totalSaldos: function totalSaldos() {
      if (this.contratosTodos) {
        var sum = 0;
        this.contratosTodosBuscar.forEach(function (e) {
          sum += Number(e.total);
        });
        return sum;
      }
    },
    totalRentas: function totalRentas() {
      if (this.contratosTodos) {
        var sum = 0;
        this.contratosTodosBuscar.forEach(function (e) {
          sum += Number(e.importeMes);
        });
        return sum;
      }
    },
    totalPropiedades: function totalPropiedades() {
      if (this.contratosTodos) {
        var sum = 0;
        this.contratosTodosBuscar.forEach(function (e) {
          sum = sum + 1;
        });
        return sum;
      }
    }
  }

});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// lee los reportes guardados y los despliega



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'LeerRepHecho',
	mounted: function mounted() {
		this.leerReporte();
		this.getRegistros();
		this.llenaNombreArchivos();
	},

	props: ['vector', 'elusuario'],
	data: function data() {
		return {
			registrosTodos: [],
			probando1: 'GMO',
			aparece: true,
			registrosTodos2: null,
			contando: true,
			delRenglon: 0,
			alRenglon: 0,
			columna: '',
			direccion: '',
			tipo: '',
			orden: [], // contiene los nombres de las columnas que se ordenaran
			camposIncluye: [],
			titulosDeColumnas: [],
			camposFechados: [],
			camposNumericos: [],
			camposTotales: [], // contiene los nombres de las columnas a totalizar
			columnasDeTotales: [],
			camposFiltrar: [],
			totales: [],
			llav: 'inquilino',
			seleccion: '',
			seleccion2: '',
			seleccion3: '',
			col1: '',
			col2: '',
			generando: false,
			elemento: '',
			anterior: '',
			esSubtotal: true,
			cualArchivo2: '',
			filtroTexto: '',
			filtroTexto2: '',
			filtroActual: '',
			banerFiltros: '',
			leerDirReporte: false,
			nombreDelReporte: "",
			letreroFiltros: ""
		};
	},


	methods: {
		getRegistros: function getRegistros() {
			var _this = this;

			// Valida usuario si tiene autorizacion para esta seccion o usa el paswword maestro  
			var archiSel = document.getElementById('elArchivo').value;
			if (!this.vector.includes('MASTERGGUV')) {
				if (this.vector.includes('Reportes')) {
					if (!this.vector.includes('Reportes de ' + archiSel)) {
						alert('Seccion no autorizada');
						return;
					}
				} else return;
			}

			this.registrosTodos = [];
			var renglon = [];
			var cualArchivo = document.getElementById('elArchivo').value;

			if (cualArchivo) {

				var cadena = 'https://www.directodo.com/Rentus/accesosdb/lee' + cualArchivo + '.php';

				__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(cadena).then(function (respuesta) {

					_this.registrosTodos = respuesta.data; // recibe un objeto

					// llena el selector de los campos
					_this.llenaCampos();

					// llama a los totales antes de llamar a ordenar porque puede ser que no 
					// haya registros a ordenar y suspenda la continuacion de la ejecucion
					// tambien llama a mi SORTUSTotals para totalizar las columnas seleccionadas a totalizar
					if (!_this.camposTotales == "" && !_this.registrosTodos == "") {
						_this.totales = _this.$sortusTotals(_this.registrosTodos, _this.camposTotales);
					}

					// ordena el resultado con MI SORTUS pasando el objeto a ordenar y 
					// el array que contiene los nombres de los campos a ordenar
					if (!_this.registrosTodos == "" && !_this.orden == "") {
						_this.registrosTodos = _this.$sortus(_this.registrosTodos, _this.orden);
					}
				});
			}
		},


		limpia: function limpia() {
			this.cualArchivo2 = document.getElementById('elArchivo').value;
			document.getElementById('elArchivo').hidden = true;
		},

		iniciaDrop: function iniciaDrop() {
			// al cambiar el archivo seleccionado inicializa los selects
			var selectBox = document.getElementById("loscampos");
			selectBox.innerHTML = "";
			this.seleccion = "";
			this.seleccion2 = "";
			this.seleccion3 = "";
			var selectBox = document.getElementById("losorden");
			selectBox.innerHTML = "";
			var selectBox = document.getElementById("losfiltros");
			selectBox.innerHTML = "";

			document.getElementById("elReporte").innerHTML = "Campos incluidos:";
			document.getElementById("elOrden").innerHTML = "Orden:";
			document.getElementById("elFiltro").innerHTML = "Filtros:";
		},


		filtrar: function filtrar() {
			this.registrosTodos = this.filtrando;
			// tambien llama a recalcular totales
			this.totales = this.$sortusTotals(this.registrosTodos, this.camposTotales);

			this.cualFiltroTexto2 = "";
			this.cualFiltroTexto = "";
		},

		ponCampo: function ponCampo(campo) {
			// agrega campo al reporte. Lo corre despues 
			// de ponCampo
			// AGREGA EL BOTON CAMPO						
			document.getElementById("elReporte").innerHTML += '&nbsp&nbsp&nbsp<button class="campos" id="' + campo + '">' + campo + ' x </button>';

			// AGREGA EL BOTON FECHA
			var nombre = campo + 'F';
			document.getElementById("elReporte").innerHTML += '<button class="fecha" style="background-color:white;" id="' + nombre + '"> F </button>';

			// AGREGA EL BOTON NUMERICO
			var nombre = campo + 'N';
			document.getElementById("elReporte").innerHTML += '<button class="numero" style="background-color:white;" id="' + nombre + '"> # </button>';

			// AGREGA EL BOTON TOTAL
			var nombre = campo + 'T';
			document.getElementById("elReporte").innerHTML += '<button class="total" style="background-color:white;" id="' + nombre + '"> T </button>';
		},

		ponCampoOrden: function ponCampoOrden(campo) {
			// agrega campo a ordenar en el reporte
			var nombre = campo + '.';
			document.getElementById("elOrden").innerHTML += '&nbsp&nbsp&nbsp<button class="ordenar" id="' + nombre + '">' + nombre + ' x </button>';
		},

		ponCampoFiltro: function ponCampoFiltro(campo) {
			// agrega campo a filtrar en el reporte
			var nombre = campo + '*';
			document.getElementById("elFiltro").innerHTML += '&nbsp&nbsp&nbsp<button class="filtrar" id="' + nombre + '">' + nombre + ' x </button>';
		},

		generaCampo: function generaCampo() {
			// genera el reporte la parte a incluir
			var item = '';
			var elms = document.getElementById('elReporte').getElementsByClassName("campos");

			// les agrega funciones a los botones.
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {
					// al click borra este botón y el de fecha y el de Total
					this.remove();
					document.getElementById(this.id + 'F').remove();
					document.getElementById(this.id + 'N').remove();
					document.getElementById(this.id + 'T').remove();
				};
			}
			this.llenaCamposOrdenar(); // llena el select aordenar
			this.llenaCamposFiltrar(); // llena el select afiltrar
		},

		generaCampoOrden: function generaCampoOrden() {
			// agrega la parte del reporte los campos a ordenar
			var item = '';
			var elm = {};
			var elms = document.getElementById('elOrden').getElementsByClassName("ordenar");

			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {
					this.remove(); // borra el componente
				};
			}
		},

		generaCampoFiltro: function generaCampoFiltro() {
			// agrega la parte del reporte los campos a filtrar
			var item = '';
			var elm = {};
			var elms = document.getElementById('elFiltro').getElementsByClassName("filtrar");

			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {
					this.remove(); // borra el componente
				};
			}
		},

		generaCampoFechas: function generaCampoFechas() {
			var item = '';
			var elms = document.getElementById('elReporte').getElementsByClassName("fecha");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {
					if (this.style.backgroundColor == 'fuchsia') {
						this.style.backgroundColor = 'white';
					} else {
						this.style.backgroundColor = 'fuchsia';
					}
				};
			}
		},

		generaCampoNumeros: function generaCampoNumeros() {
			var item = '';
			var elms = document.getElementById('elReporte').getElementsByClassName("numero");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {
					if (this.style.backgroundColor == 'yellow') {
						this.style.backgroundColor = 'white';
					} else {
						this.style.backgroundColor = 'yellow';
					}
				};
			}
		},

		generaCampoTotales: function generaCampoTotales() {
			var item = '';
			var elms = document.getElementById('elReporte').getElementsByClassName("total");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				document.getElementById(item).onclick = function () {

					switch (this.style.backgroundColor) {
						case "white":
							this.style.backgroundColor = 'lime';
							this.innerHTML = "Contar";
							break;
						case "lime":
							this.style.backgroundColor = 'aqua';
							this.innerHTML = "Sumar";
							break;
						case "aqua":
							this.style.backgroundColor = 'white';
							this.innerHTML = "T";
							break;
					}
				};
			}
		},

		generaReporte: function generaReporte() {

			// obtiene el nombre del archivo en cuestion para sugerirlo como nombre del reporte
			if (this.nombreDelReporte == "") {
				var cualArchivo = document.getElementById('elArchivo').value;
				this.nombreDelReporte = cualArchivo;
			}

			this.nombreDelReporte = prompt("Encabezado del reporte ?", cualArchivo);

			this.generando = true; // resetea reporte y bandera que es nuevo reporte
			this.banerFiltros = ''; // limpia baner de los filtros.

			var item,
			    itemColor = '';
			var elm = {};
			this.orden = [];
			this.camposIncluye = [];
			this.camposFechados = [];
			this.titulosDeColumnas = [];
			this.camposNumericos = [];
			this.camposTotales = [];
			this.camposFiltrar = [];
			this.registrosTodos = [];

			// crea el array de los campos a incluir
			elms = document.getElementById('elReporte').getElementsByClassName("campos");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				//en 'camposIncluye' deja los campos a incluir en el reporte
				this.camposIncluye.push(item);
			};

			// crea el array de los campos a ordenar. Les quita el punto decimal
			// que le agregamos al nombre al final para diferenciarlos de los demas
			var elms = document.getElementById('elOrden').getElementsByClassName("ordenar");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				this.orden.push(item.replace('.', '')); // en el campo 'orden' deja los campos a ordenar
			};

			// crea el array de los campos a formatear como fecha. los de fondo rojo
			elms = document.getElementById('elReporte').getElementsByClassName("fecha");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				itemColor = elms[i].style.backgroundColor;
				//en 'camposFechados' deja los campos a formatear como fecha
				// y le quita la F
				item = item.replace('F', '');
				if (itemColor == 'fuchsia') {
					this.camposFechados.push(item);
					// MODIFICA EL ARRAY DE ORDEN PARA QUE SE VAYA AL SORTUS CON LOS
					// PARÁMETROS ADECUADOS
					for (var elemento in this.orden) {
						if (this.orden[elemento] == item) {
							this.orden[elemento] = item + '+D';
						}
					}
				}
			};

			// crea el array de los campos a formatear como NUMERO. los de fondo AMARILLO
			elms = document.getElementById('elReporte').getElementsByClassName("numero");

			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				itemColor = elms[i].style.backgroundColor;

				//en 'camposFechados' deja los campos a formatear como fecha
				// y le quita la N
				item = item.replace('N', '');
				if (itemColor == 'yellow') {
					this.camposNumericos.push(item);

					// MODIFICA EL ARRAY DE ORDEN PARA QUE SE VAYA AL SORTUS CON LOS
					// PARÁMETROS ADECUADOS
					for (var elemento in this.orden) {
						if (this.orden[elemento] == item) {
							this.orden[elemento] = item + '+N';
						}
					}
				}
			};

			// crea el array de los campos a totalizar. Los de fondo lime
			elms = document.getElementById('elReporte').getElementsByClassName("total");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				itemColor = elms[i].style.backgroundColor;

				//en 'camposTotales' deja los nombres de las columnas a totalizar 
				// y le quita la T
				item = item.replace('T', '');

				if (itemColor == 'lime' || itemColor == "aqua") {
					if (itemColor == "aqua") item = item + "*";
					this.camposTotales.push(item);
				}
			};

			// llena el array de los campos a filtrar
			elms = document.getElementById('elFiltro').getElementsByClassName("filtrar");
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				//en 'camposIncluye' deja los campos a incluir en el reporte
				this.camposFiltrar.push(item);
			};

			// llena el select de filtros
			var selector = document.getElementById('cualFiltroUsar');
			selector.length = 0; // lo limpia primero
			for (var i in this.camposFiltrar) {
				var campo = this.camposFiltrar[i].replace('*', '');
				selector.add(new Option(campo));
			}

			this.getRegistros();
		},

		imprimir: function imprimir(divName) {
			var printContents = document.getElementById(divName).innerHTML;
			var originalContents = document.body.innerHTML;
			document.body.innerHTML = printContents;
			window.print();
		},

		llenaNombreArchivos: function llenaNombreArchivos() {
			// llena los select
			// son los nombres de los archivos del backend
			var loscampos2 = ['Archivo', 'Contratos', 'Inquilinos', 'Movimientos', 'Propiedades'];
			var selector1 = document.getElementById('elArchivo');

			var c1;
			for (c1 in loscampos2) {
				selector1.add(new Option(loscampos2[c1]));
			};
		},

		llenaCampos: function llenaCampos() {
			var loscampos1 = [];
			// toma los titulos de los campos
			for (var key in this.registrosTodos[0]) {
				// lee campo por campo del registro primero y llena un array con los nombres de las columnas
				loscampos1.push(key);
			}

			var selector2 = document.getElementById('loscampos');
			selector2.length = 0; // lo limpia primero

			var c;
			for (c in loscampos1) {
				// lo llena con los nombres de los campos
				selector2.add(new Option(loscampos1[c]));
			};
		},

		llenaCamposOrdenar: function llenaCamposOrdenar() {
			// llena el select losorden

			var selectBox = document.getElementById("losorden");
			selectBox.innerHTML = ""; // lo limpia

			// extrae los elementos del select campos
			var elms = document.getElementById('elReporte').getElementsByClassName("campos");
			var item;
			var loscampos3;
			this.titulosDeColumnas = [];

			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				this.titulosDeColumnas.push(item.replace('.', '')); // en el campo 'consec' deja los campos a ordenar
			};

			loscampos3 = this.camposIncluye;
			var selector3 = document.getElementById('losorden');
			selector3.length = 0; // lo limpia

			for (var c in this.titulosDeColumnas) {
				selector3.add(new Option(this.titulosDeColumnas[c]));
			};
		},

		llenaCamposFiltrar: function llenaCamposFiltrar() {
			// llena el select losorden
			// primero lo limpia
			var selectBox = document.getElementById("losfiltros");
			selectBox.innerHTML = "";
			// extrae los elementos del select LOSCAMPOS
			var elms = document.getElementById('elReporte').getElementsByClassName("campos");
			var item;
			var loscampos3;
			this.titulosDeColumnas = [];
			for (var i = 0; i < elms.length; i++) {
				item = elms[i].id;
				this.titulosDeColumnas.push(item.replace('.,', '')); // en el campo 'consec' deja los campos a ordenar
			};
			loscampos3 = this.camposIncluye;
			var selector3 = document.getElementById('losfiltros');
			selector3.length = 0; // lo limpia

			if (this.titulosDeColumnas.length > 0) {
				//vailida si existe
				for (var c in this.titulosDeColumnas) {
					selector3.add(new Option(this.titulosDeColumnas[c]));
				};
			}
		},

		colum: function colum(columna, registro) {
			// CREA LAS COLUMNAS EN EL REPORTE
			// recibe todo el registro 
			// checa si es la primera vez (generando = true) nuevo reporte y cambia los 
			// campos como se desplegarán. Solo lo hace una vez cada nuevo registro

			if (this.generando == true) {
				// si es nuevo reporte toma encabezados
				this.titulosDeColumnas = [];
				for (var cada in this.camposIncluye) {
					//lee campos que se incluirán
					for (var titulo in registro) {
						// lee campo por campo del registro
						if (this.camposIncluye[cada] == titulo) {
							this.titulosDeColumnas.push(titulo); //guarda la posición del
							break; //campo que si se incluirá
						}
					}
				}

				this.generando = false; // apaga la bandera de que es nuevo
			}

			// despliega los campos en el orden que se pidió el reporte.
			// checa si este campo debe llevar formato de fecha o numero y lo formatea
			var elemento = this.titulosDeColumnas[parseInt(columna)];

			var esfecha = this.camposFechados.includes(elemento);
			if (esfecha) {
				// es con formato de fecha
				return this.formateaFecha2(registro[elemento]);
			} else {
				var esnumero = this.camposNumericos.includes(elemento);
				if (esnumero) {
					// es con formato de numero
					return this.FormateaNumero2(registro[elemento]);
				} else {
					// no es ni fecha ni numero
					return registro[this.titulosDeColumnas[parseInt(columna)]];
				}
			}
		},

		titulo: function titulo(tit) {
			//con el numero de columna regresa el titulo de la columna
			return this.titulosDeColumnas[tit];
		},

		formateaFecha2: function formateaFecha2(fecha) {

			var d = new Date(fecha);
			if (Date.parse(d)) {
				// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				//d.setHours(0);
				var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
				d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
				return d;
			} else {
				return "sin fecha";
			}
		},

		guardarReporte: function guardarReporte() {
			var _this2 = this;

			var nombreReporte = prompt("Nombre del reporte ?", "");

			if (nombreReporte == "") return;

			var archiSel = document.getElementById('elArchivo').value;

			// guarda los array en formato json para despues poderlos desserializar de json a array
			var cadena = 'https://www.directodo.com/Rentus/accesosdb/guardaReporte.php?cliente=RGGUV1' + '&nombreReporte=' + nombreReporte + '&archivo=' + archiSel + '&encabezado=' + this.nombreDelReporte + '&descripcion=' + this.banerFiltros + '&camposIncluye=' + JSON.stringify(this.camposIncluye) + '&orden=' + JSON.stringify(this.orden) + '&camposTotales=' + JSON.stringify(this.camposTotales) + '&camposFiltrar=' + JSON.stringify(this.camposFiltrar) + '&filtrosAplicados=' + '&autor=' + this.elusuario + '&status=' + "A";

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(cadena).then(function (respuesta) {
				_this2.registrosTodos = respuesta.data; // recibe un objeto
			});
		},
		leerReporte: function leerReporte() {

			// llena el select de los reportes disponibles
			var selectorRep = document.getElementById('selReportes');

			var cadena = 'https://www.directodo.com/Rentus/accesosdb/leeReporte.php';

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(cadena).then(function (respuesta) {
				var todosLosReportes = respuesta.data; // recibe un objeto

				// llena el select de reportes		
				selectorRep.length = 0; // lo limpia primero
				for (var rep in todosLosReportes) {
					// lee cada registro
					var campo = "";
					for (campo in todosLosReportes[rep]) {
						// lee cada campo del registro
						if (campo = "nombreReporte") break;
					}
					// agrega el elemento del campo
					var opcion = document.createElement("option");

					opcion.value = todosLosReportes[rep]["consec"];
					opcion.text = todosLosReportes[rep][campo] + "    " + todosLosReportes[rep]["autor"];

					selectorRep.add(opcion, null);
				}
			});

			this.leerDirReporte = true;
		},
		reporteSeleccionado: function reporteSeleccionado() {
			var _this3 = this;

			var selectorRep1 = document.getElementById('selReportes');

			var cadena = 'https://www.directodo.com/Rentus/accesosdb/leeUnReporte.php?repnum=' + selectorRep1.value;

			var cualArchivo = document.getElementById('elArchivo');

			__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(cadena).then(function (respue) {
				var losReportes = respue.data;

				// llena los selects del reporte.
				// los array vienen en formato JSON por eso los pasa a array
				cualArchivo.value = losReportes[0]["archivo"];

				_this3.camposIncluye = JSON.parse(losReportes[0]["camposIncluye"]);
				_this3.orden = JSON.parse(losReportes[0]["orden"]);
				_this3.camposFiltrar = JSON.parse(losReportes[0]["camposFiltrar"]);
				_this3.camposTotales = JSON.parse(losReportes[0]["camposTotales"]);
				_this3.nombreDelReporte = losReportes[0]["encabezado"];
				_this3.letreroFiltros = losReportes[0]["descripcion"];

				_this3.llenaCamposOrdenar();
				_this3.llenaCamposFiltrar();
				_this3.generando = true;

				_this3.getRegistros();

				// llena el select de filtros
				var selector = document.getElementById('cualFiltroUsar');
				selector.length = 0; // lo limpia primero
				for (var i in _this3.camposFiltrar) {
					var campo = _this3.camposFiltrar[i].replace('*', '');
					selector.add(new Option(campo));
				}

				//this.limpia();
				//this.iniciaDrop();		   		
			});
		},
		quitarParametros: function quitarParametros() {
			this.filtroTexto = "";
			this.filtroTexto2 = "";
			// tambien llama a recalcular totales
			this.totales = this.$sortusTotals(this.registrosTodos, this.camposTotales);
		},
		FormateaNumero2: function FormateaNumero2(valor1) {
			return Number(valor1).toLocaleString('en-US', { minimumFractionDigits: 2, useGrouping: true });
		},


		total: function total(columna) {
			var titulo = this.titulosDeColumnas[columna];

			// les quita a los campos totales el * en el caso de que lo tengan
			var camposT = [];
			for (var i in this.camposTotales) {
				camposT.push(this.camposTotales[i].replace("*", ""));
			}

			var lugar = camposT.indexOf(titulo);

			var contenido = this.totales[lugar];

			if (isNaN(contenido)) return contenido;else return this.FormateaNumero2(contenido);
		},

		limpiar: function limpiar() {
			var filtro1 = document.getElementById('cualFiltroTexto');
			var filtro2 = document.getElementById('cualFiltroTexto2');
			filtro1.value = "";
			filtro2.value = "";
		}

		// terminan las funciones
	},

	computed: {
		filtrando: function filtrando() {
			var _this4 = this;

			var campoSeleccionado = document.getElementById('cualFiltroUsar').selectedOptions[0].value;
			// si está vacio entonces iguala los campos
			if (this.filtroTexto2 == '') this.filtroTexto2 = this.filtroTexto;
			// pone letreros informativos de los filtros que se usarán.
			this.banerFiltros = this.banerFiltros + ' (EN ' + campoSeleccionado + ' DE ' + this.filtroTexto + ' A ' + this.filtroTexto2 + ')';

			// aplica los filtros en el array registrosTodos y devuelve filtrado en esta computada solo los que estan en el rango señalado. el 1 lo agregamos para que funcione correcto el filtro
			return this.registrosTodos.filter(function (item) {
				return item[campoSeleccionado] >= _this4.filtroTexto && item[campoSeleccionado] <= _this4.filtroTexto2 + '1';
			});
		}
	}

});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sortus_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Inquilinos_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Propiedades_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Contratos_vue__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Movimientos_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Usuarios_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Inquilino_ver_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Inquilino_agregar_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Inquilino_editar_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Propiedad_ver_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Propiedad_agregar_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Propiedad_editar_vue__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Contrato_ver_vue__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Contrato_agregar_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Contrato_editar_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Contrato_estado_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Contratos_renovacion_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Movimiento_ver_vue__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Movimiento_agregar_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Propiedad_seleccionar_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Contratos_reporte_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Pagos_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Reporteador_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Usuario_agregar_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Usuario_editar_vue__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Formato_agregar_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Estados_de_cuenta_vue__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ReportesHechos__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Comprar_Rentus__ = __webpack_require__(17);




 // By Guillermo G. Ugalde Vergara











































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// SORTUS. AUTOR GUILLERO G. UGALDE VERGARA
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__Sortus_js__["a" /* default */]);

var routes = [{ path: '/inq', component: __WEBPACK_IMPORTED_MODULE_4__Inquilinos_vue__["a" /* default */] }, { path: '/pro', component: __WEBPACK_IMPORTED_MODULE_5__Propiedades_vue__["a" /* default */] }, { path: '/con', component: __WEBPACK_IMPORTED_MODULE_6__Contratos_vue__["a" /* default */] }, { path: '/mov', component: __WEBPACK_IMPORTED_MODULE_7__Movimientos_vue__["a" /* default */] }, { path: '/usu', component: __WEBPACK_IMPORTED_MODULE_8__Usuarios_vue__["a" /* default */] }, { path: '/pagos', component: __WEBPACK_IMPORTED_MODULE_24__Pagos_vue__["a" /* default */] }, { path: '/rep', component: __WEBPACK_IMPORTED_MODULE_25__Reporteador_vue__["a" /* default */] }, { path: '/inq-ver/id', name: 'ver-inqui', component: __WEBPACK_IMPORTED_MODULE_9__Inquilino_ver_vue__["a" /* default */] }, { path: '/inq-edi/id', name: 'edi-inqui', component: __WEBPACK_IMPORTED_MODULE_11__Inquilino_editar_vue__["a" /* default */] }, { path: '/inq-agrega', name: 'agre-inqui', component: __WEBPACK_IMPORTED_MODULE_10__Inquilino_agregar_vue__["a" /* default */] }, { path: '/pro-ver/id', name: 'ver-propi', component: __WEBPACK_IMPORTED_MODULE_12__Propiedad_ver_vue__["a" /* default */] }, { path: '/pro-edi/id', name: 'edi-propi', component: __WEBPACK_IMPORTED_MODULE_14__Propiedad_editar_vue__["a" /* default */] }, { path: '/pro-agrega', name: 'agre-propi', component: __WEBPACK_IMPORTED_MODULE_13__Propiedad_agregar_vue__["a" /* default */] }, { path: '/con-agrega', name: 'agre-con', component: __WEBPACK_IMPORTED_MODULE_16__Contrato_agregar_vue__["a" /* default */] }, { path: '/con-ver/id', name: 'ver-con', component: __WEBPACK_IMPORTED_MODULE_15__Contrato_ver_vue__["a" /* default */] }, { path: '/con-edi/id', name: 'edi-con', component: __WEBPACK_IMPORTED_MODULE_17__Contrato_editar_vue__["a" /* default */] }, { path: '/con-edo/id', name: 'edo-con', component: __WEBPACK_IMPORTED_MODULE_18__Contrato_estado_vue__["a" /* default */] }, { path: '/mov-agrega', name: 'agre-movi', component: __WEBPACK_IMPORTED_MODULE_21__Movimiento_agregar_vue__["a" /* default */] }, { path: '/mov-ver/id', name: 'ver-movi', component: __WEBPACK_IMPORTED_MODULE_20__Movimiento_ver_vue__["a" /* default */] }, { path: '/pro-sel', name: 'sel-pro', component: __WEBPACK_IMPORTED_MODULE_22__Propiedad_seleccionar_vue__["a" /* default */] }, { path: '/con-rep', name: 'rep-con', component: __WEBPACK_IMPORTED_MODULE_23__Contratos_reporte_vue__["a" /* default */] }, { path: '/usu-agrega', name: 'agre-usu', component: __WEBPACK_IMPORTED_MODULE_26__Usuario_agregar_vue__["a" /* default */] }, { path: '/usu-editar', name: 'edi-usu', component: __WEBPACK_IMPORTED_MODULE_27__Usuario_editar_vue__["a" /* default */] }, { path: '/for-agrega', name: 'agre-for', component: __WEBPACK_IMPORTED_MODULE_28__Formato_agregar_vue__["a" /* default */] }, { path: '/pagos/id', name: 'pago', component: __WEBPACK_IMPORTED_MODULE_24__Pagos_vue__["a" /* default */] }, { path: '/edos-cta', name: 'edos-de-cta', component: __WEBPACK_IMPORTED_MODULE_29__Estados_de_cuenta_vue__["a" /* default */] }, { path: '/leer-repor', name: 'repor-leer', component: __WEBPACK_IMPORTED_MODULE_30__ReportesHechos__["a" /* default */] }, { path: '/reno-cont', name: 'cont-reno', component: __WEBPACK_IMPORTED_MODULE_19__Contratos_renovacion_vue__["a" /* default */] }, { path: '/rent-comp', name: 'comp-rent', component: __WEBPACK_IMPORTED_MODULE_31__Comprar_Rentus__["a" /* default */] }];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: routes,
	mode: 'history'
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: router,
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */]);
	}
});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(56);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5), __webpack_require__(7)))

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.1.5
  * (c) 2020 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isExtendedError (constructor, err) {
  return (
    err instanceof constructor ||
    // _name is to support IE9 too
    (err && (err.name === constructor.name || err._name === constructor._name))
  )
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cachce
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    if (params.pathMatch) { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("RouterLink with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  window.history.replaceState({ key: getStateKey() }, '', absolutePath);
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && 'pushState' in window.history
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

var NavigationDuplicated = /*@__PURE__*/(function (Error) {
  function NavigationDuplicated (normalizedLocation) {
    Error.call(this);
    this.name = this._name = 'NavigationDuplicated';
    // passing the message to super() doesn't seem to work in the transpiled version
    this.message = "Navigating to current location (\"" + (normalizedLocation.fullPath) + "\") is not allowed";
    // add a stack property so services like Sentry can correctly display it
    Object.defineProperty(this, 'stack', {
      value: new Error().stack,
      writable: true,
      configurable: true
    });
    // we could also have used
    // Error.captureStackTrace(this, this.constructor)
    // but it only exists on node and chrome
  }

  if ( Error ) NavigationDuplicated.__proto__ = Error;
  NavigationDuplicated.prototype = Object.create( Error && Error.prototype );
  NavigationDuplicated.prototype.constructor = NavigationDuplicated;

  return NavigationDuplicated;
}(Error));

// support IE9
NavigationDuplicated._name = 'NavigationDuplicated';

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        this$1.ready = true;
        this$1.readyErrorCbs.forEach(function (cb) {
          cb(err);
        });
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    // after merging https://github.com/vuejs/vue-router/pull/2771 we
    // When the user navigates through history through back/forward buttons
    // we do not want to throw the error. We only throw it if directly calling
    // push/replace. That's why it's not included in isError
    if (!isExtendedError(NavigationDuplicated, err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort(new NavigationDuplicated(route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) {
            cb();
          });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key, cbs, isValid)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
      next(cb);
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (
    instances[key] &&
    !instances[key]._isBeingDestroyed // do not reuse being destroyed instance
  ) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    var this$1 = this;

    History.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = decodeURI(window.location.pathname);
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(
      supportsPushState ? 'popstate' : 'hashchange',
      function () {
        var current = this$1.current;
        if (!ensureSlash()) {
          return
        }
        this$1.transitionTo(getHash(), function (route) {
          if (supportsScroll) {
            handleScroll(this$1.router, route, current, true);
          }
          if (!supportsPushState) {
            replaceHash(route.fullPath);
          }
        });
      }
    );
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);
  // decode the hash but not the search or hash
  // as search(query) is already decoded
  // https://github.com/vuejs/vue-router/issues/2708
  var searchIndex = href.indexOf('?');
  if (searchIndex < 0) {
    var hashIndex = href.indexOf('#');
    if (hashIndex > -1) {
      href = decodeURI(href.slice(0, hashIndex)) + href.slice(hashIndex);
    } else { href = decodeURI(href); }
  } else {
    href = decodeURI(href.slice(0, searchIndex)) + href.slice(searchIndex);
  }

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        this$1.index = targetIndex;
        this$1.updateRoute(route);
      },
      function (err) {
        if (isExtendedError(NavigationDuplicated, err)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(
    to,
    current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.1.5';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9490cdc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(79);
function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9490cdc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(60);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("cf6875f6", content, true, {});

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#app1{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50}h1,h2{font-weight:400}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}a{color:#42b983}", ""]);

// exports


/***/ }),
/* 61 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var bind = __webpack_require__(9);
var Axios = __webpack_require__(63);
var mergeConfig = __webpack_require__(15);
var defaults = __webpack_require__(12);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(16);
axios.CancelToken = __webpack_require__(76);
axios.isCancel = __webpack_require__(11);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(77);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var buildURL = __webpack_require__(10);
var InterceptorManager = __webpack_require__(64);
var dispatchRequest = __webpack_require__(65);
var mergeConfig = __webpack_require__(15);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);
var transformData = __webpack_require__(66);
var isCancel = __webpack_require__(11);
var defaults = __webpack_require__(12);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(14);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(71);
var combineURLs = __webpack_require__(72);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(16);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"captura"}},[_c('br'),_vm._v(" "),_c('div',{staticClass:"tile is-ancestor"},[_c('div',{staticClass:"tile is-vertical is-8"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tile is-parent"},[_c('article',{staticClass:"tile is-child notification is-danger"},[_c('p',{staticClass:"title"},[_vm._v("Contacto")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("24 hrs")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_c('a',{attrs:{"mailto:":""}},[_vm._v("\n                        "+_vm._s(_vm.eMailVentas)+"\n                    ")])]),_vm._v("    \n                "),_c('span',[_c('a',{attrs:{"href":'http://wa.me/521' + _vm.wVentas,"target":"_blank"}},[_c('i',{staticClass:"fab fa-whatsapp fa-2x"})])])])])])]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile"},[_c('div',{staticClass:"tile is-parent is-vertical"},[_c('article',{staticClass:"tile is-child notification is-primary"},[_c('p',{staticClass:"title"},[_vm._v("Controle sus cobros")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("Alertas oportunas")]),_vm._v(" "),_c('p',[_vm._v("De moroso ")]),_vm._v(" "),_c('p',[_vm._v("De los que no pagaron nada este mes")]),_vm._v(" "),_c('p',[_vm._v("De vencimiento de contrato")]),_vm._v(" "),_c('p',[_vm._v("De desocupados")]),_vm._v(" "),_c('p',[_vm._v("Reciba alertas a su mail, o a su app")]),_vm._v(" "),_c('p',[_vm._v("App de control")])]),_vm._v(" "),_c('article',{staticClass:"tile is-child notification is-warning"},[_c('p',{staticClass:"title"},[_vm._v("Beneficios")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("Para su empresa")]),_vm._v(" "),_c('p',[_vm._v("Reportes personalizados")]),_vm._v(" "),_c('p',[_vm._v("Formateador personalizado")]),_vm._v(" "),_c('p',[_vm._v("Consultas con busqueda avanzada")]),_vm._v(" "),_c('p',[_vm._v("Contratos y pre-contratos")]),_vm._v(" "),_c('p',[_vm._v("Estados de cuenta a mails, en consulta o pdf")]),_vm._v(" "),_c('p',[_vm._v("Renovacion de contrato oportuno")]),_vm._v(" "),_c('p',[_vm._v("Tips expertos para rentar, para cobrar y renovar")]),_vm._v(" "),_c('p',[_vm._v("Sugerencias de renovaciones de contratos")]),_vm._v(" "),_c('p',[_vm._v("Facilidad para argos de otros servicios")]),_vm._v(" "),_c('p',[_vm._v("Configure usuarios con diferente nivel de autorizaciones")]),_vm._v(" "),_c('p',[_vm._v("Capture de forma simple sus cobros")]),_vm._v(" "),_c('p',[_vm._v("Acceso a whatsapp de inquilinos inmediato")]),_vm._v(" "),_c('p',[_vm._v("Soporte continuo y profesional")])])]),_vm._v(" "),_c('div',{staticClass:"tile is-parent"},[_c('article',{staticClass:"tile is-child notification is-info"},[_c('p',{staticClass:"title"},[_vm._v("Control total")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("Integral")]),_vm._v(" "),_c('figure',{staticClass:"image is-4by3"},[_c('img',{attrs:{"src":"https://www.directodo.com/Rentus/recursos/EDIFICIOS.jpg"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Descanse, todo bajo control")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-parent"},[_c('article',{staticClass:"tile is-child notification is-success"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"title"},[_vm._v("Precios")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("Pago mensual")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('form',{attrs:{"action":"https://www.paypal.com/cgi-bin/webscr","method":"post","target":"_top"}},[_c('input',{attrs:{"type":"hidden","name":"cmd","value":"_s-xclick"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"hosted_button_id","value":"AVYN2N8GF2TBY"}}),_vm._v(" "),_c('table',[_c('tr',[_c('td',[_c('input',{attrs:{"type":"hidden","name":"on0","value":"Número de inmuebles"}}),_vm._v("Número de inmuebles")])]),_c('tr',[_c('td',[_c('select',{attrs:{"name":"os0"}},[_c('option',{attrs:{"value":"Hasta 3"}},[_vm._v("Hasta 3 $960.00 MXN")]),_vm._v(" "),_c('option',{attrs:{"value":"Hasta 10"}},[_vm._v("Hasta 10 $3,300.00 MXN")]),_vm._v(" "),_c('option',{attrs:{"value":"Hasta 30"}},[_vm._v("Hasta 30 $6,600.00 MXN")]),_vm._v(" "),_c('option',{attrs:{"value":"Ilimitado"}},[_vm._v("Ilimitado $13,200.00 MXN")])])])]),_vm._v(" "),_c('tr',[_c('td',[_c('input',{attrs:{"type":"hidden","name":"on1","value":"Su email de contacto"}}),_vm._v("Su email de contacto")])]),_c('tr',[_c('td',[_c('input',{attrs:{"type":"text","name":"os1","maxlength":"200"}})])]),_vm._v(" "),_c('tr',[_c('td',[_c('input',{attrs:{"type":"hidden","name":"on2","value":"Su nombre o de la empresa"}}),_vm._v("Su nombre o de la empresa")])]),_c('tr',[_c('td',[_c('input',{attrs:{"type":"text","name":"os2","maxlength":"200"}})])])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"currency_code","value":"MXN"}}),_vm._v(" "),_c('input',{attrs:{"type":"image","src":"https://www.paypalobjects.com/es_XC/MX/i/btn/btn_buynowCC_LG.gif","border":"0","name":"submit","alt":"PayPal, la forma más segura y rápida de pagar en línea."}}),_vm._v(" "),_c('img',{attrs:{"alt":"","border":"0","src":"https://www.paypalobjects.com/es_XC/i/scr/pixel.gif","width":"1","height":"1"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app1"}},[_c('img',{attrs:{"src":"https://www.directodo.com/Rentus/recursos/rentusLogo180.jpg"}}),_vm._v(" "),_c('p',{attrs:{"center":""}},[_vm._v(_vm._s(_vm.version))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.pase != 'vealo')?_c('div',[_c('br'),_vm._v(" "),_c('h2',{staticClass:"title is-primary"},[_vm._v("Sistema de Control de rentas de inmuebles")]),_vm._v(" "),(!_vm.verComprar)?_c('button',{staticClass:"button",on:{"click":function($event){_vm.verComprar = !_vm.verComprar}}},[_vm._v("Conocer mas")]):_vm._e(),_vm._v(" "),(_vm.verComprar)?_c('button',{staticClass:"button",on:{"click":function($event){_vm.verComprar = !_vm.verComprar}}},[_vm._v("Regresar")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.verComprar)?_c('comprar-rentus'):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.verComprar)?_c('div',{attrs:{"id":"vista2"}},[_c('div',{staticStyle:{"background-color":"Gainsboro"}},[_c('br'),_vm._v(" "),_c('h3',[_vm._v("Pagar renta o Comprar Sistema RENTUS")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){return _vm.emem()}}},[_vm._v("Enviarme estado de cuenta a mi mail")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){return _vm.licfun()}}},[_vm._v("Documentos para la Licencia de Funcionamiento")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.checarUsuario($event)}}},[_c('table',{attrs:{"align":"center"}},[_c('tr',[_c('td',{attrs:{"align":"left"}},[_vm._v("Empresa")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.empresa),expression:"usuarios.empresa"}],attrs:{"type":"empresa","required":"","autofocus":"","name":"empresa"},domProps:{"value":(_vm.usuarios.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "empresa", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"left"}},[_vm._v("Mail ")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.mail),expression:"usuarios.mail"}],attrs:{"type":"email","required":"","name":"mail"},domProps:{"value":(_vm.usuarios.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "mail", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"left"}},[_vm._v("Password ")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.pasw),expression:"usuarios.pasw"}],attrs:{"type":"password","required":"","name":"pase"},domProps:{"value":(_vm.usuarios.pasw)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "pasw", $event.target.value)}}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.cargando)?_c('div',[_vm._v("Cargando ... "),_c('button',{staticClass:"button is-primary is-loading"})]):_vm._e(),_vm._v(" "),(_vm.pase == 'vealo' && !_vm.cargando)?_c('div',{staticClass:"columns is-desktop is-gapless is-vcentered"},[_c('div',{staticClass:"column"},[_c('router-link',{attrs:{"to":"/pro"}},[_vm._v("Propiedades")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-link',{attrs:{"to":"/inq"}},[_vm._v("Inquilinos")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-link',{attrs:{"to":"/con"}},[_vm._v("Contratos y Pre-Contratos")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-link',{attrs:{"to":"/mov"}},[_vm._v("Movimientos")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-link',{attrs:{"to":"/usu"}},[_vm._v("Usuarios")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-link',{attrs:{"to":"/pagos"}},[_vm._v("Pagos")])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('router-link',{attrs:{"to":"/rep"}},[_vm._v("Reporteador")])],1)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('router-view',{attrs:{"vector":_vm.permisos,"elusuario":_vm.usuarios.mail,"empresa":_vm.usuarios.empresa}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":"https://www.paypal.com/cgi-bin/webscr","method":"post","target":"_blank"}},[_c('input',{attrs:{"type":"hidden","name":"cmd","value":"_s-xclick"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"hosted_button_id","value":"296VWRSXHXA6J"}}),_vm._v(" "),_c('table',{attrs:{"align":"center","border":"1"}},[_c('tr',[_c('td',[_c('input',{attrs:{"type":"hidden","name":"on0","value":"Numero de contrato"}}),_vm._v("Numero de contrato\n                    ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('input',{attrs:{"type":"text","name":"os0","maxlength":"200"}})])]),_vm._v(" "),_c('tr',[_c('td',[_c('input',{attrs:{"type":"hidden","name":"on1","value":"Mi nombre"}}),_vm._v("Mi nombre\n                  ")])]),_vm._v(" "),_c('tr',[_c('td',[_c('input',{attrs:{"type":"text","name":"os1","maxlength":"200","size":"40px"}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"image","src":"https://www.paypalobjects.com/es_XC/MX/i/btn/btn_paynowCC_LG.gif","border":"0","name":"submit","alt":"PayPal, la forma más segura y rápida de pagar en línea."}}),_vm._v(" "),_c('img',{attrs:{"alt":"","border":"0","src":"https://www.paypalobjects.com/es_XC/i/scr/pixel.gif","width":"1","height":"1"}}),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_c('td',[_c('input',{staticClass:"button",attrs:{"type":"submit","value":"Entrar"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
		install: function install(Vue, options) {

				// SORTUS     V1.0
				//
				// It is a multiple keys sort. Order by dates, numerically or alphabetically
				// And aditionally SortusTotals returns the columns totals that you ask.
				//
				// How Sortus works ?
				//     It get two parameters. The main array to sort and the order array.
				//     Sortus return an ordered array as request.
				// 
				//     Parameter 1:
				//     It's an object or array to order.
				//
				//     Parameter 2:
				//     It's an array with the name of the keys to order.
				//     This is the simple sintaxis for the second parameter;
				//         By example; ("name+A","birthday-D",edge+N) 
				//                  means order by name asc alphabetically then by
				//                                 birthday desc by Date, then by
				//                                 edge asc Numerically.
				//      Sintaxis:
				//      [keyName][+ or -][A (alphabetically) or N (numerically) or D (date)], [nextKey][+ or -]....
				//
				//      By default the order is ascending and alphabetically
				//
				// Parameter2 examples;
				//
				// (name, edge, birthday) Order by name, then by edge and then by birthday all them 
				//                        asc and alphabetically.
				// (edge+, name-)         Order by edge asc alphabetically, then by name desc alphabetically.
				// (edge+N, name)         Order by edge asc numerically then by name asc alphabetically.
				// (edge-N, birthday+D)   Order by edge desc numerically then by birthday asc by date.
				//
				// (edge+N, name, birthday-D, class, zipcode+N) Order by edge asc Numerically then by name asc
				//                          alphabetically then by birthday desc by date then by class asc 
				//                          alphabetically then by zipcode asc numerically.
				//
				// 
				// SORTUS_TOTALS
				// Aditionally SortusTotals return the column's totals
				// How sortusTotals works ?
				//     It get two parameters. The main array to sort and the totals array.
				//     SortusTotals return an array with the totals asked.
				// 
				//     Parameter 1:
				//     It's an object or array to totalize.
				//
				//     Parameter 2:
				//     It's an array with the name of the keys to totalize.
				//     This is the simple sintaxis for the second parameter;
				//         By example; ("description", "stock*") 
				//                  means count the rows in description. Add the content of every row in stock
				//                                 
				//      Sintaxis:
				//      [keyName][*],[keyName][*],[keyName][*].....
				//
				//      By default it will count the rows. If you put the asterisc then it add the amount.
				//       
				// Some SortusTotals examples:
				// 
				// (name, city, sales)     Return the number of rows in name, also return the number of rows in
				//                         city, also return the number of rows in sales.
				// 
				// (stock*, zipCode)      Return the addition of the stock, also return the number of rows in zipCode.
				// 
				// Author: Ing: Guillermo Gerardo Ugalde Vergara  2018 - 2020     


				// ******************** SPANISH *********************************************************
				//
				// SORTUS      V1.0
				// ES UN SORT. ORDENA ALFABETICO, NUMERICO Y FECHAS.
				//
				// COMO FUNCIONA: RECIBE LA MATRIZ PRINCIPAL CON RENGLONES Y COLUMNAS
				// A ORDENAR COMO OBJETO. Y RECIBE OTRO ARRAY CON LOS NOMBRES (string) DE LAS
				// COLUMNAS QUE SE ORDENARÁN CON EL SIGUIENTE FORMATO:
				//
				//    ORDENARÁ LA PRIMER COLUMNA DE ESTE ARRAY Y ASI SUCESIVAMENTE
				//    CADA COLUMNA PUEDE TERMINAR HASTA CON 2 CARACTERES ADICIONALES,
				//    EL PRIMERO SERÁ UN SIGNO SEÑALANDO EL ORDEN (+ ASCENDENTE O - DESCENDENTE)
				//    EL SEGUNDO PODRÁ SER UNA LETRA (A ALFANUMERIC, N NUMERIC, D DATE).
				//    SI SE OMITEN EL DEFAULT SERÁ ASCENDENTE Y ALFANUMERICO.
				//
				// EJEMPLOS:
				// (articulo, talla, peso) ORDENARÁ PRIMERO POR ARTICULO, DESPÚES POR TALLA Y
				//                         LUEGO POR PESO. TODOS ALFABETICAMENTE Y ASCENDENTE
				// (peso+, articulo-)      ORDENARA PRIMERO POR PESO ASCENDENTE, DESPUÉS POR 
				//                         ARTÍCULO DESCENDENTEMENTE.
				// (talla+N, articulo)     ORDENARÁ PRIMERO POR TALLA ASCENDENTE Y NUMERICAMENTE
				//                         Y DESPÚES POR ARTÍCULO ASCENDENTE ALFABETICAMENTE.
				// (talla-N, uso+D)        ORDENARÁ PRIMERO POR TALLA DESCENDENTE Y NUMERICAMENTE
				//                         Y DESPÚES POR USO ASCENDENTE Y TOMARÁ ESTE CAMPO COMO FECHA.
				// (talla+n, articulo-, uso-d) ORDENARÁ PRIMERO POR TALLA ASCENDENTE NUMERICO,
				//                         DESPUÉS POR ARTÍCULO DESCENDENTE ALFABETICO Y POR ÚLTIMO
				//                         POR USO DESCENDENTE Y TOMARÁ ESTE CAMPO COMO FECHA.
				//
				// 
				// SORTUS_TOTALS
				// Es la parte que regresa los totales de las columnas recibidas
				// COMO FUNCIONA; RECIBE LA MATRIZ PRINCIPAL CON RENGLONES Y COLUMNAS
				// A TOTALIZAR COMO OBJETO. Y RECIBE OTRO ARRAY CON LOS NOMBRES (STRING) DE LAS
				// COLUMNAS QUE SE TOTALIZARAN CON EL SIGUIENTE FORMATO
				//     
				//    TOTALIZARA LA PRIMER COLUMNA DE ESTE ARRAY Y ASI SUCESIVAMENTE
				//    CADA COLUMNA. PODRA TERMINAR CON UN * PARA INDICAR QUE ESTA COLUMNA
				//    SE SUMARA EN LUGAR DE SOLO CONTAR LOS RENGLONES.
				//
				// EJEMPLOS:
				// (nombre, ciudad, venta) CONTARA CUANTOS REGISTROS HAY DE CADA UNA DE ESTAS COL
				// 
				// (existencia*, codigo)   SUMARA LAS CANTIDADES DE existencia Y DESPUES CONTARA CUANTOS
				//                         codigo HAY.
				// 
				// Author: Ing: Guillermo Gerardo Ugalde Vergara  2018 - 2020  

				// variables globales
				var columna = '';
				var direccion = '+';
				var tipo = 'A';

				var matriz = [];
				var columnasAordenar = [];

				var matrizT = [];
				var columnasAtotalizar = [];

				Vue.prototype.$sortus = function (matrizPrincipal, columnasQueSeOrdenaran) {
						var x, y, x1, y1;
						var renglon;

						if (!matrizPrincipal || matrizPrincipal == "") {
								console.log("SORTUS parameter1 not present");
								return "SORTUS Parameter 1 not present";
						}

						if (!columnasQueSeOrdenaran || columnasQueSeOrdenaran == "") {
								console.log("SORTUS parameter2 not present or empty. Default 0");
								columnasQueSeOrdenaran = ["0"]; // le da un valor por default columna 0
						}

						// LA MATRIZ A ORDENAR LLEGA COMO OBJETO
						matriz = matrizPrincipal; // es necesaria para manejarla local
						columnasAordenar = columnasQueSeOrdenaran; // es necesaria para manejarla local

						desglosar(columnasAordenar[0]); // pasa el primer elemento

						// delRenglonNum, alRenglonNum, enColNum,indiceCol
						sortusInicia(0, matriz.length - 1, columna, 0);

						return matriz; // regresa matriz ya ordenada
				};

				Vue.prototype.$sortusTotals = function (matrizRecibida, columnasQueSeTotalizaran) {
						// sortus-totals suma el importe de las columnas especificadas 
						// en el arreglo columnasQueSeTotalizaran sobre la matrizRecibida

						// Valida si existen los 2 parametros
						if (!matrizRecibida || matrizRecibida == "") {
								console.log("SortusTotals parameter1 not present");
								return "SortusTotals Parameter 1 not present";
						}
						if (!columnasQueSeTotalizaran || columnasQueSeTotalizaran == "") {
								console.log("SortusTotals parameter2 not present");
								return "SortusTotals Parameter 2 not present";
						}

						var columnasConTotales = [];

						for (var indice in columnasQueSeTotalizaran) {
								// recorre el arreglo que trae los nombres de las col que se totalizaran

								var nombreDeLaColumna = columnasQueSeTotalizaran[indice]; // es el nombre de la col que se totalizara
								var sumaCol = 0;
								var sumar = false;

								// checa si se sumara o se contara esta columna
								if (nombreDeLaColumna.includes("*")) {
										nombreDeLaColumna = nombreDeLaColumna.replace("*", "");
										sumar = true;
								}

								// recorre la matriz. Empieza por los renglones
								for (var indice in matrizRecibida) {
										var renglon = matrizRecibida[indice];

										// recorremos un renglon, los campos
										for (var columnaDelRenglon in renglon) {

												if (columnaDelRenglon == nombreDeLaColumna) {
														// checa si es columna a totalizar

														var contenido = renglon[columnaDelRenglon];

														// checa si se contara o se sumara
														if (sumar) {
																sumaCol = sumaCol + Number(contenido);
														} else sumaCol = sumaCol + 1;
												}
										}
								}

								// agrega el total de la columna al arreglo de totales de columnas
								columnasConTotales.push(sumaCol);
								sumaCol = 0;
						}

						// regresa el arreglo con los totales

						return columnasConTotales;
				};

				function desglosar(elemento) {
						// Separa la columna y decide si es ascendente o descendente y si es fecha, numero o alfabetico el ordenamiento
						// cada vez que se llama 
						// cambia las variables globales columna, direccion y tipo

						columna = '';
						direccion = '+';
						tipo = 'A';

						if (!elemento.includes("+") && !elemento.includes("-")) {
								// solo hay caracteres
								columna = elemento;
								direccion = '+'; // + ASCENDENTE
								tipo = 'A'; // Alfabetico o Numerico o Date
						} else {
								// escanea para saber cual es la parte antes del mas o menos
								var n = 0;

								if (elemento.includes('+')) {
										n = elemento.indexOf('+');
								}
								if (elemento.includes("-")) {
										n = elemento.indexOf("-");
								}

								columna = elemento.substring(0, n);
								direccion = elemento.substring(n, n + 1);

								if (n + 1 == elemento.length) {
										tipo = 'A';
								} else {
										tipo = elemento.slice(-1);
								}
						}
				}

				function sortusInicia(delRenglon, alRenglon, enLaColumnaNum, indiceCol) {
						// se llama cada vez que se requiere ordenar registros

						desglosar(columnasAordenar[indiceCol]);

						sortusOrdena(delRenglon, alRenglon, columna, direccion, tipo);
						sortusIguales(delRenglon, alRenglon - 1, columna, indiceCol);
				}

				function sortusOrdena(desde1, alRenglon, en_columna1, dir1, tipo1) {
						var ordenando = 1;
						var cambio = "";
						var el_renglon1 = 0;
						var uno,
						    dos = '';

						while (ordenando == 1) {

								cambio = "NO";
								el_renglon1 = Number(desde1);

								while (Number(el_renglon1) <= Number(alRenglon) - 1) {

										uno = matriz[el_renglon1][en_columna1];

										try {
												dos = matriz[el_renglon1 + 1][en_columna1];
										} catch (error) {
												dos = uno;
										}

										if (tipo.toUpperCase() == 'A' || !tipo.toUpperCase() == 'D' && !tipo.toUpperCase() == 'N') {
												// ES ALFABETICO

												if (direccion.includes('-')) {
														// ES ORDEN DESCENDENTE 
														if (uno.toUpperCase() < dos.toUpperCase()) {
																// hace el intercambio
																//matriz[el_renglon1][en_columna1] = dos;
																//matriz[el_renglon1 + 1][en_columna1] = uno;
																var renglonMomentaneo = matriz[el_renglon1];
																matriz[el_renglon1] = matriz[el_renglon1 + 1];
																matriz[el_renglon1 + 1] = renglonMomentaneo;
																cambio = "SI";
														}
												} else {
														// ES ORDEN ASCENDENTE
														if (uno.toUpperCase() > dos.toUpperCase()) {
																// hace el intercambio
																//matriz[el_renglon1][en_columna1] = dos;
																//matriz[el_renglon1 + 1][en_columna1] = uno;	 							
																var renglonMomentaneo = matriz[el_renglon1];
																matriz[el_renglon1] = matriz[el_renglon1 + 1];
																matriz[el_renglon1 + 1] = renglonMomentaneo;
																cambio = "SI";
														}
												}
										}

										if (tipo.toUpperCase() == 'N') {
												// ES NUMERICO EL ORDEN DE LA COLUMNA.

												if (direccion.includes('-')) {
														// ES ORDEN DESCENDENTE 
														if (Number(uno) < Number(dos)) {
																// hace el intercambio
																//matriz[el_renglon1][en_columna1] = dos;
																//matriz[el_renglon1 + 1][en_columna1] = uno;	
																var renglonMomentaneo = matriz[el_renglon1];
																matriz[el_renglon1] = matriz[el_renglon1 + 1];
																matriz[el_renglon1 + 1] = renglonMomentaneo;
																cambio = "SI";
														}
												} else {
														// ES ORDEN ASCENDENTE
														if (Number(uno) > Number(dos)) {
																// hace el intercambio
																//matriz[el_renglon1][en_columna1] = dos;
																//matriz[el_renglon1 + 1][en_columna1] = uno;		 
																var renglonMomentaneo = matriz[el_renglon1];
																matriz[el_renglon1] = matriz[el_renglon1 + 1];
																matriz[el_renglon1 + 1] = renglonMomentaneo;
																cambio = "SI";
														}
												}
										}

										if (tipo.toUpperCase() == 'D') {
												// ES FECHAS (viene en formato AAAA-MM-DD HH:MM:SS)
												var fecha1 = new Date(uno);
												var fecha2 = new Date(dos);

												var fech1 = fecha1.getTime(); // a milisegundos
												var fech2 = fecha2.getTime(); // a milisegundos

												if (direccion.includes('-')) {
														// ES ORDEN DESCENDENTE 
														if (fech1 < fech2) {
																// hace el intercambio
																// matriz[el_renglon1][en_columna1] = dos;
																// matriz[el_renglon1 + 1][en_columna1] = uno;
																var renglonMomentaneo = matriz[el_renglon1];
																matriz[el_renglon1] = matriz[el_renglon1 + 1];
																matriz[el_renglon1 + 1] = renglonMomentaneo;
																cambio = "SI";
														}
												} else {
														// ES ORDEN ASCENDENTE
														if (fech1 > fech2) {
																// hace el intercambio
																//matriz[el_renglon1][en_columna1] = dos;
																//matriz[el_renglon1 + 1][en_columna1] = uno;
																var renglonMomentaneo = matriz[el_renglon1];
																matriz[el_renglon1] = matriz[el_renglon1 + 1];
																matriz[el_renglon1 + 1] = renglonMomentaneo;
																cambio = "SI";
														}
												}
										}

										el_renglon1 = Number(el_renglon1) + 1;
								}

								if (cambio == "NO") {
										ordenando = 0;
								}
						}
				}

				function sortusIguales(desde_renglon, hasta_renglon, en_columna, indiceCol) {
						var hay_iguales = 'no';
						var iguales = 1;
						var el_primer_igual = 'si';
						var igual_hasta,
						    igual_desde = 0;
						var cont_renglon = Number(desde_renglon);
						var este,
						    x,
						    y,
						    siguiente,
						    existe = 0;

						while (cont_renglon <= Number(hasta_renglon) + 1) {
								// lee los elementos a comparar como iguales
								try {
										x = matriz[Number(cont_renglon)];
										este = x[en_columna];
								} catch (err) {
										este = 'fuera del limite';
								}

								try {
										y = matriz[Number(cont_renglon) + 1];
										siguiente = y[en_columna];
								} catch (err) {
										siguiente = 'ya fin';
								}

								if (este == siguiente) {
										hay_iguales = 'si';
										iguales = iguales + 1;

										if (el_primer_igual == 'si') {
												igual_desde = Number(cont_renglon);
												el_primer_igual = 'no';
										}
								}

								if (este != siguiente && hay_iguales == 'si') {
										igual_hasta = Number(igual_desde) + Number(iguales) - 1;

										try {
												desglosar(columnasAordenar[indiceCol + 1]);
												existe = matriz[0][Number(columna + 1)];
										} catch (err) {
												existe = 'no';
										}

										if (existe != 'no') {
												desglosar(columnasAordenar[indiceCol + 1]);
												sortusInicia(Number(igual_desde), Number(igual_hasta), columna, indiceCol + 1);
										}

										iguales = 1;
										el_primer_igual = 'si';
										hay_iguales = 'no';
								}

								cont_renglon = Number(cont_renglon) + 1;
						}
				}
		}
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquilinos_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b40b60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquilinos_vue__ = __webpack_require__(84);
function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquilinos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72b40b60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquilinos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(83);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6cb251fb", content, true, {});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Inquilinos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","placeholder":"BUSCAR"},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"id":"agregar","to":{name: 'agre-inqui'}}},[_vm._v("Agregar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.inquilinosTodos !=null)?_c('table',{staticClass:"table is-striped is-hoverable",attrs:{"id":"inquilinos-lista","align":"center"}},[_c('tbody',[_vm._m(0),_vm._v(" "),_vm._l((_vm.buscando),function(inquili){return _c('tr',[_c('td',[_vm._v(_vm._s(inquili.nombreCompleto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquili.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquili.celular))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquili.status))]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"id":"ver","to":{name: 'ver-inqui', params:{id:inquili.id}}}},[_vm._v("Ver")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"id":"editar","to":{name: 'edi-inqui', params:{id:inquili.id}}}},[_vm._v("Editar")])],1)])})],2)]):_c('span',[_c('button',{staticClass:"button is-primary is-loading"},[_vm._v("Loading")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Nombre")]),_vm._v(" "),_c('th',[_vm._v("Mail")]),_vm._v(" "),_c('th',[_vm._v("Cel")]),_vm._v(" "),_c('th',[_vm._v("Status")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedades_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0ad112_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedades_vue__ = __webpack_require__(88);
function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedades_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0ad112_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedades_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(87);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1b461dad", content, true, {});

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Propiedades")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","placeholder":"BUSCAR"},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"id":"agrega","to":{name: 'agre-propi'}}},[_vm._v("Agregar")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.propiedadesTodas !=null)?_c('table',{staticClass:"table is-striped is-hoverable",attrs:{"id":"inquilinos-lista","align":"center"}},[_c('tbody',[_vm._m(0),_vm._v(" "),_vm._l((_vm.buscando),function(propi){return _c('tr',[_c('td',[_vm._v(_vm._s(propi.familia)),_c('br'),_vm._v(" "+_vm._s(propi.subfamilia)+"  "),_c('br'),_vm._v(" Id:"+_vm._s(propi.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propi.dueno)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propi.nombreCompleto))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propi.dirCalle))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propi.dirNumero))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propi.metrosCuadrados))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propi.tipo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formateaNumero(propi.ultimaRenta)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formateaNumero(propi.saldo)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propi.fechaSaldo))]),_vm._v(" "),(propi.status == 'DISPONIBLE')?_c('td',[_c('b',[_vm._v(_vm._s(propi.status)),_c('br'),_vm._v(" "+_vm._s(propi.giro))])]):_c('td',[_vm._v(_vm._s(propi.status)),_c('br'),_vm._v(" "+_vm._s(propi.giro))]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"id":"ver","to":{name: 'ver-propi', params:{id:propi.id}}}},[_vm._v("Ver")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"id":"editar","to":{name: 'edi-propi', params:{id:propi.id}}}},[_vm._v("Editar")])],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"id":"editar","to":{name: 'edi-propi', params:{id:propi.id}}}},[_vm._v("Crear QR")])],1)])})],2)]):_c('span',[_c('button',{staticClass:"button is-primary is-loading"},[_vm._v("Loading")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Familia/SubF")]),_vm._v(" "),_c('th',[_vm._v("Dueño")]),_vm._v(" "),_c('th',[_vm._v("Nombre")]),_vm._v(" "),_c('th',[_vm._v("Calle")]),_vm._v(" "),_c('th',[_vm._v("Num.")]),_vm._v(" "),_c('th',[_vm._v("M2")]),_vm._v(" "),_c('th',[_vm._v("Tipo")]),_vm._v(" "),_c('th',[_vm._v("Renta")]),_vm._v(" "),_c('th',[_vm._v("Saldo")]),_vm._v(" "),_c('th',[_vm._v("Fecha saldo")]),_vm._v(" "),_c('th',[_vm._v("Status")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contratos_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8de5d26_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contratos_vue__ = __webpack_require__(93);
function injectStyle (ssrContext) {
  __webpack_require__(90)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contratos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8de5d26_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contratos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(91);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("5d0e306c", content, true, {});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contra-editar"}},[_c('h2',[_vm._v("Editar contrato")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.guardarContrato($event)}}},[_c('table',{staticClass:"table",attrs:{"align":"center"}},[_c('tbody',[_c('tr',[_c('td',[_vm._v("inquilino ")]),_c('td',[_vm._v(_vm._s(_vm.contratos.inquilinoId))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("propiedad ")]),_c('td',[_vm._v(_vm._s(_vm.contratos.propiedadId))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("inquilino")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.inquilino),expression:"contratos.inquilino"}],staticStyle:{"width":"200%"},attrs:{"type":"text","name":"inquilino","disabled":""},domProps:{"value":(_vm.contratos.inquilino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "inquilino", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("propiedad")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.propiedad),expression:"contratos.propiedad"}],staticStyle:{"width":"200%"},attrs:{"type":"text","name":"propiedad","disabled":""},domProps:{"value":(_vm.contratos.propiedad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "propiedad", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("nombreComercial")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.nombreComercial),expression:"contratos.nombreComercial"}],attrs:{"type":"text","name":"nombreComercial","disabled":""},domProps:{"value":(_vm.contratos.nombreComercial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "nombreComercial", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("giro")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.giro),expression:"contratos.giro"}],attrs:{"type":"text","name":"giro","disabled":""},domProps:{"value":(_vm.contratos.giro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "giro", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("familia")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.familia),expression:"contratos.familia"}],attrs:{"type":"text","name":"famila","disabled":""},domProps:{"value":(_vm.contratos.familia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "familia", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("inicio contrato")]),_c('td',[_vm._v(_vm._s(_vm.formateaFecha(_vm.contratos.fechaInicio )))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("importe Mes")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.importeMes),expression:"contratos.importeMes"}],attrs:{"type":"number","name":"importeMes","min":"100","required":""},domProps:{"value":(_vm.contratos.importeMes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "importeMes", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("depositar A")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.depositarA),expression:"contratos.depositarA"}],attrs:{"type":"text","name":"depositarA","min":"100"},domProps:{"value":(_vm.contratos.depositarA)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "depositarA", $event.target.value)}}})])]),_vm._v(" "),(_vm.contratos.status != 'PRE-CONTRATO')?_c('tr',[_c('td',[_vm._v("Status")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.status),expression:"contratos.status"}],attrs:{"id":"status","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.contratos, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"RENTADO"}},[_vm._v("RENTADO")]),_vm._v(" "),_c('option',{attrs:{"value":"FINALIZADO"}},[_vm._v("FINALIZADO")]),_vm._v(" "),_c('option',{attrs:{"value":"EN JURIDICO"}},[_vm._v("EN JURIDICO")])]),_vm._v(_vm._s(_vm.contratos.status)+"\n\t\t\t\t\t")])]):_vm._e(),_vm._v(" "),(_vm.contratos.status == 'FINALIZADO')?_c('tr',[_c('td',[_vm._v("Finalizo")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.finalizo),expression:"contratos.finalizo"}],attrs:{"type":"date","name":"fin"},domProps:{"value":(_vm.contratos.finalizo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "finalizo", $event.target.value)}}}),_vm._v(_vm._s(_vm.formateaFecha(_vm.contratos.finalizo)))])]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"submit","name":"guardaContrato","value":"Enviar"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Contratos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v(" Ver tambien PRE-CONTRATOS Y FINALIZADOS   "),_c('input',{attrs:{"type":"checkbox","id":"incluyePreFinalizados"},on:{"click":function($event){return _vm.cambioIncluye()}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","placeholder":"BUSCAR"},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"id":"agregar","to":{name: 'agre-con'}}},[_c('br'),_c('br'),_vm._v("Agregar Contrato o Pre-Contrato\n\t\t\t")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"id":"edos","to":{name: 'edos-de-cta'}}},[_c('br'),_c('br'),_vm._v("Estados de Cuenta \n\t\t\t")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"id":"impri","to":{name: 'agre-for'}}},[_c('br'),_c('br'),_vm._v("Imprimir Contrato o Pre-Contrato \n\t\t\t")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"id":"renovacion","to":{name: 'cont-reno'}}},[_c('br'),_c('br'),_vm._v("Renovación de contratos \n            ")])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.contratosTodos !=null)?_c('div',{attrs:{"id":"contratos-lista","align":"left"}},_vm._l((_vm.buscando),function(contrat){return _c('div',[(_vm.verTodos == true || (_vm.verTodos == false && contrat.status == 'RENTADO'))?_c('div',{staticClass:"box "},[_c('strong',[_c('p',[_vm._v("Contrato # "+_vm._s(contrat.id))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(contrat.propiedad))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(contrat.inquilino))]),_vm._v(" "),_c('font',{attrs:{"color":"blue"}},[(contrat.familia)?_c('p',[_vm._v(_vm._s(contrat.familia))]):_vm._e(),_vm._v(" "),(contrat.subfamilia)?_c('p',[_vm._v("Sub familia:"+_vm._s(contrat.subfamilia))]):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(contrat.nombreComercial))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(contrat.giro))])]),_vm._v(" "),_c('p',[_vm._v("Renta mensual: $ "+_vm._s(_vm.formateaNumero(contrat.importeMes)))]),_vm._v(" "),_c('br'),_vm._v(" "),(contrat.status != 'PRE-CONTRATO')?_c('p',[_vm._v("             \n                            "),(contrat.status == 'RENTADO')?_c('font',{attrs:{"color":"blue"}},[_vm._v("Status: "+_vm._s(contrat.status)+" "+_vm._s(contrat.finalizo)+"\n                            ")]):_vm._e(),_vm._v(" "),(contrat.status == 'FINALIZADO')?_c('font',{attrs:{"color":"red"}},[_vm._v("Status: "+_vm._s(contrat.status)+" "+_vm._s(contrat.finalizo)+"\n                            ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(contrat.status == 'PRE-CONTRATO')?_c('p',[_vm._v("             \n                            "),_c('font',{attrs:{"color":"orange"}},[_vm._v("Status: "+_vm._s(contrat.status)+" "+_vm._s(contrat.finalizo)+"\n                            ")])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("INICIO CONTRATO: "+_vm._s(_vm.formateaFecha(contrat.fechaInicio)))]),_vm._v(" "),_c('p',[_vm._v("TERMINA CONTRATO: "+_vm._s(_vm.formateaFecha(contrat.fechaTerminacion)))]),_vm._v(" "),_c('p',[_c('font',{attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.vencido(contrat.fechaTerminacion, contrat.status)))])],1)],1),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{name: 'ver-con', params:{id:contrat.id}}}},[_c('button',{staticClass:"button is-primary"},[_vm._v(" Ver")])]),_vm._v(" \n\n\t\t\t\t\t  \t"),(contrat.status != 'PRE-CONTRATO')?_c('router-link',{attrs:{"to":{name: 'edo-con', params:{id:contrat.id}}}},[_c('button',{staticClass:"button is-primary"},[_vm._v(" Estado de Cuenta ")])]):_vm._e(),_vm._v(" \n\n\t\t\t\t\t  \t"),(contrat.status != 'PRE-CONTRATO' && contrat.status == 'RENTADO' )?_c('router-link',{attrs:{"to":{name: 'pago', params:{id:contrat.id, inum:contrat.inquilinoId, pnum:contrat.propiedadId , ino:contrat.inquilino , pno:contrat.propiedad , gir:contrat.giro, fam:contrat.familia , subf:contrat.subfamilia , dueno:contrat.dueno, mail:contrat.emailInquilino, rentaMes:contrat.importeMes} }}},[_c('button',{staticClass:"button is-primary"},[_vm._v("Pagar ")])]):_vm._e(),_vm._v(" \n                        "),_c('br'),_c('br')],1),_c('div',{on:{"click":function($event){return _vm.verContrato(contrat.id)}}},[_c('button',{staticClass:"button is-primary"},[_vm._v("Editar Contrato")])]),_vm._v(" "),(_vm.verIndividual == true && _vm.cualContratoVer == contrat.id)?_c('div',{attrs:{"id":"verIndi","align":"center"}},[_c('button',{staticClass:"button is-warning",on:{"click":function($event){_vm.verIndividual = false}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('editar-individual',{attrs:{"cualContrato":_vm.numContrato,"vector":_vm.vector},on:{"cerrar":function($event){_vm.verIndividual = false}}}),_vm._v(" "),_c('br'),_c('br')],1):_vm._e(),_c('br'),_vm._v(" "),_c('p')]):_vm._e()])}),0):_c('span',[_c('button',{staticClass:"button is-primary is-loading"},[_vm._v("Loading ...")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Movimientos_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ed12584_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Movimientos_vue__ = __webpack_require__(97);
function injectStyle (ssrContext) {
  __webpack_require__(95)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Movimientos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ed12584_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Movimientos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(96);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("cefa981a", content, true, {});

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Movimientos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","placeholder":"BUSCAR"},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"id":"agrega","to":{name: 'agre-movi'}}},[_vm._v("Agregar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.movimientosTodos !=null)?_c('table',{staticClass:"table is-striped is-hoverable",attrs:{"align":"center","id":"todos"}},[_c('tbody',[_vm._m(0),_vm._v(" "),_vm._l((_vm.buscando),function(movi){return _c('tr',[_c('td',[_vm._v(_vm._s(movi.tipo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.contrato))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.inquilinoNombre))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.propiedadNombre))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.giro))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.familia))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.concepto))]),_vm._v(" "),_c('td',[_c('p',{attrs:{"align":"right"}},[_vm._v("$ "+_vm._s(_vm.formateaNumero(movi.importe)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formateaFecha(movi.fecha)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.formaDePago))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.referencia))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.refDeposito))])])})],2)]):_c('span',[_c('button',{staticClass:"button is-primary is-loading"},[_vm._v("Loading")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Tipo")]),_vm._v(" "),_c('th',[_vm._v("Contrato")]),_vm._v(" "),_c('th',[_vm._v("Inquilino")]),_vm._v(" "),_c('th',[_vm._v("Propiedad")]),_vm._v(" "),_c('th',[_vm._v("Giro")]),_vm._v(" "),_c('th',[_vm._v("Familia")]),_vm._v(" "),_c('th',[_vm._v("Concepto")]),_vm._v(" "),_c('th',[_vm._v("Importe")]),_vm._v(" "),_c('th',[_vm._v("Fecha")]),_vm._v(" "),_c('th',[_vm._v("Forma")]),_vm._v(" "),_c('th',[_vm._v("Ref.")]),_vm._v(" "),_c('th',[_vm._v("Ref. Dep.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727646c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuarios_vue__ = __webpack_require__(101);
function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_727646c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(100);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3ccbe8a3", content, true, {});

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#propiedades-lista{padding:20px}#propiedades-lista li{width:100%;height:100%;background:#eee;text-align:left;overflow:hidden}", ""]);

// exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Usuarios")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"id":"agrega","to":{name: 'agre-usu'}}},[_vm._v("Agregar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.usuariosTodos !=null)?_c('ul',{attrs:{"id":"usuarios-lista"}},_vm._l((_vm.usuariosTodos),function(usuari){return _c('li',[_c('strong',[_c('p',[_vm._v(_vm._s(usuari.nombreCompleto))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(usuari.mail))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(usuari.celular))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(usuari.whatsapp))]),_vm._v(" "),_c('p',[_vm._v("status: "+_vm._s(usuari.status))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"id":"editar","to":{name: 'edi-usu', params:{idparam:usuari.idu}}}},[_vm._v("Editar")])],1)])}),0):_c('span',[_vm._v("Cargando usuarios...")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquilino_ver_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8d0a7b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquilino_ver_vue__ = __webpack_require__(105);
function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquilino_ver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8d0a7b4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquilino_ver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(104);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("36e0e4d0", content, true, {});

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "table #todos1{font-family:arial,sans-serif;border-collapse:collapse;width:100%}th,tr{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(2n){background-color:#ddd}", ""]);

// exports


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Inquilino # "+_vm._s(this.id))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"captura"}},[(_vm.inquilinoSolo !=null)?_c('div',{attrs:{"name":"inquilino-ver"}},_vm._l((_vm.inquilinoSolo),function(inquilinos){return _c('table',{attrs:{"name":"todos1","align":"center"}},[_c('tr',[_c('td',[_vm._v("id:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.id))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("nombreCompleto:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.nombreCompleto))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("email:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.email))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("celular:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.celular))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("telefonoFijo:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.telefonoFijo))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("whatsapp:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.whatsapp))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("facebook:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.facebook))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCalle:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.dirCalle))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirNumero:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.dirNumero))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirInterior:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.dirInterior))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirColonia:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.dirColonia))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCodigo:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.dirCodigo))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCiudad:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.dirCiudad))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirEstado:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.dirEstado))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("status:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.status))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("fechaModifica:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.fechaModifica))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("quienModifico:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inquilinos.quienModifico))])])])}),0):_c('span',[_vm._v("Cargando inquilino")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquilino_agregar_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563e3300_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquilino_agregar_vue__ = __webpack_require__(107);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquilino_agregar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_563e3300_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquilino_agregar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"captura"}},[_c('h2',[_vm._v("AGREGAR INQUILINO")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.guardarInquilino($event)}}},[_c('table',{attrs:{"align":"center"}},[_c('tr',[_c('td',[_vm._v("Nombre completo ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.nombreCompleto),expression:"inquilinos.nombreCompleto"}],attrs:{"type":"text","name":"nombreCompleto","required":"","autofocus":""},domProps:{"value":(_vm.inquilinos.nombreCompleto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "nombreCompleto", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Email ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.email),expression:"inquilinos.email"}],attrs:{"type":"email","name":"email","required":""},domProps:{"value":(_vm.inquilinos.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "email", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Celular ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.celular),expression:"inquilinos.celular"}],attrs:{"type":"tel","name":"celular","required":""},domProps:{"value":(_vm.inquilinos.celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "celular", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Telefono fijo ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.telefonoFijo),expression:"inquilinos.telefonoFijo"}],attrs:{"type":"tel","name":"telefonoFijo"},domProps:{"value":(_vm.inquilinos.telefonoFijo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "telefonoFijo", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Whatsapp ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.whatsapp),expression:"inquilinos.whatsapp"}],attrs:{"type":"tel","name":"whatsapp","required":""},domProps:{"value":(_vm.inquilinos.whatsapp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "whatsapp", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Facebook ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.facebook),expression:"inquilinos.facebook"}],attrs:{"type":"text","name":"facebook"},domProps:{"value":(_vm.inquilinos.facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "facebook", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Calle ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirCalle),expression:"inquilinos.dirCalle"}],attrs:{"type":"text","name":"dirCalle","required":""},domProps:{"value":(_vm.inquilinos.dirCalle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirCalle", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Numero ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirNumero),expression:"inquilinos.dirNumero"}],attrs:{"type":"text","name":"dirNumero","required":""},domProps:{"value":(_vm.inquilinos.dirNumero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirNumero", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Interior ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirInterior),expression:"inquilinos.dirInterior"}],attrs:{"type":"text","name":"dirInterior"},domProps:{"value":(_vm.inquilinos.dirInterior)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirInterior", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Colonia ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirColonia),expression:"inquilinos.dirColonia"}],attrs:{"type":"text","name":"dirColonia","required":""},domProps:{"value":(_vm.inquilinos.dirColonia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirColonia", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Codigo ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirCodigo),expression:"inquilinos.dirCodigo"}],attrs:{"type":"number","name":"dirCodigo","required":"","minlength":"5"},domProps:{"value":(_vm.inquilinos.dirCodigo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirCodigo", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Ciudad ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirCiudad),expression:"inquilinos.dirCiudad"}],attrs:{"type":"text","name":"dirCiudad","required":""},domProps:{"value":(_vm.inquilinos.dirCiudad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirCiudad", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Estado ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirEstado),expression:"inquilinos.dirEstado"}],attrs:{"type":"text","name":"dirEstado","required":""},domProps:{"value":(_vm.inquilinos.dirEstado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirEstado", $event.target.value)}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"submit","name":"agregandoInquilino"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquilino_editar_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127b463a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquilino_editar_vue__ = __webpack_require__(109);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquilino_editar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127b463a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquilino_editar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"inqui-editar"}},[_c('h2',[_vm._v("EDITAR INQUILINO")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.guardarInquilino($event)}}},[_c('table',{attrs:{"align":"center"}},[_c('tr',[_c('td',[_vm._v("nombreCompleto")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.nombreCompleto),expression:"inquilinos.nombreCompleto"}],attrs:{"type":"text","name":"nombreCompleto"},domProps:{"value":(_vm.inquilinos.nombreCompleto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "nombreCompleto", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("email")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.email),expression:"inquilinos.email"}],attrs:{"type":"text","name":"email"},domProps:{"value":(_vm.inquilinos.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "email", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("celular")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.celular),expression:"inquilinos.celular"}],attrs:{"type":"text","name":"celular"},domProps:{"value":(_vm.inquilinos.celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "celular", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("telefonoFijo")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.telefonoFijo),expression:"inquilinos.telefonoFijo"}],attrs:{"type":"text","name":"telefonoFijo"},domProps:{"value":(_vm.inquilinos.telefonoFijo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "telefonoFijo", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("whatsapp")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.whatsapp),expression:"inquilinos.whatsapp"}],attrs:{"type":"text","name":"whatsapp"},domProps:{"value":(_vm.inquilinos.whatsapp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "whatsapp", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("facebook")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.facebook),expression:"inquilinos.facebook"}],attrs:{"type":"text","name":"facebook"},domProps:{"value":(_vm.inquilinos.facebook)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "facebook", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCalle")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirCalle),expression:"inquilinos.dirCalle"}],attrs:{"type":"text","name":"dirCalle"},domProps:{"value":(_vm.inquilinos.dirCalle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirCalle", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirNumero")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirNumero),expression:"inquilinos.dirNumero"}],attrs:{"type":"text","name":"dirNumero"},domProps:{"value":(_vm.inquilinos.dirNumero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirNumero", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirInterior")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirInterior),expression:"inquilinos.dirInterior"}],attrs:{"type":"text","name":"dirInterior"},domProps:{"value":(_vm.inquilinos.dirInterior)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirInterior", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirColonia")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirColonia),expression:"inquilinos.dirColonia"}],attrs:{"type":"text","name":"dirColonia"},domProps:{"value":(_vm.inquilinos.dirColonia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirColonia", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCodigo")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirCodigo),expression:"inquilinos.dirCodigo"}],attrs:{"type":"text","name":"dirCodigo"},domProps:{"value":(_vm.inquilinos.dirCodigo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirCodigo", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCiudad")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirCiudad),expression:"inquilinos.dirCiudad"}],attrs:{"type":"text","name":"dirCiudad"},domProps:{"value":(_vm.inquilinos.dirCiudad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirCiudad", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirEstado")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inquilinos.dirEstado),expression:"inquilinos.dirEstado"}],attrs:{"type":"text","name":"dirEstado"},domProps:{"value":(_vm.inquilinos.dirEstado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inquilinos, "dirEstado", $event.target.value)}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"submit","name":"agregandoInquilino"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedad_ver_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_475222ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedad_ver_vue__ = __webpack_require__(111);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedad_ver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_475222ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedad_ver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("Propiedad "+_vm._s(this.id))]),_vm._v(" "),_c('div',{attrs:{"id":"propi"}},[(_vm.propiedadSola !=null)?_c('div',{attrs:{"name":"propiedad-ver"}},_vm._l((_vm.propiedadSola),function(propiedades){return _c('table',{attrs:{"id":"todos","align":"center"}},[_c('tr',[_c('td',[_vm._v("nombreCompleto:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.nombreCompleto))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("familia:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.familia))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("subfamilia:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.subfamilia))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("tipo:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.tipo))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("claveCatastral:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.claveCatastral))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("pais:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.pais))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCalle:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.dirCalle))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirNumero:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.dirNumero))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirInterior:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.dirInterior))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCiudad:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.dirCiudad))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirEstado:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.dirEstado))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCodigo:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.dirCodigo))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("metrosCuadrados:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(propiedades.metrosCuadrados))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("status:")]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(propiedades.status))])])])])}),0):_c('span',[_vm._v("Cargando propiedad")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedad_agregar_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cf36918_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedad_agregar_vue__ = __webpack_require__(115);
function injectStyle (ssrContext) {
  __webpack_require__(113)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedad_agregar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cf36918_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedad_agregar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(114);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("28b24f48", content, true, {});

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#propiAdd{padding:20px}#propiAdd li{width:20%;height:100px;background:#eee;overflow:hidden}", ""]);

// exports


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"propiAdd"}},[_c('h2',[_vm._v("AGREGAR PROPIEDAD")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"captura"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.guardarPropiedad($event)}}},[_c('table',{attrs:{"align":"center"}},[_c('tr',[_c('td',[_vm._v("Nombre completo")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.nombreCompleto),expression:"propiedades.nombreCompleto"}],attrs:{"type":"text","name":"nombreCompleto","required":""},domProps:{"value":(_vm.propiedades.nombreCompleto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "nombreCompleto", $event.target.value)}}})])]),_c('tr'),_c('tr',[_c('td',[_vm._v("Familia")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.familia),expression:"propiedades.familia"}],attrs:{"id":"familiasSelect","name":"dueno","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.propiedades, "familia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":" "}}),_vm._v(" "),_c('option',{attrs:{"value":"OTRO"}},[_vm._v("OTRO")])]),_vm._v(" "),(_vm.propiedades.familia == 'OTRO')?_c('div',[_vm._v("\n                                Familia\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nuevoFamilia),expression:"nuevoFamilia"}],attrs:{"id":"otroFamilia","required":""},domProps:{"value":(_vm.nuevoFamilia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nuevoFamilia=$event.target.value}}})]):_vm._e()])]),_c('tr'),_c('tr',[_c('td',[_vm._v("Subfamilia")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.subfamilia),expression:"propiedades.subfamilia"}],attrs:{"type":"text","name":"subfamilia"},domProps:{"value":(_vm.propiedades.subfamilia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "subfamilia", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Dueño")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dueno),expression:"propiedades.dueno"}],attrs:{"id":"duenosSelect","name":"dueno","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.propiedades, "dueno", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":" "}}),_vm._v(" "),_c('option',{attrs:{"value":"OTRO"}},[_vm._v("OTRO")])]),_vm._v(" "),(_vm.propiedades.dueno == 'OTRO')?_c('div',[_vm._v("\n                                Dueño nombre \n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nuevoDueno),expression:"nuevoDueno"}],attrs:{"id":"otroDueno","required":""},domProps:{"value":(_vm.nuevoDueno)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nuevoDueno=$event.target.value}}})]):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tipo")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.tipo),expression:"propiedades.tipo"}],attrs:{"name":"tipo","value":"LOCAL","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.propiedades, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"LOCAL","selected":""}},[_vm._v("LOCAL")]),_vm._v(" "),_c('option',{attrs:{"value":"OFICINA"}},[_vm._v("OFICINA")]),_vm._v(" "),_c('option',{attrs:{"value":"CASA"}},[_vm._v("CASA")]),_vm._v(" "),_c('option',{attrs:{"value":"TERRENO"}},[_vm._v("TERRENO")]),_vm._v(" "),_c('option',{attrs:{"value":"BODEGA"}},[_vm._v("BODEGA")]),_vm._v(" "),_c('option',{attrs:{"value":"OTRO"}},[_vm._v("OTRO")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Clave Catastral")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.claveCatastral),expression:"propiedades.claveCatastral"}],attrs:{"type":"text","name":"claveCatastral"},domProps:{"value":(_vm.propiedades.claveCatastral)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "claveCatastral", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Calle")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirCalle),expression:"propiedades.dirCalle"}],attrs:{"type":"text","name":"dirCalle","required":""},domProps:{"value":(_vm.propiedades.dirCalle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dirCalle", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Numero")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirNumero),expression:"propiedades.dirNumero"}],attrs:{"type":"text","name":"dirNumero","required":""},domProps:{"value":(_vm.propiedades.dirNumero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dirNumero", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Interior")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirInterior),expression:"propiedades.dirInterior"}],attrs:{"type":"text","name":"dirInterior"},domProps:{"value":(_vm.propiedades.dirInterior)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dirInterior", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Ciudad")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirCiudad),expression:"propiedades.dirCiudad"}],attrs:{"id":"ciudadesSelect","name":"estado","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.propiedades, "dirCiudad", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":" "}}),_vm._v(" "),_c('option',{attrs:{"value":"OTRO"}},[_vm._v("OTRO")])]),_vm._v(" "),(_vm.propiedades.dirCiudad == 'OTRO')?_c('div',[_vm._v("\n                                Ciudad\n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nuevoCiudad),expression:"nuevoCiudad"}],attrs:{"id":"otroCiudad","required":""},domProps:{"value":(_vm.nuevoCiudad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nuevoCiudad=$event.target.value}}})]):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Estado")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirEstado),expression:"propiedades.dirEstado"}],attrs:{"id":"estadosSelect","name":"estado","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.propiedades, "dirEstado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":" "}}),_vm._v(" "),_c('option',{attrs:{"value":"OTRO"}},[_vm._v("OTRO")])]),_vm._v(" "),(_vm.propiedades.dirEstado == 'OTRO')?_c('div',[_vm._v("\n                                Nombre estado \n                                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nuevoEstado),expression:"nuevoEstado"}],attrs:{"id":"otroEstado","required":""},domProps:{"value":(_vm.nuevoEstado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nuevoEstado=$event.target.value}}})]):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Pais")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.pais),expression:"propiedades.pais"}],attrs:{"type":"text","name":"pais","value":"Mexico","required":""},domProps:{"value":(_vm.propiedades.pais)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "pais", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Codigo")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirCodigo),expression:"propiedades.dirCodigo"}],attrs:{"type":"text","name":"dirCodigo"},domProps:{"value":(_vm.propiedades.dirCodigo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dirCodigo", $event.target.value)}}})])]),_vm._v(" "),_c('td',[_vm._v("Metros cuadrados")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.metrosCuadrados),expression:"propiedades.metrosCuadrados"}],attrs:{"type":"text","name":"metrosCuadrados","required":""},domProps:{"value":(_vm.propiedades.metrosCuadrados)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "metrosCuadrados", $event.target.value)}}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Medidas y colindancias")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.medidasYcol),expression:"propiedades.medidasYcol"}],attrs:{"type":"text","name":"metrosCuadrados","required":""},domProps:{"value":(_vm.propiedades.medidasYcol)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "medidasYcol", $event.target.value)}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"submit","name":"agregandoPropiedad"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedad_editar_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070ac5d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedad_editar_vue__ = __webpack_require__(117);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedad_editar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070ac5d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedad_editar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"propi-editar"}},[_c('h2',[_vm._v("EDITAR PROPIEDAD ")]),_vm._v(" "),_c('div',{attrs:{"id":"propiedad-ver"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.guardarPropiedad($event)}}},[_c('table',{attrs:{"align":"center"}},[_c('tr',[_c('td',[_vm._v("nombreCompleto")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.nombreCompleto),expression:"propiedades.nombreCompleto"}],attrs:{"type":"text","name":"nombreCompleto","autofocus":"","required":"","autocomplete":""},domProps:{"value":(_vm.propiedades.nombreCompleto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "nombreCompleto", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("familia")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.familia),expression:"propiedades.familia"}],attrs:{"type":"text","name":"familia","required":"","autocomplete":""},domProps:{"value":(_vm.propiedades.familia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "familia", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("subfamilia")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.subfamilia),expression:"propiedades.subfamilia"}],attrs:{"type":"text","name":"subfamilia","autocomplete":""},domProps:{"value":(_vm.propiedades.subfamilia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "subfamilia", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dueño")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dueno),expression:"propiedades.dueno"}],attrs:{"type":"text","name":"dueno","autocomplete":""},domProps:{"value":(_vm.propiedades.dueno)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dueno", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("tipo")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.tipo),expression:"propiedades.tipo"}],attrs:{"type":"text","name":"tipo","required":""},domProps:{"value":(_vm.propiedades.tipo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "tipo", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("claveCatastral")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.claveCatastral),expression:"propiedades.claveCatastral"}],attrs:{"type":"text","name":"claveCatastral"},domProps:{"value":(_vm.propiedades.claveCatastral)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "claveCatastral", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("pais")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.pais),expression:"propiedades.pais"}],attrs:{"type":"text","name":"pais","required":"","value":"Mexico"},domProps:{"value":(_vm.propiedades.pais)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "pais", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCalle")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirCalle),expression:"propiedades.dirCalle"}],attrs:{"type":"text","name":"dirCalle","required":""},domProps:{"value":(_vm.propiedades.dirCalle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dirCalle", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirNumero")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirNumero),expression:"propiedades.dirNumero"}],attrs:{"type":"text","name":"dirNumero","required":"","number":""},domProps:{"value":(_vm.propiedades.dirNumero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dirNumero", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirInterior")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirInterior),expression:"propiedades.dirInterior"}],attrs:{"type":"text","name":"dirInterior"},domProps:{"value":(_vm.propiedades.dirInterior)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dirInterior", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCiudad")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirCiudad),expression:"propiedades.dirCiudad"}],attrs:{"type":"text","name":"dirCiudad","autocomplete":"","required":""},domProps:{"value":(_vm.propiedades.dirCiudad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dirCiudad", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirEstado")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirEstado),expression:"propiedades.dirEstado"}],attrs:{"type":"text","name":"dirEstado","required":""},domProps:{"value":(_vm.propiedades.dirEstado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dirEstado", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dirCodigo")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.dirCodigo),expression:"propiedades.dirCodigo"}],attrs:{"type":"text","name":"dirCodigo","number":""},domProps:{"value":(_vm.propiedades.dirCodigo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "dirCodigo", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("metrosCuadrados")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.metrosCuadrados),expression:"propiedades.metrosCuadrados"}],attrs:{"type":"text","name":"metrosCuadrados","number":""},domProps:{"value":(_vm.propiedades.metrosCuadrados)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "metrosCuadrados", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Contrato de luz")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.contratoElec),expression:"propiedades.contratoElec"}],attrs:{"type":"text","name":"cl","number":""},domProps:{"value":(_vm.propiedades.contratoElec)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "contratoElec", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Medidor de luz")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.medidorElec),expression:"propiedades.medidorElec"}],attrs:{"type":"text","name":"ml","number":""},domProps:{"value":(_vm.propiedades.medidorElec)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "medidorElec", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Medidor de luz a nombre de")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.AnombreDeElec),expression:"propiedades.AnombreDeElec"}],attrs:{"type":"text","name":"mln","number":""},domProps:{"value":(_vm.propiedades.AnombreDeElec)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "AnombreDeElec", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Comentarios de toma de Luz")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.comentarioMedidorE),expression:"propiedades.comentarioMedidorE"}],attrs:{"type":"text","name":"ctl","number":""},domProps:{"value":(_vm.propiedades.comentarioMedidorE)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "comentarioMedidorE", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Contrato de Agua")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.contratoAgua),expression:"propiedades.contratoAgua"}],attrs:{"type":"text","name":"ca","number":""},domProps:{"value":(_vm.propiedades.contratoAgua)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "contratoAgua", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Medidor de Agua")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.medidorAgua),expression:"propiedades.medidorAgua"}],attrs:{"type":"text","name":"ma","number":""},domProps:{"value":(_vm.propiedades.medidorAgua)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "medidorAgua", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Contrato de Agua a nombre de")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.AnombreDeAgua),expression:"propiedades.AnombreDeAgua"}],attrs:{"type":"text","name":"can","number":""},domProps:{"value":(_vm.propiedades.AnombreDeAgua)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "AnombreDeAgua", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Comentarios de toma de Agua")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.comentarioAgua),expression:"propiedades.comentarioAgua"}],attrs:{"type":"text","name":"cta","number":""},domProps:{"value":(_vm.propiedades.comentarioAgua)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "comentarioAgua", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Medidas y colindancias")]),_vm._v(" "),_c('td',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.propiedades.medidasYcol),expression:"propiedades.medidasYcol"}],attrs:{"type":"text","name":"cta","number":""},domProps:{"value":(_vm.propiedades.medidasYcol)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.propiedades, "medidasYcol", $event.target.value)}}})])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"submit","name":"agregandoPropiedad"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contrato_ver_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ac602a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contrato_ver_vue__ = __webpack_require__(121);
function injectStyle (ssrContext) {
  __webpack_require__(119)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contrato_ver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ac602a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contrato_ver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(120);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("200d78f2", content, true, {});

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#contrato-ver{padding:20px}#contrato-ver li{width:30%;height:120px;background:#eee;overflow:hidden}", ""]);

// exports


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"captura"}},[(_vm.contratoSolo !=null)?_c('div',{attrs:{"name":"contrato-ver"}},[_vm._l((_vm.contratoSolo),function(contratos){return _c('table',{attrs:{"align":"center"}},[_c('tr',[_c('td',[_vm._v("familia:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.familia))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("subfamilia:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.subfamilia))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("dueño:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.dueno))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Contrato Número:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.id))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("propiedad:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.propiedad))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("propiedad Num:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.propiedadId))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("inquilino:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.inquilino))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("inquilino Num:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.inquilinoId))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("nombreComercial:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.nombreComercial))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("giro:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.giro))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("importeMes:")]),_vm._v(" "),_c('td',[_vm._v("$ "+_vm._s(_vm.formateaNumero(contratos.importeMes)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("fecha Inicio:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formateaFecha(contratos.fechaInicio)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("fecha Terminacion:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formateaFecha(contratos.fechaTerminacion)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("quien Modifico:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.quienModifico))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("status:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.status))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("area:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.area))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("medidas:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.medidasYcol))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("finalizo:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.finalizo))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("direccion inquilino:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.dirInquilino))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("celular inquilino:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.celularInquilino))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("mail inquilino:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.emailInquilino))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("facebook inquilino:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.fbInquilino))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("whatsapp inquilino:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.wappInquilino))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("id inquilino:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.idInquilino))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("comprobante dom. inquilino:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.comDomInquilino))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("nombre aval:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.nomAval))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("direccion aval:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.dirAval))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("direccion aval:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.direccionAval))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("mail aval:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.mailAval))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("celular aval:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.celAval))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("facebook aval:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.fbAval))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("id aval:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.ideAval))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("comprobante aval:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.comDomAval))])])])}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],2):_c('span',[_vm._v("Cargando contrato")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contrato_agregar_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce1ace9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contrato_agregar_vue__ = __webpack_require__(135);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contrato_agregar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce1ace9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contrato_agregar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedades_buscar_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6664d36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedades_buscar_vue__ = __webpack_require__(126);
function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedades_buscar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6664d36_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedades_buscar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(125);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4be6d4ad", content, true, {});

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#propiedades-lista{padding:20px}#propiedades-lista li{width:100%;height:100%;background:#eee}", ""]);

// exports


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Propiedades")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","placeholder":"Buscar"},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{attrs:{"id":"agrega","to":{name: 'agre-propi'}}},[_vm._v("Agregar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.propiedadesTodas !=null)?_c('ul',{attrs:{"id":"propiedades-lista"}},_vm._l((_vm.buscando),function(propi){return _c('li',{attrs:{"align":"left"}},[_c('strong',{on:{"click":function($event){return _vm.lanza(propi.id, propi.nombreCompleto + ' ' +propi.dirCalle +  ' ' + propi.dirNumero +  ' Int. ' + propi.dirInterior +  ' ' + propi.dirCiudad + ' ' + propi.dirEstado + ' ' + propi.dirCodigo , propi.familia, propi.subfamilia, propi.dueno, propi.metrosCuadrados, propi.medidasYcol, propi.status )}}},[_c('p',[_vm._v(_vm._s(propi.nombreCompleto))]),_vm._v(" "),_c('p',[_vm._v("Fam: "+_vm._s(propi.familia))]),_vm._v(" "),_c('p',[_vm._v("Sub familia:"+_vm._s(propi.subfamilia))]),_vm._v(" "),_c('p',[_vm._v("Tipo: "+_vm._s(propi.tipo))]),_vm._v(" "),(propi.status == 'RENTADO')?_c('p',[_c('mark',[_vm._v("Status: "+_vm._s(propi.status))])]):_vm._e(),_vm._v(" "),(propi.status != 'RENTADO')?_c('p',[_c('font',{attrs:{"color":"blue"}},[_vm._v("Status: "+_vm._s(propi.status))])],1):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Area: "+_vm._s(propi.metrosCuadrados))]),_vm._v(" "),_c('p',[_vm._v("Medidas: "+_vm._s(propi.medidasYcol))])]),_vm._v(" "),_c('button',{attrs:{"type":"button","id":"selector"},on:{"click":function($event){return _vm.lanza(propi.id, propi.nombreCompleto + ' ' +propi.dirCalle +  ' ' + propi.dirNumero +  ' Int.' + propi.dirInterior +  ' ' + propi.dirCiudad + ' ' + propi.dirEstado + ' ' + propi.dirCodigo , propi.familia, propi.subfamilia, propi.dueno, propi.metrosCuadrados, propi.medidasYcol, propi.claveCatastral ,propi.status)}}},[_vm._v("Seleccionar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":{name: 'ver-propi', params:{id:propi.id}}}},[_vm._v("Ver")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'edi-propi', params:{id:propi.id}}}},[_vm._v("Editar")])],1)])}),0):_c('span',[_vm._v("Cargando propiedades ...")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquilinos_buscar_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66747aa9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquilinos_buscar_vue__ = __webpack_require__(130);
function injectStyle (ssrContext) {
  __webpack_require__(128)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inquilinos_buscar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66747aa9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inquilinos_buscar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(129);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("625b36ae", content, true, {});

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#propiedades-lista{padding:20px}#propiedades-lista li{width:100%;height:120px;background:#eee;overflow:hidden}", ""]);

// exports


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Inquilinos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","placeholder":"Buscar"},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.inquilinosTodos !=null)?_c('ul',{attrs:{"id":"inquilinos-lista"}},_vm._l((_vm.buscando),function(inqui){return _c('li',{attrs:{"align":"left"}},[_c('strong',{on:{"click":function($event){return _vm.lanza(inqui.id, inqui.nombreCompleto, inqui.email, inqui.celular, inqui.telefonoFijo, inqui.whatsapp, inqui.facebook, inqui.dirCalle + ' ' + inqui.dirNumero + ' -' + inqui.dirInterior + ' ' + inqui.dirColonia + ' ' + inqui.dirCodigo  + ' ' + inqui.dirCiudad + ' ' + inqui.dirEstado, inqui.celular, inqui.fbInquilino, inqui.wappInquilino)}}},[_c('p',[_vm._v("Nombre: "+_vm._s(inqui.nombreCompleto))]),_vm._v(" "),_c('p',[_vm._v("Id: "+_vm._s(inqui.id))]),_vm._v(" "),_c('p',[_vm._v("Mail: "+_vm._s(inqui.email))]),_vm._v(" "),_c('p',[_vm._v("Celular: "+_vm._s(inqui.celular))]),_vm._v(" "),_c('p',[_vm._v("Calle: "+_vm._s(inqui.dirCalle))]),_vm._v(" "),_c('p',[_vm._v("Numero: "+_vm._s(inqui.dirNumero))]),_vm._v(" "),_c('p',[_vm._v("Interior: "+_vm._s(inqui.dirInterior))]),_vm._v(" "),_c('p',[_vm._v("Colonia: "+_vm._s(inqui.dirColonia))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.lanza(inqui.id, inqui.nombreCompleto, inqui.email, inqui.celular, inqui.telefonoFijo, inqui.whatsapp, inqui.facebook, inqui.dirCalle + ' ' + inqui.dirNumero + ' -' + inqui.dirInterior + ' ' + inqui.dirColonia + ' ' + inqui.dirCodigo  + ' ' + inqui.dirCiudad + ' ' + inqui.dirEstado, inqui.celular, inqui.fbInquilino, inqui.wappInquilino)}}},[_vm._v("Seleccionar")]),_vm._v(" "),_c('p',[_c('br'),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'ver-inqui', params:{id:inqui.id}}}},[_vm._v("Ver")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'edi-inqui', params:{id:inqui.id}}}},[_vm._v("Editar")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])}),0):_c('span',[_vm._v("Cargando inquilinos ...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pre_o_Contratos_buscar_vue__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27dba39a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pre_o_Contratos_buscar_vue__ = __webpack_require__(134);
function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pre_o_Contratos_buscar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27dba39a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pre_o_Contratos_buscar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(133);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("cd3b1512", content, true, {});

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Pre-Contratos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","id":"busca","align":"center"},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" Buscar\n\t\t"),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.contratosTodos !=null)?_c('ul',{attrs:{"id":"contratos-lista","align":"left"}},_vm._l((_vm.buscando),function(contra){return (_vm.esProformaOcontrato == contra.status)?_c('li',[(_vm.esProformaOcontrato == contra.status)?_c('div',{on:{"click":function($event){return _vm.lanza(contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes, contra.celularInquilino, contra.fbInquilino, contra.dirInquilino, contra.wappInquilino, contra.fechaInicio, contra.fechaTerminacion, contra.idInquilino, contra.comDomInquilino, contra.nombreAval, contra.direccionAval, contra.celularAval, contra.mailAval, contra.fbAval, contra.nombreComercial, contra.medidasYcol, contra.area)}}},[_c('strong',[_vm._v("\n\t\t\t\t\t    Contrato Num.  "+_vm._s(contra.id)+" "),_c('br'),_vm._v("\n  \t\t\t\t\t\t"+_vm._s(contra.inquilino)+" "),_c('br'),_vm._v("\n  \t\t\t\t\t\t"+_vm._s(contra.propiedad)),_c('br'),_vm._v(" "),_c('font',{attrs:{"color":"orange"}},[_vm._v(_vm._s(contra.giro)),_c('br'),_vm._v("\n\t\t\t\t\t    "+_vm._s(contra.nombreComercial)+" ")]),_c('br'),_vm._v("\n\t\t\t\t\t    "+_vm._s(contra.familia)+" "),_c('br'),_vm._v("\n\t\t\t\t\t    "+_vm._s(contra.subfamilia)+" "),_c('br'),_vm._v("\n              "+_vm._s(contra.status)+" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Termina: "+_vm._s(_vm.formateaFecha(contra.fechaTerminacion)))]),_vm._v(" "),_c('p',[_c('font',{attrs:{"color":"red"}},[_vm._v(_vm._s(_vm.vencido(contra.fechaTerminacion, contra.status)))])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-primary is-rounded",attrs:{"type":"button"},on:{"click":function($event){return _vm.lanza(contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes, contra.celularInquilino, contra.fbInquilino, contra.dirInquilino, contra.wappInquilino, contra.fechaInicio, contra.fechaTerminacion, contra.idInquilino, contra.comDomInquilino, contra.nombreAval, contra.direccionAval, contra.celularAval, contra.mailAval, contra.fbAval, contra.nombreComercial, contra.medidasYcol, contra.area)}}},[_vm._v(" Seleccionar\n\t\t\t\t\t")])]):_vm._e()]):_vm._e()}),0):_c('span',[_vm._v("Cargando contratos ...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contraAdd"}},[_c('h2',[_vm._v("Agregar Contrato o Pre-Contrato")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-primary is-rounded",attrs:{"type":"button"},on:{"click":function($event){return _vm.aBuscarPre_o_Con("PRE-CONTRATO")}}},[_vm._v("Buscar en Pre-Contratos")]),_vm._v(" "),_c('button',{staticClass:"button is-primary is-rounded",attrs:{"type":"button"},on:{"click":function($event){return _vm.aBuscarPre_o_Con("RENTADO")}}},[_vm._v("Copiar un contrato")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('form',{attrs:{"id":"visible"},on:{"submit":function($event){$event.preventDefault();return _vm.guardarContrato($event)}}},[_c('table',{attrs:{"align":"center"}},[_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Propiedad numero")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.propiedadId),expression:"contratos.propiedadId"}],staticClass:"input is-rounded",attrs:{"disabled":""},domProps:{"value":(_vm.contratos.propiedadId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "propiedadId", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"button is-primary is-rounded",attrs:{"type":"button"},on:{"click":_vm.aBuscar}},[_vm._v("Buscar")]),_vm._v(" "),_c('router-link',{attrs:{"id":"agre","to":{name: 'agre-propi'}}},[_vm._v("Agregar")])],1)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Inquilino numero")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.inquilinoId),expression:"contratos.inquilinoId"}],staticClass:"input is-rounded",attrs:{"disabled":""},domProps:{"value":(_vm.contratos.inquilinoId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "inquilinoId", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"button is-primary is-rounded",attrs:{"type":"button"},on:{"click":_vm.aBuscarI}},[_vm._v("Buscar")]),_vm._v(" "),_c('router-link',{attrs:{"id":"busca","to":{name: 'agre-inqui'}}},[_vm._v("Agregar")])],1)]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Inquilino")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.inquilino),expression:"contratos.inquilino"}],staticClass:"input is-rounded",attrs:{"type":"text","disabled":"","name":"inquilino"},domProps:{"value":(_vm.contratos.inquilino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "inquilino", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Direccion Inquilino")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.dirI),expression:"contratos.dirI"}],staticClass:"input is-rounded",attrs:{"type":"text","disabled":"","name":"inquilinoDir"},domProps:{"value":(_vm.contratos.dirI)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "dirI", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Propiedad")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.propiedad),expression:"contratos.propiedad"}],staticClass:"input is-rounded",attrs:{"type":"text","disabled":"","name":"propiedad"},domProps:{"value":(_vm.contratos.propiedad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "propiedad", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Familia")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.familia),expression:"contratos.familia"}],staticClass:"input is-rounded",attrs:{"type":"text","disabled":"","name":"familia"},domProps:{"value":(_vm.contratos.familia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "familia", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Sub familia")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.subfamilia),expression:"contratos.subfamilia"}],staticClass:"input is-rounded",attrs:{"type":"text","disabled":"","name":"subfamilia"},domProps:{"value":(_vm.contratos.subfamilia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "subfamilia", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Clave catastral")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.claveCat),expression:"contratos.claveCat"}],staticClass:"input is-rounded",attrs:{"type":"text","disabled":"","name":"claveCat"},domProps:{"value":(_vm.contratos.claveCat)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "claveCat", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Area")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.metrosCuadrados),expression:"contratos.metrosCuadrados"}],staticClass:"input is-rounded",attrs:{"type":"text","disabled":"","name":"area"},domProps:{"value":(_vm.contratos.metrosCuadrados)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "metrosCuadrados", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Medidas y colindancias")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.medidasYcol),expression:"contratos.medidasYcol"}],staticClass:"input is-rounded",attrs:{"type":"text","disabled":"","name":"colin"},domProps:{"value":(_vm.contratos.medidasYcol)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "medidasYcol", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Contrato o Pre-Contrato ")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('strong',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.conpre),expression:"conpre"}],staticClass:"input is-rounded",attrs:{"name":"cop","required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.conpre=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.visibleInicio()}]}},[_c('option',{attrs:{"value":"P","selected":""}},[_vm._v("Pre-Contrato")]),_vm._v(" "),_c('option',{attrs:{"value":"C"}},[_vm._v("Contrato")])])])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Nombre Comercial ")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.nombreComercial),expression:"contratos.nombreComercial"}],staticClass:"input is-rounded",attrs:{"type":"text","required":"","minlength":"4","name":"nombreComercial"},domProps:{"value":(_vm.contratos.nombreComercial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "nombreComercial", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Giro")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.giro),expression:"contratos.giro"}],staticClass:"input is-rounded",attrs:{"type":"text","required":"","minlength":"4","name":"giro"},domProps:{"value":(_vm.contratos.giro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "giro", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Renta Mensual")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.importeMes),expression:"contratos.importeMes"}],staticClass:"input is-rounded",attrs:{"type":"number","required":"","min":"100","name":"importeMes"},domProps:{"value":(_vm.contratos.importeMes)},on:{"keyup":function($event){return _vm.diaria(_vm.contratos.importeMes)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "importeMes", $event.target.value)}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Renta diaria: $ "+_vm._s(_vm.formateaNumero(_vm.rentaDiaria)))])])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Inicia el contrato")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.fechaInicio),expression:"contratos.fechaInicio"}],staticClass:"input is-rounded",attrs:{"type":"date","required":"","name":"fechaInicio"},domProps:{"value":(_vm.contratos.fechaInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "fechaInicio", $event.target.value)}}}),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.formateaFecha(_vm.contratos.fechaInicio))+"\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Termina el contrato")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.fechaFinal),expression:"contratos.fechaFinal"}],staticClass:"input is-rounded",attrs:{"type":"date","required":"","name":"fechaFinal"},domProps:{"value":(_vm.contratos.fechaFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "fechaFinal", $event.target.value)}}}),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.formateaFecha(_vm.contratos.fechaFinal ))+"\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Saldo inicial")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.saldoInicial),expression:"contratos.saldoInicial"}],staticClass:"input is-rounded",attrs:{"type":"number","required":"","min":"0","name":"saldoI"},domProps:{"value":(_vm.contratos.saldoInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "saldoInicial", $event.target.value)}}}),_vm._v(" "),_c('p',[_vm._v("El importe del depósito en Garantia ")]),_c('p',[_vm._v("captúrelo después en Movimientos con")]),_c('p',[_vm._v(" el TIPO \"Deposito en Garantía\", ")]),_c('p',[_vm._v("No agregue aquí el depósito en garantía ")]),_c('p',[_vm._v(" como parte del saldo inicial")])])]),_vm._v(" "),_c('tr',{attrs:{"id":"fechaSaldo"}},[_vm._m(0),_vm._v(" "),_c('td',{staticStyle:{"color":"red"},attrs:{"align":"left"}},[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.fechaSaldoInicial),expression:"contratos.fechaSaldoInicial"}],staticClass:"input is-rounded",attrs:{"type":"date","required":"","id":"fs"},domProps:{"value":(_vm.contratos.fechaSaldoInicial)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "fechaSaldoInicial", $event.target.value)}}}),_vm._v(" "),_c('br'),_vm._v("El primer cargo será a razón de $ "+_vm._s(_vm.formateaNumero(_vm.rentaDiaria))+" diarios\n\t\t\t\t\t\t\t\t"),_c('br'),_vm._v("AL DIA SIGUIENTE del  "+_vm._s(_vm.formateaFecha(_vm.contratos.fechaSaldoInicial))+"\n\t\t\t\t\t\t\t")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("ESTA FECHA NO SE PUEDE")]),_vm._v(" "),_c('p',[_vm._v("CAMBIAR DESPUES")]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Identificación del inquilino")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.idInquilino),expression:"contratos.idInquilino"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"idinq","required":""},domProps:{"value":(_vm.contratos.idInquilino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "idInquilino", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Comprobante domicilio inquilino")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.comDomInquilino),expression:"contratos.comDomInquilino"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"comdom","required":""},domProps:{"value":(_vm.contratos.comDomInquilino)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "comDomInquilino", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Nombre completo aval")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.nombreAval),expression:"contratos.nombreAval"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"naval"},domProps:{"value":(_vm.contratos.nombreAval)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "nombreAval", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Dirección completa aval")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.direccionAval),expression:"contratos.direccionAval"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"daval","maxlength":"250"},domProps:{"value":(_vm.contratos.direccionAval)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "direccionAval", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Celular aval")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.celularAval),expression:"contratos.celularAval"}],staticClass:"input is-rounded",attrs:{"type":"phone","name":"caval"},domProps:{"value":(_vm.contratos.celularAval)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "celularAval", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Email aval")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.emailAval),expression:"contratos.emailAval"}],staticClass:"input is-rounded",attrs:{"type":"email","name":"eaval"},domProps:{"value":(_vm.contratos.emailAval)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "emailAval", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Facebook aval")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.facebookAval),expression:"contratos.facebookAval"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"faval"},domProps:{"value":(_vm.contratos.facebookAval)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "facebookAval", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("Depositar a ")]),_vm._v(" "),_c('td',{attrs:{"align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratos.depositarA),expression:"contratos.depositarA"}],staticClass:"input is-rounded",attrs:{"type":"text","required":"","name":"depA"},domProps:{"value":(_vm.contratos.depositarA)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratos, "depositarA", $event.target.value)}}})])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('p',[(_vm.buscar)?_c('hijo1',{on:{"eventoP":function($event){return _vm.recibeP.apply(void 0, arguments)}}},[_vm._v("Cargando propiedades...")]):_vm._e()],1),_vm._v(" "),_c('p',[(_vm.buscar1)?_c('hijo2',{on:{"eventoI":function($event){return _vm.recibeI.apply(void 0, arguments)}}},[_vm._v("Cargando inquilinos...")]):_vm._e()],1),_vm._v(" "),_c('p',[(_vm.buscarProf)?_c('hijo3',{attrs:{"esProformaOcontrato":_vm.poc},on:{"eventoProf":function($event){return _vm.recibePro_o_Con.apply(void 0, arguments)}}},[_vm._v("Cargando proformas...")]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"color":"red"},attrs:{"align":"right"}},[_c('p',[_c('b',[_vm._v("Fecha del saldo inicial.")])]),_vm._v(" "),_c('p',[_vm._v("Al día siguiete")]),_vm._v(" "),_c('p',[_vm._v("iniciarán los cargos ")]),_vm._v(" "),_c('p',[_vm._v("mensuales de renta")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('sup',[_vm._v("(Inicio del control del sistema al DIA SIGUIENTE)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('input',{staticClass:"button is-primary is-rounded",attrs:{"type":"submit","name":"agre"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(137);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("469697a1", content, true, {});

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"captura"}},[_c('div',{attrs:{"align":"center"}},[_c('button',{on:{"click":function($event){return _vm.imprimir('estado-cuenta')}}},[_c('b',[_vm._v("Imprimir o crear PDF")])]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('div',{attrs:{"id":"estado-cuenta"}},[(_vm.contratoSolo !=null)?_c('div',{attrs:{"id":"estado-ver"}},[_vm._m(0),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('b',[_vm._v("Al "+_vm._s(_vm.formateaFecha(_vm.hoy)))])]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.contratoSolo),function(contratos){return _c('table',{staticClass:"table is-striped is-hoverable",attrs:{"align":"center","border":"2","cellspacing":"10"}},[_c('tbody',{model:{value:(_vm.leyenda = contratos.giro + ' - ' + contratos.familia + ' - ' + contratos.propiedad),callback:function ($$v) {_vm.$set(_vm.leyenda = contratos.giro + ' - ' + contratos.familia + ' - ' + contratos, "propiedad", $$v)},expression:"leyenda = contratos.giro + ' - ' + contratos.familia + ' - ' + contratos.propiedad"}},[_c('tr',[_c('td',[_vm._v("Giro:")]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(contratos.giro))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Renta mensual:")]),_vm._v(" "),_c('td',[_c('b',[_vm._v("$ "+_vm._s(_vm.formateaNumero(contratos.importeMes)))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Propiedad:")]),_vm._v(" "),_c('td',[_c('b',[_vm._v("("+_vm._s(contratos.id)+") "+_vm._s(contratos.propiedad))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Familia:")]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(contratos.familia))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Celular:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.celularInquilino))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Email:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.emailInquilino))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Nombre Comercial:")]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(contratos.nombreComercial))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Inquilino:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.inquilino))])]),_vm._v(" "),(_vm.verStatus(contratos.status))?_c('tr',[_c('td',[_vm._v("Status:")]),_vm._v(" "),_c('td',[_c('strong',[_c('font',{attrs:{"color":"blue"}},[_vm._v(_vm._s(contratos.status))])],1)])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Fecha inicio contrato:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formateaFecha(contratos.fechaInicio)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Contrato Num:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contratos.id)+_vm._s(_vm.pasaContrato(contratos.id)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Saldo inicial")]),_vm._v(" "),_c('td',[_vm._v("$ "+_vm._s(_vm.formateaNumero(contratos.saldoInicial))+" al "+_vm._s(_vm.formateaFecha(contratos.fechaSaldoInicial)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Adeudo actual: ")]),_vm._v(" "),_c('td',[_c('b',[_vm._v("$ "+_vm._s(_vm.formateaNumero(_vm.saldoTotal)))])])])])])})],2):_c('span',[_vm._v("Cargando contrato")]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('b',[_vm._v(" \n\t\t\t\t\t Del: "),_c('input',_vm._b({attrs:{"type":"date","id":"de"},on:{"change":function($event){return _vm.rangos()}}},'input',_vm.fecha1,false)),_vm._v("\n\t\t\t\t\t Al:  "),_c('input',_vm._b({attrs:{"type":"date","id":"al"},on:{"change":function($event){return _vm.rangos()}}},'input',_vm.fecha2,false))]),_vm._v("\n\t\t\t\t\t     Concepto \n\t\t\t\t\t"),_c('select',{attrs:{"id":"losConceptos","text":"Concepto"},on:{"change":function($event){return _vm.rangos()}}},[_c('option',{attrs:{"value":"Todos","selected":"true"}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"Consumo AGUA"}},[_vm._v("Consumo AGUA")]),_vm._v(" "),_c('option',{attrs:{"value":"Consumo LUZ"}},[_vm._v("Consumo LUZ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Del   ")]),_vm._v(" "+_vm._s(_vm.formateaFecha(_vm.fecha1))+"  "),_c('b',[_vm._v("     al     ")]),_vm._v(" "+_vm._s(_vm.formateaFecha(_vm.fecha2))+"\n\t\t\n\t\t\t\t")])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.movimientos4 !=null)?_c('div',{attrs:{"name":"contrato-edo","align":"center"}},[_c('table',{staticClass:"table is-striped is-hoverable",attrs:{"border":"2","cellspacing":"10"}},[_c('tbody',[_vm._m(1),_vm._v(" "),_vm._l((_vm.movimientos4),function(movi,indice){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.formateaFecha(movi.fecha)))]),_vm._v(" "),(movi.tipo == 'PAGO')?_c('td',[_c('b',[_vm._v(_vm._s(movi.tipo))]),_c('br'),_vm._v(_vm._s(movi.ids))]):_vm._e(),_vm._v(" "),(movi.tipo != 'PAGO')?_c('td',[_vm._v(_vm._s(movi.tipo)),_c('br'),_vm._v(_vm._s(movi.ids))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.concepto)),_c('br'),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(movi.referencia)),_c('br'),_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(movi.comentario)+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('td',[(movi.importe >= 0)?_c('p',{attrs:{"align":"right"}},[_vm._v("$"+_vm._s(_vm.formateaNumero(movi.importe)))]):_vm._e()]),_vm._v(" "),_c('td',[(movi.importe < 0)?_c('p',{attrs:{"align":"right"}},[_c('b',[_vm._v("$"+_vm._s(_vm.formateaNumero(movi.importe)))])]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(movi.formaDePago)),_c('br'),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.verFoto(movi.ids)}}},[_vm._v(_vm._s(movi.recibo)+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),(movi.recibo !='' && _vm.cualFotoId == movi.ids)?_c('img',{attrs:{"src":'https://directodo.com/Rentus/accesosdb/recibosrentus/' + movi.direccionFoto,"alt":" ","width":"250","height":"250","id":"lafoto"}}):_vm._e()]),_vm._v(" "),_c('td',[_c('p',{attrs:{"align":"right"}},[_vm._v("$"+_vm._s(_vm.formateaNumero(movi.acum)))])])])})],2)]),_vm._v("\n                "+_vm._s(_vm.leyenda)+"\n\t\t\t\t"),_c('br')]):_vm._e()]),_vm._v(" "),_c('div',[_c('br'),_c('br'),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.imprimir('estado-cuenta')}}},[_c('b',[_vm._v("Imprimir Estado de Cuenta o crear PDF ")])]),_vm._v(" "),_c('br'),_c('br')])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"align":"center"}},[_c('b',[_vm._v("ESTADO DE CUENTA ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("fecha")]),_vm._v(" "),_c('th',[_vm._v("tipo/folio")]),_vm._v(" "),_c('th',[_vm._v("concepto")]),_vm._v(" "),_c('th',[_c('p',{attrs:{"align":"right"}},[_vm._v("cargos")])]),_vm._v(" "),_c('th',[_c('p',{attrs:{"align":"right"}},[_vm._v("abonos")])]),_vm._v(" "),_c('th',[_vm._v("forma de pago")]),_vm._v(" "),_c('th',[_c('p',{attrs:{"align":"right"}},[_vm._v("saldo")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contratos_renovacion_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1108729c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contratos_renovacion_vue__ = __webpack_require__(142);
function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contratos_renovacion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1108729c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contratos_renovacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(141);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("c161dccc", content, true, {});

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","placeholder":"BUSCAR"},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.contratosTodos !=null)?_c('table',{staticClass:"table is-striped",attrs:{"id":"contratos-lista"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.buscando),function(contrat){return (contrat.status != 'PROFORMA' && contrat.status == 'RENTADO')?_c('tr',[_c('td',[_vm._v(_vm._s(contrat.propiedad))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contrat.inquilino))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(contrat.nombreComercial)+"/"+_vm._s(contrat.giro))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contrat.familia)+"/"+_vm._s(contrat.subfamilia))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" $"+_vm._s(_vm.formateaNumero(contrat.importeMes))+"\n                    "),_c('br'),_vm._v(_vm._s(contrat.area)+"M2")]),_vm._v(" "),_c('br'),_vm._v("$"+_vm._s(_vm.formateaNumeroSimple(contrat.importeMes/contrat.area))+"/m2\n                ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formateaFecha(contrat.fechaInicio))),_c('strong',[_vm._v(" / ")]),_vm._v(_vm._s(_vm.formateaFecha(contrat.fechaTerminacion)))]),_vm._v(" "),_c('td',[_c('font',{attrs:{"color":"red"}},[_vm._v("\n                    "+_vm._s(contrat.vencidoEsta = _vm.vencido(contrat.fechaTerminacion, contrat.status)))])],1),_vm._v(" "),_c('td',[(contrat.vencidoEsta !='' )?_c('div',[_c('span',[_vm._v("Nueva renta sugerida ")]),(contrat.rentaSugerida)?_c('span',[_c('b',[_vm._v("($"+_vm._s(_vm.formateaNumero(contrat.rentaSugerida/contrat.area))+"/m2)")])]):_vm._e(),_c('span',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(contrat.rentaSugerida),expression:"contrat.rentaSugerida"}],staticClass:"input",attrs:{"type":"number","name":"cuanto","number":""},domProps:{"value":(contrat.rentaSugerida)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(contrat, "rentaSugerida", $event.target.value)}}})]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(Number(contrat.rentaSugerida) >= Number(contrat.importeMes) && contrat.emailInquilino )?_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(contrat.mensaje='Apreciable ' + contrat.inquilino +' es necesario firmar su nuevo contrato en caso de que desee seguir rentando el inmueble ' + contrat.propiedad + '. Por lo que le informamos que su nueva renta será de $ ' + _vm.formateaNumero(contrat.rentaSugerida) + ' Por favor verifique sus datos en esta liga: ' + _vm.datosActuales + contrat.id ),expression:"contrat.mensaje='Apreciable ' + contrat.inquilino +' es necesario firmar su nuevo contrato en caso de que desee seguir rentando el inmueble ' + contrat.propiedad + '. Por lo que le informamos que su nueva renta será de $ ' + formateaNumero(contrat.rentaSugerida) + ' Por favor verifique sus datos en esta liga: ' + datosActuales + contrat.id "}],attrs:{"id":"mensaje","disabled":"","cols":"40","rows":"10"},domProps:{"value":(contrat.mensaje='Apreciable ' + contrat.inquilino +' es necesario firmar su nuevo contrato en caso de que desee seguir rentando el inmueble ' + contrat.propiedad + '. Por lo que le informamos que su nueva renta será de $ ' + _vm.formateaNumero(contrat.rentaSugerida) + ' Por favor verifique sus datos en esta liga: ' + _vm.datosActuales + contrat.id )},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(contrat.mensaje='Apreciable ' + contrat.inquilino +' es necesario firmar su nuevo contrato en caso de que desee seguir rentando el inmueble ' + contrat.propiedad + '. Por lo que le informamos que su nueva renta será de $ ' + _vm.formateaNumero(contrat.rentaSugerida) + ' Por favor verifique sus datos en esta liga: ' + _vm.datosActuales + contrat, "id", $event.target.value)}}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[(contrat.fechaAvisoRenovar)?_c('div',{staticStyle:{"color":"hsl(0,100%,50%)"}},[_c('div',{staticClass:"notification is-primary"},[_c('p',[_vm._v("\n                                        Ya avisado por mail el "+_vm._s(_vm.formateaFecha(contrat.fechaAvisoRenovar))+" a $"+_vm._s(_vm.formateaNumeroSimple(contrat.avisoNuevaRenta))+"\n                                    ")])])]):_vm._e()]),_vm._v(" "),(Number(contrat.rentaSugerida) > Number(contrat.importeMes) && contrat.emailInquilino )?_c('button',{staticClass:"button is-primary",on:{"click":function($event){return _vm.enviaMail(contrat.emailInquilino, contrat.rentaSugerida, contrat.mensaje, contrat.id)}}},[_vm._v("Enviar al mail "+_vm._s(contrat.emailInquilino)+"\n                        ")]):_vm._e(),_vm._v("   \n\n                        "),(contrat.celularInquilino && Number(contrat.rentaSugerida) >= Number(contrat.importeMes))?_c('div',[_c('a',{attrs:{"href":'https://wa.me/521' + contrat.celularInquilino + '?text=Apreciable%20' + contrat.inquilino +'%20es%20necesario%20firmar%20su%20nuevo%20contrato%20en%20caso%20de%20que%20desee%20seguir%20rentando%20el%20inmueble%20' + contrat.propiedad + '.%20Por%20lo%20que%20le%20informamos%20que%20su%20nueva%20renta%20será%20de%20$%20' + _vm.formateaNumero(contrat.rentaSugerida) + '%20Por%20favor%20verifique%20sus%20datos%20en%20esta%20liga:%20' + _vm.datosActuales + contrat.id,"target":"_blank"}},[_c('i',{staticClass:"fab fa-whatsapp fa-2x"})])]):_vm._e()]):_vm._e()])]):_vm._e()}),0)]):_c('div',[_c('button',{staticClass:"button is-primary is-loading"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('strong',[_vm._v("Contratos Renovación ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Propiedad")]),_vm._v(" "),_c('th',[_vm._v("Inquilino")]),_vm._v(" "),_c('th',[_vm._v("Nombre/Giro")]),_vm._v(" "),_c('th',[_vm._v("Familia")]),_vm._v(" "),_c('th',[_vm._v("Renta")]),_vm._v(" "),_c('th',[_vm._v("Inicio/Termino")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Avisar")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Movimiento_ver_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1ec4d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Movimiento_ver_vue__ = __webpack_require__(144);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Movimiento_ver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1ec4d3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Movimiento_ver_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Movimiento "+_vm._s(this.id))]),_vm._v(" "),(_vm.movimientoSolo !=null)?_c('div',{attrs:{"name":"movimiento-ver"}},_vm._l((_vm.movimientoSolo),function(movi){return _c('li',[(movi.idContrato !=null)?_c('h2',[_vm._v(_vm._s(movi.idContrato))]):_vm._e(),_vm._v(" "),(movi.importe !=null)?_c('p',[_vm._v(_vm._s(movi.importe))]):_vm._e(),_vm._v(" "),(movi.tipo !=null)?_c('p',[_vm._v(_vm._s(movi.tipo))]):_vm._e()])}),0):_c('span',[_vm._v("Cargando movimiento")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Movimiento_agregar_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e1abac8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Movimiento_agregar_vue__ = __webpack_require__(151);
function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Movimiento_agregar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e1abac8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Movimiento_agregar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(147);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("1aa399db", content, true, {});

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#propiAdd{padding:20px}#propiAdd li{width:20%;height:120px;background:#eee;overflow:hidden}", ""]);

// exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(149);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b569e6b2", content, true, {});

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Contratos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","id":"busca","align":"center","size":"20","placeholder":"Buscar","autofocus":""},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.contratosTodos !=null)?_c('ul',{attrs:{"id":"contratos-lista","align":"left"}},_vm._l((_vm.buscando),function(contra){return _c('li',[(_vm.esRentado(contra.status))?_c('div',{on:{"click":function($event){return _vm.lanza(contra.id, contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes)}}},[_c('strong',[_vm._v("\n\t\t\t\t\t\t\n\t\t\t\t\t    Contrato #  "+_vm._s(contra.id)+" "),_c('br'),_vm._v("\n\t\t\t\t\t\t  "+_vm._s(contra.inquilino)+" "),_c('br'),_c('br'),_vm._v("\n\t\t\t\t\t\t  "+_vm._s(contra.propiedad)),_c('br'),_c('br'),_vm._v(" "),_c('font',{attrs:{"color":"blue"}},[_vm._v(_vm._s(contra.giro)),_c('br'),_vm._v("\n\t\t\t\t\t    "+_vm._s(contra.nombreComercial)+" ")]),_c('br'),_c('br'),_vm._v("\n\t\t\t\t\t    "+_vm._s(contra.familia)+" "),_c('br'),_vm._v("\n\t\t\t\t\t    "+_vm._s(contra.subfamilia)+" "),_c('br'),_c('br'),_vm._v("\n                        "+_vm._s(contra.status)+" "),_c('br')],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-primary is-rounded",attrs:{"type":"button"},on:{"click":function($event){return _vm.lanza(contra.id, contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes)}}},[_vm._v(" Seleccionar\n\t\t\t\t")])]):_vm._e()])}),0):_c('span',[_vm._v("Cargando contratos ...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"moviAdd"}},[_c('h2',[_vm._v("Agregar Movimiento")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-primary is-rounded",attrs:{"type":"button"},on:{"click":_vm.aBuscar}},[_vm._v("BUSCAR CONTRATO")]),_vm._v(" "),_c('label',{model:{value:(this.movimientos.contrato),callback:function ($$v) {_vm.$set(this.movimientos, "contrato", $$v)},expression:"this.movimientos.contrato"}},[_vm._v(" "+_vm._s(_vm.movimientos.contrato))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[(_vm.buscar)?_c('hijo1',{on:{"eventoC":function($event){return _vm.recibeC.apply(void 0, arguments)}}},[_vm._v("Cargando contratos...")]):_vm._e()],1),_vm._v(" "),_c('form',{attrs:{"id":"visible"},on:{"submit":function($event){$event.preventDefault();return _vm.guardarMovimiento($event)}}},[_c('table',{staticClass:"table is-striped is-hoverable",attrs:{"align":"center"}},[_c('tr',[_c('td',[_vm._v("Inquilino Nombre")]),_vm._v(" "),_c('td',{model:{value:(this.movimientos.inquilinoNombre),callback:function ($$v) {_vm.$set(this.movimientos, "inquilinoNombre", $$v)},expression:"this.movimientos.inquilinoNombre"}},[_vm._v(_vm._s(_vm.movimientos.inquilinoNombre))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Propiedad Nombre:")]),_vm._v(" "),_c('td',{model:{value:(_vm.movimientos.propiedadNombre),callback:function ($$v) {_vm.$set(_vm.movimientos, "propiedadNombre", $$v)},expression:"movimientos.propiedadNombre"}},[_vm._v(_vm._s(_vm.movimientos.propiedadNombre))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Giro:")]),_vm._v(" "),_c('td',{model:{value:(_vm.movimientos.giro),callback:function ($$v) {_vm.$set(_vm.movimientos, "giro", $$v)},expression:"movimientos.giro"}},[_c('font',{attrs:{"color":"blue"}},[_vm._v(_vm._s(_vm.movimientos.giro))])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Familia:")]),_vm._v(" "),_c('td',{model:{value:(_vm.movimientos.familia),callback:function ($$v) {_vm.$set(_vm.movimientos, "familia", $$v)},expression:"movimientos.familia"}},[_c('font',{attrs:{"color":"blue"}},[_vm._v(_vm._s(_vm.movimientos.familia))])],1)]),_c('tr',[_c('td',[_vm._v("Tipo")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"select is-rounded"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.tipo),expression:"movimientos.tipo"}],attrs:{"id":"tipo","required":""},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.movimientos, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.visibles()}]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Tipo")]),_vm._v(" "),_c('option',{attrs:{"value":"PAGO"}},[_vm._v("PAGO DEL INQUILINO")]),_vm._v(" "),_c('option',{attrs:{"value":"COBRO"}},[_vm._v("COBRO AL INQUILINO")]),_vm._v(" "),_c('option',{attrs:{"value":"DEPOSITO EN GARANTIA"}},[_vm._v("DEPOSITO EN GARANTIA")]),_vm._v(" "),_c('option',{attrs:{"value":"AJUSTE POSITIVO"}},[_vm._v("AJUSTE POSITIVO")]),_vm._v(" "),_c('option',{attrs:{"value":"AJUSTE NEGATIVO"}},[_vm._v("AJUSTE NEGATIVO")])])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("concepto ")]),_vm._v(" "),_c('td',[(!_vm.esCobro)?_c('div',{staticClass:"select is-rounded"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.concepto),expression:"movimientos.concepto"}],attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.movimientos, "concepto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Concepto")]),_vm._v(" "),(!_vm.esCobro)?_c('option',{attrs:{"value":"A CUENTA"}},[_vm._v("A CUENTA")]):_vm._e(),_vm._v(" "),(_vm.esCobro)?_c('option',{attrs:{"value":"COBRO"}},[_vm._v("COBRO")]):_vm._e(),_vm._v(" "),(!_vm.esCobro)?_c('option',{attrs:{"value":"DEPOSITO EN GARANTIA"}},[_vm._v("DEPOSITO EN GARANTIA")]):_vm._e(),_vm._v(" "),(_vm.esCobro)?_c('option',{attrs:{"value":"AJUSTE NEGATIVO"}},[_vm._v("AJUSTE MENOS")]):_vm._e(),_vm._v(" "),(_vm.esCobro)?_c('option',{attrs:{"value":"AJUSTE POSITIVO"}},[_vm._v("AJUSTE MENOS")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.esCobro)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.concepto),expression:"movimientos.concepto"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"importe2","required":"","min":"1"},domProps:{"value":(_vm.movimientos.concepto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "concepto", $event.target.value)}}})]):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("importe ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.importe),expression:"movimientos.importe"}],staticClass:"input is-rounded",attrs:{"type":"number","name":"importe","required":"","min":"1"},domProps:{"value":(_vm.movimientos.importe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "importe", $event.target.value)}}})])]),_vm._v(" "),(!_vm.esCobro)?_c('tr',[_c('td',[_vm._v("Forma De Pago ")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"select is-rounded"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.formaDePago),expression:"movimientos.formaDePago"}],attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.movimientos, "formaDePago", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Forma")]),_vm._v(" "),_c('option',[_vm._v("DEPOSITO A TARJETA")]),_vm._v(" "),_c('option',[_vm._v("TRANSFERENCIA")]),_vm._v(" "),_c('option',[_vm._v("EFECTIVO")]),_vm._v(" "),_c('option',[_vm._v("CHEQUE")]),_vm._v(" "),_c('option',[_vm._v("PAGO CON EL DEPOSITO DE GARANTIA")]),_vm._v(" "),_c('option',[_vm._v("TARJETA DE CREDITO")]),_vm._v(" "),_c('option',[_vm._v("TARJETA DE DEBITO")]),_vm._v(" "),_c('option',[_vm._v("AJUSTE")])])])])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("fecha del movimiento")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.fecha),expression:"movimientos.fecha"}],staticClass:"input is-rounded",attrs:{"type":"date","name":"fecha","required":""},domProps:{"value":(_vm.movimientos.fecha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "fecha", $event.target.value)}}}),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.formateaFecha(_vm.movimientos.fecha))+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("quien capturo ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.quienCapturo),expression:"movimientos.quienCapturo"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"quienCapturo","disabled":""},domProps:{"value":(_vm.movimientos.quienCapturo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "quienCapturo", $event.target.value)}}})])]),_vm._v(" "),(!_vm.esCobro)?_c('tr',[_c('td',[_vm._v("quien pago ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.quienPago),expression:"movimientos.quienPago"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"quienPago","required":""},domProps:{"value":(_vm.movimientos.quienPago)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "quienPago", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(!_vm.esCobro)?_c('tr',[_c('td',[_vm._v("donde ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.donde),expression:"movimientos.donde"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"donde"},domProps:{"value":(_vm.movimientos.donde)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "donde", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),(!_vm.esCobro )?_c('tr',[_c('td',[_vm._v("ref deposito ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.refDeposito),expression:"movimientos.refDeposito"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"refDeposito"},domProps:{"value":(_vm.movimientos.refDeposito)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "refDeposito", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("referencia ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.referencia),expression:"movimientos.referencia"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"referencia"},domProps:{"value":(_vm.movimientos.referencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "referencia", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("comentario ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.comentario),expression:"movimientos.comentario"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"comentario"},domProps:{"value":(_vm.movimientos.comentario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "comentario", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("recibo ref.")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.recibo),expression:"movimientos.recibo"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"recibo"},domProps:{"value":(_vm.movimientos.recibo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "recibo", $event.target.value)}}})])]),_vm._v(" "),(!_vm.esCobro)?_c('tr',[_c('td',[_vm._v("quien recibió ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.recibio),expression:"movimientos.recibio"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"recibio","required":""},domProps:{"value":(_vm.movimientos.recibio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "recibio", $event.target.value)}}})])]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{staticClass:"button is-primary is-rounded",attrs:{"type":"submit","name":"agregandoMovimiento"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedad_seleccionar_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0ac1ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedad_seleccionar_vue__ = __webpack_require__(155);
function injectStyle (ssrContext) {
  __webpack_require__(153)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Propiedad_seleccionar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0ac1ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Propiedad_seleccionar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(154);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7deb6513", content, true, {});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#propiedades-lista{padding:20px}#propiedades-lista li{width:30%;height:120px;background:#eee;overflow:hidden}", ""]);

// exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Propiedades")]),_vm._v(" "),_c('router-link',{attrs:{"to":{name: 'agre-propi'}}},[_vm._v("Agregar")]),_vm._v(" "),(_vm.propiedadesTodas !=null)?_c('ul',{attrs:{"id":"propiedades-lista"}},_vm._l((_vm.propiedadesTodas),function(propi){return _c('li',[_c('strong',[_vm._v(_vm._s(propi.nombreCompleto)+" "+_vm._s(propi.familia)+" "+_vm._s(propi.tipo))])])}),0):_c('span',[_vm._v("Cargando propiedades...")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contratos_reporte_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00ba1d7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contratos_reporte_vue__ = __webpack_require__(157);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contratos_reporte_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00ba1d7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contratos_reporte_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"reporte1"}},[_c('h2',[_vm._v("Contratos Reporte ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"id":"abusca","type":"text","placeholder":"Buscar"},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.imprimir('reporte1')}}},[_vm._v("Impresión")]),_vm._v(" "),(_vm.contratosTodos !=null)?_c('ul',{attrs:{"id":"contratos-lista"}},[_c('table',[_c('thead',[_c('tr',[_c('th',[_vm._v("Contrato\t\t\t\n\t \t\t\t\t\t"),_c('button',{on:{"click":function($event){return _vm.ordenar(0,'registros')}}},[_vm._v("▵")])]),_vm._v(" "),_c('th',[_vm._v("Propiedad\n\t \t\t\t\t\t"),_c('button',{on:{"click":function($event){return _vm.ordenar(1,'registros')}}},[_vm._v("▵")])]),_vm._v(" "),_c('th',[_vm._v("Inquilino\n\t \t\t\t\t\t"),_c('button',{on:{"click":function($event){return _vm.ordenar(2,'registros')}}},[_vm._v("▵")])]),_vm._v(" "),_c('th',[_vm._v("Nombre\n\t \t\t\t\t\t"),_c('button',{on:{"click":function($event){return _vm.ordenar(3,'registros')}}},[_vm._v("▵")])]),_vm._v(" "),_c('th',[_vm._v("Giro\n\t \t\t\t\t\t"),_c('button',{on:{"click":function($event){return _vm.ordenar(4,'registros')}}},[_vm._v("▵")])]),_vm._v(" "),_c('th',{attrs:{"id":"ren"}},[_vm._v("Renta/mes\n\t \t\t\t\t\t"),_c('button',{on:{"click":function($event){return _vm.ordenar(5,'registros')}}},[_vm._v("▵")])]),_vm._v(" "),_c('th',[_vm._v("Modificado\n\t \t\t\t\t\t"),_c('button',{on:{"click":function($event){return _vm.ordenar(6,'registros')}}},[_vm._v("▵")])]),_vm._v(" "),_c('th',[_vm._v("Por\n\t \t\t\t\t\t"),_c('button',{on:{"click":function($event){return _vm.ordenar(7,'registros')}}},[_vm._v("▵")])])])]),_vm._v(" "),_c('tbody',{attrs:{"id":"registros"}},_vm._l((_vm.buscando),function(contrat){return _c('tr',{on:{"click":function($event){return _vm.seleccion(contrat.id)}}},[_c('td',[_vm._v(_vm._s(contrat.id)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contrat.propiedad)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contrat.inquilino)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contrat.nombreComercial)+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contrat.giro)+" ")]),_vm._v(" "),_c('td',{directives:[{name:"if",rawName:"v-if:contrat.importeMes",arg:"contrat",modifiers:{"importeMes":true}}],attrs:{"id":"imp"}},[_vm._v(_vm._s(_vm._f("FormateaNumero")(contrat.importeMes))+" ")]),_vm._v(" "),_c('td',{directives:[{name:"if",rawName:"v-if:contrat.fechaModificacion",arg:"contrat",modifiers:{"fechaModificacion":true}}]},[_vm._v(_vm._s(_vm._f("FormateaFecha")(contrat.fechaModificacion,contrat.fechaModificacion))+" ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contrat.quienModifico)+" ")])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',[_c('strong',[_vm._v("TOTAL "+_vm._s(_vm.cuentalos))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_vm._v("TOTAL "+_vm._s(_vm._f("FormateaNumero")(_vm.lasuma(_vm.buscando))))])])])])])]):_c('span',[_vm._v("Cargando contratos...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagos_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0241025a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagos_vue__ = __webpack_require__(161);
function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0241025a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(160);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("78ed228a", content, true, {});

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"altaPago"}},[_c('h2',[_vm._v("Pago")]),_vm._v(" "),_c('p',[(_vm.buscar)?_c('hijo1',{on:{"eventoC":function($event){return _vm.recibeC.apply(void 0, arguments)}}},[_vm._v("Cargando contratos...")]):_vm._e()],1),_vm._v(" "),_c('form',{attrs:{"id":"visible"},on:{"submit":function($event){$event.preventDefault();return _vm.guardarMovimiento($event)}}},[_c('table',{staticClass:"table is-striped",attrs:{"align":"center","border":"1"}},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Contrato Num. ")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.contrato),expression:"movimientos.contrato"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"contrato","required":"true","disabled":""},domProps:{"value":(_vm.movimientos.contrato)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "contrato", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"button is-primary is-rounded",attrs:{"type":"button"},on:{"click":_vm.aBuscar}},[_vm._v("BUSCAR")])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Inquilino")]),_vm._v(" "),_c('td',[_c('label',{attrs:{"name":"inquilinoNombre"},model:{value:(_vm.movimientos.inquilinoNombre),callback:function ($$v) {_vm.$set(_vm.movimientos, "inquilinoNombre", $$v)},expression:"movimientos.inquilinoNombre"}},[_vm._v(_vm._s(_vm.movimientos.inquilinoNombre))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Propiedad")]),_vm._v(" "),_c('td',[_c('label',{attrs:{"name":"propiedadNombre"},model:{value:(_vm.movimientos.propiedadNombre),callback:function ($$v) {_vm.$set(_vm.movimientos, "propiedadNombre", $$v)},expression:"movimientos.propiedadNombre"}},[_vm._v(_vm._s(_vm.movimientos.propiedadNombre))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Giro")]),_vm._v(" "),_c('td',[_c('label',{attrs:{"name":"giro"},model:{value:(_vm.movimientos.giro),callback:function ($$v) {_vm.$set(_vm.movimientos, "giro", $$v)},expression:"movimientos.giro"}},[_c('b',[_vm._v(_vm._s(_vm.movimientos.giro))])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Familia")]),_vm._v(" "),_c('td',[_c('label',{attrs:{"name":"familia"},model:{value:(_vm.movimientos.familia),callback:function ($$v) {_vm.$set(_vm.movimientos, "familia", $$v)},expression:"movimientos.familia"}},[_c('b',[_vm._v(_vm._s(_vm.movimientos.familia))])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Sub familia")]),_vm._v(" "),_c('td',[_c('label',{attrs:{"name":"subfam"},model:{value:(_vm.movimientos.subfamilia),callback:function ($$v) {_vm.$set(_vm.movimientos, "subfamilia", $$v)},expression:"movimientos.subfamilia"}},[_vm._v(_vm._s(_vm.movimientos.subfamilia))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Dueno")]),_vm._v(" "),_c('td',[_c('label',{attrs:{"name":"dueno"},model:{value:(_vm.movimientos.dueno),callback:function ($$v) {_vm.$set(_vm.movimientos, "dueno", $$v)},expression:"movimientos.dueno"}},[_vm._v(_vm._s(_vm.movimientos.dueno))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Renta mensual")]),_vm._v(" "),_c('td',[_c('label',{attrs:{"name":"renta"},model:{value:(_vm.renta),callback:function ($$v) {_vm.renta=$$v},expression:"renta"}},[_vm._v("$ "+_vm._s(_vm.formateaNumero(_vm.renta)))])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Concepto")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"select is-rounded"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.concepto),expression:"movimientos.concepto"}],attrs:{"name":"concepto","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.movimientos, "concepto", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"A CUENTA RENTA","selected":""}},[_vm._v("A CUENTA RENTA")]),_vm._v(" "),_c('option',{attrs:{"value":"A CUENTA AGUA"}},[_vm._v("AGUA")]),_vm._v(" "),_c('option',{attrs:{"value":"A CUENTA LUZ"}},[_vm._v("LUZ")]),_vm._v(" "),_c('option',{attrs:{"value":"MANTENIMIENTO"}},[_vm._v("MANTENIMIENTO")])])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Importe")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.importe),expression:"movimientos.importe"}],staticClass:"input is-rounded",attrs:{"type":"number","name":"importe","required":"true","min":"1"},domProps:{"value":(_vm.movimientos.importe)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "importe", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Forma De Pago")]),_vm._v(" "),_c('td',[_c('div',{staticClass:"select is-rounded"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.formaDePago),expression:"movimientos.formaDePago"}],attrs:{"name":"formaDePago","required":"true"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.movimientos, "formaDePago", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"TRANSFERENCIA"}},[_vm._v("TRANSFERENCIA")]),_vm._v(" "),_c('option',{attrs:{"value":"DEPOSITO"}},[_vm._v("DEPOSITO")]),_vm._v(" "),_c('option',{attrs:{"value":"EFECTIVO"}},[_vm._v("EFECTIVO")]),_vm._v(" "),_c('option',{attrs:{"value":"CHEQUE"}},[_vm._v("CHEQUE")]),_vm._v(" "),_c('option',{attrs:{"value":"TARJETA CREDITO"}},[_vm._v("TARJETA CREDITO")]),_vm._v(" "),_c('option',{attrs:{"value":"TARJETA DEBITO"}},[_vm._v("TARJETA DEBITO")])])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Referencia")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.referencia),expression:"movimientos.referencia"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"referencia"},domProps:{"value":(_vm.movimientos.referencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "referencia", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Comentario")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.comentario),expression:"movimientos.comentario"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"comentario"},domProps:{"value":(_vm.movimientos.comentario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "comentario", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Fecha del pago")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.fecha),expression:"movimientos.fecha"}],staticClass:"input is-rounded",attrs:{"type":"date","id":"fecha1","required":"true"},domProps:{"value":(_vm.movimientos.fecha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "fecha", $event.target.value)}}}),_vm._v(_vm._s(_vm.formateaFecha(_vm.movimientos.fecha)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Usuario captura")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.quienCapturo),expression:"movimientos.quienCapturo"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"quienCapturo","disabled":""},domProps:{"value":(_vm.movimientos.quienCapturo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "quienCapturo", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Quien pagó")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.quienPago),expression:"movimientos.quienPago"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"quienPago","required":"true","minlength":"4"},domProps:{"value":(_vm.movimientos.quienPago)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "quienPago", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Donde pagó")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.donde),expression:"movimientos.donde"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"donde","required":"true","minlength":"4"},domProps:{"value":(_vm.movimientos.donde)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "donde", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Quien recibió\n\t\t\t\t  ")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.movimientos.recibio),expression:"movimientos.recibio"}],staticClass:"input is-rounded",attrs:{"type":"text","name":"recibio","required":"true","minlength":"4"},domProps:{"value":(_vm.movimientos.recibio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.movimientos, "recibio", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_vm._m(1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.envioMail),expression:"envioMail"}],staticClass:"input is-rounded",attrs:{"type":"email","name":"envioAlMail"},domProps:{"value":(_vm.envioMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.envioMail=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('strong',[_vm._v("\n\t\t\t\t    SUBIR RECIBOS DE IMAGENES O PDF \n\t    \t\t")]),_vm._v(" "),_c('div',{staticClass:"large-12 medium-12 small-12 cell"},[_c('label',[_c('input',{ref:"cualFile",attrs:{"type":"file","id":"miArchivoRentus"},on:{"change":function($event){return _vm.archivoAsubir()}}})]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.enviaElArchivo()}}},[_vm._v("Subir")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('input',{staticClass:"button is-rounded is-primary",attrs:{"type":"submit","name":"agregandoMovimiento"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_vm._v("Enviar recibo al mail")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reporteador_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_346f10e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reporteador_vue__ = __webpack_require__(165);
function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reporteador_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_346f10e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reporteador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(164);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("58f8ccfd", content, true, {});

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"reporteador"}},[_c('h2',[_vm._v("Reporteador")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"pru1"}},[_c('button-counter')],1),_vm._v(" "),_c('div',{staticStyle:{"border":"2px solid aquamarine"},attrs:{"id":"configReporte","align":"left"}},[_c('div',{attrs:{"align":"center"}},[_vm._v("Diseño de reportes\n\t\t\t\t\t"),_c('br'),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"id":"leerReporte","to":{name: 'repor-leer'}}},[_c('br'),_vm._v("Leer un reporte previo\n\t\t\t\t")])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Archivo: "+_vm._s(_vm.cualArchivo2)+"\n\t\t\t\t"),_c('select',{staticClass:"select is-primary",attrs:{"id":"elArchivo"},on:{"change":function($event){_vm.getRegistros(); _vm.limpia(); _vm.iniciaDrop()}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table "},[_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\tCampos a incluir\n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seleccion),expression:"seleccion"}],staticClass:"select is-primary",attrs:{"id":"loscampos"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seleccion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.ponCampo(_vm.seleccion);_vm.generaCampo();_vm.generaCampoFechas();_vm.generaCampoNumeros();_vm.generaCampoTotales()}]}}),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.seleccion)+"\n\t\t\t\t\t\t")])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\tCampos a ordenar \n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seleccion2),expression:"seleccion2"}],staticClass:"select is-primary",attrs:{"id":"losorden"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seleccion2=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.ponCampoOrden(_vm.seleccion2);_vm.generaCampoOrden();}]}}),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.seleccion2)+"\n\t\t\t\t\t\t")])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\tCampos a filtrar \n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seleccion3),expression:"seleccion3"}],staticClass:"select is-primary",attrs:{"id":"losfiltros"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seleccion3=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.ponCampoFiltro(_vm.seleccion3);_vm.generaCampoFiltro();}]}}),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.seleccion3)+"\n\t\t\t\t\t\t")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"border":"2px solid aquamarine"},attrs:{"id":"reporte"}},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('button',{staticClass:"button is-primary",on:{"click":function($event){return _vm.generaReporte()}}},[_vm._v("Generar reporte")]),_vm._v("\n\t\t\t\t\t    \n\t\t\t\t\t"),_c('button',{staticClass:"button is-primary",on:{"click":function($event){return _vm.guardarReporte()}}},[_vm._v("Guardar reporte")]),_vm._v("\n\t\t\t\t\t    \n\t\t\t\t\t"),_c('button',{staticClass:"button is-primary",on:{"click":function($event){return _vm.imprimir('reporteAver')}}},[_vm._v("Imprimir reporte")])]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"column is-one-quarter"},[_vm._v("\n\t\t\tFiltro \n\t\t\t"),_c('select',{staticClass:"select is-primary",attrs:{"id":"cualFiltroUsar"},on:{"change":function($event){return _vm.limpiar()}}}),_vm._v(" "),_c('br'),_vm._v("\n\t\t\tDe"),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtroTexto),expression:"filtroTexto"}],staticClass:"input is-primary",attrs:{"size":"35","type":"text","id":"cualFiltroTexto"},domProps:{"value":(_vm.filtroTexto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filtroTexto=$event.target.value}}}),_vm._v("\n\t\t\tA"),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtroTexto2),expression:"filtroTexto2"}],staticClass:"input is-primary",attrs:{"size":"35","type":"text","id":"cualFiltroTexto2"},domProps:{"value":(_vm.filtroTexto2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filtroTexto2=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.filtrar()}}},[_vm._v("\n\t\t\t\tFILTRAR\n\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"button is-primary",on:{"click":function($event){_vm.generaReporte(); _vm.quitarParametros()}}},[_vm._v("\n\t\t\t\tQUITAR FILTROS\n\t\t\t")])]),_vm._v(" "),_c('div',{attrs:{"id":"reporteAver","align":"left"}},[_c('br'),_vm._v(" "),_c('h1',[_c('strong',[_vm._v(_vm._s(_vm.nombreDelReporte))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Contenido:"+_vm._s(_vm.banerFiltros))]),_vm._v(" "),_c('br'),_vm._v(" "),(this.registrosTodos !=null)?_c('ul',{attrs:{"id":"todos-lista"}},[_c('table',{staticClass:"table is-striped is-hoverable",attrs:{"align":"left"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.titulo('0'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('1'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('2'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('3'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('4'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('5'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('6'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('7'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('8'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('9'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('10'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('11'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('12'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('13'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('14'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('15'))+"\n\t\t \t\t\t\t\t")])])]),_vm._v(" "),_c('tbody',{attrs:{"id":"registros"}},_vm._l((this.registrosTodos),function(contrat){return _c('tr',{on:{"click":function($event){return _vm.seleccion(contrat.id)}}},[_c('td',[_vm._v(_vm._s(_vm.colum('0',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('1',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('2',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('3',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('4',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('5',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('6',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('7',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('8',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('9',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('10',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('11',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('12',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('13',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('14',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('15',contrat)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.total("0")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("1")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("2")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("3")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("4")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("5")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("6")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("7")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("8")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("9")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("10")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("11")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("12")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("13")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("14")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("15")))])])])])]):_c('span',[_vm._v("Cargando ...")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"2px solid aquamarine"},attrs:{"id":"elReporte"}},[_vm._v("\n\t\t\t\t\tCampos incluidos:\n\t\t\t\t\t"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"2px solid aquamarine"},attrs:{"id":"elOrden"}},[_vm._v("\n\t\t\t\t\tOrden:\n\t\t\t\t\t"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"2px solid aquamarine"},attrs:{"id":"elFiltro"}},[_vm._v("\n\t\t\t\t\tFiltros:\n\t\t\t\t\t"),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuario_agregar_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53144100_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuario_agregar_vue__ = __webpack_require__(167);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuario_agregar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53144100_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuario_agregar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"usuAdd"}},[_c('h2',[_vm._v("AGREGAR USUARIO "+_vm._s(_vm.empresa))]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.guardarUsuario($event)}}},[_c('table',{attrs:{"align":"center"}},[_c('tr',[_c('td',{attrs:{"align":"left"}},[_vm._v("nombre completo ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.nombreCompleto),expression:"usuarios.nombreCompleto"}],attrs:{"type":"text","name":"nombreCompleto","required":"","autofocus":"","minlength":"5"},domProps:{"value":(_vm.usuarios.nombreCompleto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "nombreCompleto", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"left"}},[_vm._v("email ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.email),expression:"usuarios.email"}],attrs:{"type":"email","name":"email","required":""},domProps:{"value":(_vm.usuarios.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "email", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"left"}},[_vm._v("password ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.pase1),expression:"usuarios.pase1"}],attrs:{"type":"password","name":"pase1","required":"","minlength":"4"},domProps:{"value":(_vm.usuarios.pase1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "pase1", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"left"}},[_vm._v("password(otra vez) ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.pase2),expression:"usuarios.pase2"}],attrs:{"type":"password","name":"pase2","minlength":"4","required":""},domProps:{"value":(_vm.usuarios.pase2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "pase2", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"left"}},[_vm._v("celular ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.celular),expression:"usuarios.celular"}],attrs:{"type":"tel","name":"celular","required":"","minlength":"10"},domProps:{"value":(_vm.usuarios.celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "celular", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"left"}},[_vm._v("whatsapp ")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.whatsapp),expression:"usuarios.whatsapp"}],attrs:{"type":"tel","name":"whatsapp"},domProps:{"value":(_vm.usuarios.whatsapp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "whatsapp", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"left"}},[_vm._v("permisos ")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seleccion),expression:"seleccion"}],attrs:{"name":"permisos"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seleccion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.agregaSeleccion(_vm.seleccion)}]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Seleccione para agregar")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Consulta")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Altas")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Ver detalle")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Editar")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Altas")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Ver Detalle")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Editar")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Altas")]),_vm._v(" "),_c('option',[_vm._v("Contratos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Contratos Altas")]),_vm._v(" "),_c('option',[_vm._v("Contratos Ver detalle")]),_vm._v(" "),_c('option',[_vm._v("Contratos Editar")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Altas")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Cobros Consulta")]),_vm._v(" "),_c('option',[_vm._v("Cobros Altas")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Propiedades ")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Inquilinos")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Movimientos")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Contratos")]),_vm._v(" "),_c('option',[_vm._v("Usuarios Altas")]),_vm._v(" "),_c('option',[_vm._v("Usuarios Editar")])]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.cadenaSeleccion)+"\n\n\t\t\t\t")])]),_vm._v(" "),_c('td'),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('input',{attrs:{"type":"submit","name":"agregandoUsuario"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuario_editar_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2414b1ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuario_editar_vue__ = __webpack_require__(169);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Usuario_editar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2414b1ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Usuario_editar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"usuario-editar"}},[_c('h2',[_vm._v("EDITAR USUARIO ")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"usuario-ver","align":"center"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.guardarUsuario($event)}}},[_c('table',[_c('tr',[_c('td',[_vm._v("Mail")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.mail),expression:"usuarios.mail"}],attrs:{"type":"text","name":"mail","disabled":"","size":"40px"},domProps:{"value":(_vm.usuarios.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "mail", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Nombre ")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.nombreCompleto),expression:"usuarios.nombreCompleto"}],attrs:{"type":"text","name":"nombreCompleto","disabled":"","size":"40px"},domProps:{"value":(_vm.usuarios.nombreCompleto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "nombreCompleto", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Su clave")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.suClave),expression:"usuarios.suClave"}],attrs:{"type":"text","name":"suClave","required":""},domProps:{"value":(_vm.usuarios.suClave)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "suClave", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Celular")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.celular),expression:"usuarios.celular"}],attrs:{"type":"text","name":"celular","required":""},domProps:{"value":(_vm.usuarios.celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "celular", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Whatsapp")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.whatsapp),expression:"usuarios.whatsapp"}],attrs:{"type":"text","name":"whatsapp","required":""},domProps:{"value":(_vm.usuarios.whatsapp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.usuarios, "whatsapp", $event.target.value)}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Status")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuarios.status),expression:"usuarios.status"}],attrs:{"name":"status","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.usuarios, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"A"}},[_vm._v("ALTA")]),_vm._v(" "),_c('option',{attrs:{"value":"B"}},[_vm._v("BAJA")]),_vm._v(" "),_c('option',{attrs:{"value":"I"}},[_vm._v("INACTIVO")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Permisos actuales: \n\t\t\t\t\t")]),_vm._v(" "),_c('td',{attrs:{"width":"80px"}},[_vm._v(_vm._s(_vm.cadenaSeleccion)+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Permisos a agregar:\n\t\t\t\t  ")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seleccion),expression:"seleccion"}],attrs:{"name":"permisos"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seleccion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.agregaSeleccion(_vm.seleccion)}]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Seleccione para agregar")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Consulta")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Altas")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Ver detalle")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Editar")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Altas")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Ver Detalle")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Editar")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Altas")]),_vm._v(" "),_c('option',[_vm._v("Contratos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Contratos Altas")]),_vm._v(" "),_c('option',[_vm._v("Contratos Ver detalle")]),_vm._v(" "),_c('option',[_vm._v("Contratos Editar")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Altas")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Cobros Consulta")]),_vm._v(" "),_c('option',[_vm._v("Cobros Altas")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Propiedades ")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Inquilinos")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Movimientos")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Contratos")]),_vm._v(" "),_c('option',[_vm._v("Usuarios Altas")]),_vm._v(" "),_c('option',[_vm._v("Usuarios Editar")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Permisos a quitar:")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seleccionQ),expression:"seleccionQ"}],attrs:{"name":"permiq"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seleccionQ=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.quitarSeleccion(_vm.seleccionQ)}]}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Seleccione para quitar")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Consulta")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Altas")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Ver detalle")]),_vm._v(" "),_c('option',[_vm._v("Propiedades Editar")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Altas")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Ver Detalle")]),_vm._v(" "),_c('option',[_vm._v("Inquilinos Editar")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Altas")]),_vm._v(" "),_c('option',[_vm._v("Contratos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Contratos Altas")]),_vm._v(" "),_c('option',[_vm._v("Contratos Ver detalle")]),_vm._v(" "),_c('option',[_vm._v("Contratos Editar")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Altas")]),_vm._v(" "),_c('option',[_vm._v("Movimientos Consulta")]),_vm._v(" "),_c('option',[_vm._v("Cobros Consulta")]),_vm._v(" "),_c('option',[_vm._v("Cobros Altas")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Propiedades ")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Inquilinos")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Movimientos")]),_vm._v(" "),_c('option',[_vm._v("Reportes de Contratos")]),_vm._v(" "),_c('option',[_vm._v("Usuarios Altas")]),_vm._v(" "),_c('option',[_vm._v("Usuarios Editar")])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"submit","name":"agregandoUsuario"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Formato_agregar_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4900eced_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Formato_agregar_vue__ = __webpack_require__(175);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Formato_agregar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4900eced_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Formato_agregar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContratosY_pre_contratos_buscar_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f993bec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContratosY_pre_contratos_buscar_vue__ = __webpack_require__(174);
function injectStyle (ssrContext) {
  __webpack_require__(172)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContratosY_pre_contratos_buscar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f993bec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContratosY_pre_contratos_buscar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(173);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6941dd6b", content, true, {});

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Contratos y Pre-Contratos")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","id":"busca","align":"center","size":"20","placeholder":"Buscar","autofocus":""},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.contratosTodos !=null)?_c('ul',{attrs:{"id":"contratos-lista","align":"left"}},_vm._l((_vm.buscando),function(contra){return _c('li',[(_vm.esRentado(contra.status))?_c('div',{on:{"click":function($event){return _vm.lanza(contra.id, contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes, contra.claveCat)}}},[_c('strong',[_vm._v("\n\t\t\t\t\t\t\n\t\t\t\t\t    Contrato Num.  "+_vm._s(contra.id)+" "),_c('br'),_vm._v("\n\t\t\t\t\t\t  Inquilino: "+_vm._s(contra.inquilino)+" "),_c('br'),_c('br'),_vm._v("\n\t\t\t\t\t\t  Propiedad: "+_vm._s(contra.propiedad)),_c('br'),_c('br'),_vm._v("\n\t\t\t\t\t\t  Giro: "),_c('font',{attrs:{"color":"purple"}},[_vm._v(_vm._s(contra.giro)),_c('br'),_vm._v("\n\t\t\t\t\t    "+_vm._s(contra.nombreComercial)+" ")]),_c('br'),_c('br'),_vm._v("\n                        Renta mensual: "+_vm._s(contra.importeMes)+" "),_c('br'),_vm._v("\n\t\t\t\t\t    "+_vm._s(contra.familia)+" "),_c('br'),_vm._v("\n\t\t\t\t\t    "+_vm._s(contra.subfamilia)+"  "),_c('br'),_vm._v("\n                        "+_vm._s(contra.claveCat)+"  "),_c('br'),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(contra.status =='PRE-CONTRATO' )?_c('font',{attrs:{"color":"red"}},[_vm._v(_vm._s(contra.status))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(contra.status !='PRE-CONTRATO' )?_c('font',{attrs:{"color":"black"}},[_vm._v(_vm._s(contra.status))]):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-primary is-rounded",attrs:{"type":"button"},on:{"click":function($event){return _vm.lanza(contra.id, contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes, contra.claveCat)}}},[_vm._v(" Seleccionar\n\t\t\t\t")])]):_vm._e()])}),0):_c('span',[_vm._v("Cargando contratos ...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"formateador"}},[_c('H2',[_vm._v("Crear Formato de \n\t"),_c('br'),_vm._v("un Contrato o de un Pre-Contrato\n\t"),_c('br'),_vm._v("para imprimir\n")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("regresar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',[(_vm.buscar)?_c('hijo1',{on:{"eventoConYpre":function($event){return _vm.recibeC.apply(void 0, arguments)}}},[_vm._v("Cargando contratos...")]):_vm._e()],1),_vm._v(" "),_c('div',{attrs:{"id":"esVisible"}},[_c('table',{attrs:{"align":"center"}},[_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\tContrato num.  \n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.contratoSolo.id),expression:"contratoSolo.id"}],attrs:{"type":"text","id":"contra","disabled":""},domProps:{"value":(_vm.contratoSolo.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contratoSolo, "id", $event.target.value)}}}),_vm._v(" "),_c('input',{attrs:{"type":"button","name":"bus","value":"Buscar"},on:{"click":_vm.aBuscar}})])]),_vm._v(" "),_c('tr'),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(this.contratoSolo.inquilino)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(this.contratoSolo.giro)+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(this.contratoSolo.propiedad)+" "+_vm._s(this.contratoSolo.familia)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(this.contratoSolo.nombreComercial)+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_c('font',{attrs:{"color":"red"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(this.contratoSolo.status)+" \n\t\t\t\t\t\t")])],1)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('tr',[_c('td',{attrs:{"align":"right"}},[_vm._v("\n\t\t\t\t\t\tDato a incluir \n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seleccion),expression:"seleccion"}],attrs:{"id":"loscampos"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seleccion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.agrega()}]}}),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.seleccion)+"\n\t\t\t\t\t\t")])])])]),_vm._v(" "),_c('br'),_vm._v("\n\t\t\t\n\t\t\tLeer un formato:\n\t\t\t"),_c('input',{attrs:{"type":"file","accept":".for"},on:{"change":function($event){return _vm.leerFormato(_vm.event)}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"areaTexto"}},[_c('textarea',{attrs:{"id":"contenido","rows":"100%","cols":"100%"},on:{"click":function($event){return _vm.posicion()},"keydown":_vm.keymonitor}})]),_vm._v(" "),_c('div',[_c('button',{attrs:{"id":"bRemplazar"},on:{"click":function($event){return _vm.remplazar()}}},[_c('b',[_vm._v("Generar contrato")])]),_vm._v(" "),_c('button',{attrs:{"id":"bModificar"},on:{"click":function($event){return _vm.modificar()}}},[_c('b',[_vm._v("Ver formato")])]),_vm._v(" "),_c('button',{attrs:{"id":"bGuardarFor"},on:{"click":function($event){_vm.guardarFor(_vm.obtieneContenido())}}},[_c('b',[_vm._v("Guardar como Formato")])]),_vm._v(" "),_c('button',{attrs:{"id":"bGuardarCon"},on:{"click":function($event){_vm.guardarCon(_vm.obtieneContenido())}}},[_c('b',[_vm._v("Guardar Contrato lleno")])]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.imprimir('contenido')}}},[_c('b',[_vm._v("Imprimir o crear PDF")])]),_vm._v(" "),_c('br'),_c('br')])]),_vm._v(" "),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Estados_de_cuenta_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0279d7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Estados_de_cuenta_vue__ = __webpack_require__(179);
function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Estados_de_cuenta_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0279d7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Estados_de_cuenta_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(178);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("ca12175c", content, true, {});

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "#contratos-lista{padding:20px}#contratos-lista li{width:100%;height:100%;background:#eee;overflow:hidden;text-align:left}", ""]);

// exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Estados de Cuenta")]),_vm._v(" "),(_vm.ifin=='nop')?_c('h2',[_c('strong',[_vm._v(" RENTADOS ACTUALMENTE")])]):_vm._e(),_vm._v(" "),(_vm.ifin=='sip')?_c('h2',[_c('strong',[_vm._v(" FINALIZADOS ")])]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(" Ver solo los finalizados "),_c('input',{attrs:{"type":"checkbox","id":"incluyeFinalizados"},on:{"click":function($event){return _vm.cambioIncluye()}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.abuscar),expression:"abuscar"}],attrs:{"type":"text","placeholder":"BUSCAR"},domProps:{"value":(_vm.abuscar)},on:{"input":function($event){if($event.target.composing){ return; }_vm.abuscar=$event.target.value}}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-danger",attrs:{"name":"envio"},on:{"click":function($event){return _vm.enviaMails()}}},[_vm._v("Enviar Estados de Cuenta a cada Inquilino por Mail ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[(_vm.contratosTodos !=null)?_c('ul',{attrs:{"id":"contratos-lista","align":"left"}},_vm._l((_vm.contratosTodosBuscar),function(contrat){return _c('li',[_c('strong',[_c('p',[_vm._v("Contrato # "+_vm._s(contrat.contrato))]),_vm._v(" "),_c('p',[_vm._v("Mail registrado: "+_vm._s(contrat.email))]),_vm._v(" "),(contrat.total > 0)?_c('p',[_vm._v("Saldo actual: "),_c('font',{attrs:{"color":"red"}},[_vm._v(" $ "+_vm._s(_vm.formateaNumero(contrat.total)))])],1):_vm._e(),_vm._v(" "),(contrat.total/contrat.importeMes > 2)?_c('p',[_c('font',{attrs:{"color":"red"}},[_vm._v(" ***** "+_vm._s((contrat.total/contrat.importeMes).toFixed(0))+" meses *****\n                                ")])],1):_vm._e(),_vm._v(" "),(contrat.total <= 0)?_c('p',[_vm._v("Saldo actual: $ "+_vm._s(_vm.formateaNumero(contrat.total)))]):_vm._e(),_vm._v(" "),_c('p',[_c('font',{attrs:{"color":"Olive"}},[_vm._v(_vm._s(contrat.familia))])],1),_vm._v(" "),_c('p',[_c('font',{attrs:{"color":"Olive"}},[_vm._v(_vm._s(contrat.nombreComercial))])],1),_vm._v(" "),_c('p',[_c('font',{attrs:{"color":"Olive"}},[_vm._v(_vm._s(contrat.giro))])],1),_vm._v(" "),_c('p',[_vm._v(_vm._s(contrat.propiedad))]),_vm._v(" "),_c('p',[_vm._v("Dueño: "+_vm._s(contrat.dueno))]),_vm._v(" "),_c('p',[_vm._v("Status: "+_vm._s(contrat.status))]),_vm._v(" "),_c('p',[_vm._v("Renta Mensual: $ "+_vm._s(_vm.formateaNumero(contrat.importeMes)))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.verContrato(contrat.contrato)}}},[_c('button',{staticClass:"button is-primary"},[_vm._v("Ver Estado de cuenta")])]),_vm._v(" "),(_vm.verEstadoCta == true && _vm.cualContratoVer == contrat.contrato)?_c('div',{attrs:{"id":"verEdo","align":"center"}},[_c('button',{staticClass:"button is-warning",on:{"click":function($event){_vm.verEstadoCta= false}}},[_vm._v("Cerrar")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('estado-individual',{attrs:{"cualContrato":_vm.numContrato,"vector":_vm.vector}}),_vm._v(" "),_c('br'),_c('br')],1):_vm._e()]),_vm._v(" "),_c('br')])}),0):_c('span',[_c('button',{staticClass:"button is-primary is-loading"},[_vm._v("Loading")])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',[(_vm.totalSaldos)?_c('strong',[_vm._v(" Total Saldos hoy: $ "+_vm._s(_vm.formateaNumero(_vm.totalSaldos)))]):_vm._e()]),_vm._v(" "),_c('p',[(_vm.totalSaldos)?_c('strong',[_vm._v(" Total Rentas Mensuales: $ "+_vm._s(_vm.formateaNumero(_vm.totalRentas)))]):_vm._e()]),_vm._v(" "),_c('p',[(_vm.totalSaldos)?_c('strong',[_vm._v(" Total Unidades: "+_vm._s(_vm.formateaNumero(_vm.totalPropiedades)))]):_vm._e()]),_vm._v(" "),_c('br'),_c('br')])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportesHechos_vue__ = __webpack_require__(53);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1535e443_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportesHechos_vue__ = __webpack_require__(183);
function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportesHechos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1535e443_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportesHechos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(182);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("20cacc20", content, true, {});

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"reporteador"}},[_c('H2',[_vm._v("Reportes Disponibles")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"pru1"}},[_c('button-counter')],1),_vm._v(" "),_c('div',[_vm._v("Seleccione el Reporte \n\t"),_c('select',{attrs:{"id":"selReportes"},on:{"click":_vm.reporteSeleccionado}})]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"}},[_c('div',{staticStyle:{"border":"2px solid aquamarine"},attrs:{"id":"configReporte","align":"left"}},[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Archivo: "+_vm._s(_vm.cualArchivo2)+"\n\t\t\t\t"),_c('select',{staticClass:"select is-primary",attrs:{"id":"elArchivo"},on:{"change":function($event){_vm.getRegistros(); _vm.limpia(); _vm.iniciaDrop()}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table "},[_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\tCampos a incluir\n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seleccion),expression:"seleccion"}],staticClass:"select is-primary",attrs:{"id":"loscampos"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seleccion=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.ponCampo(_vm.seleccion);_vm.generaCampo();_vm.generaCampoFechas();_vm.generaCampoNumeros();_vm.generaCampoTotales()}]}}),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.seleccion)+"\n\t\t\t\t\t\t")])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\tCampos a ordenar \n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seleccion2),expression:"seleccion2"}],staticClass:"select is-primary",attrs:{"id":"losorden"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seleccion2=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.ponCampoOrden(_vm.seleccion2);_vm.generaCampoOrden();}]}}),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.seleccion2)+"\n\t\t\t\t\t\t")])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n\t\t\t\t\t\tCampos a filtrar \n\t\t\t\t\t")]),_vm._v(" "),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.seleccion3),expression:"seleccion3"}],staticClass:"select is-primary",attrs:{"id":"losfiltros"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.seleccion3=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.ponCampoFiltro(_vm.seleccion3);_vm.generaCampoFiltro();}]}}),_vm._v(" "),_c('span',[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.seleccion3)+"\n\t\t\t\t\t\t")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"border":"2px solid aquamarine"},attrs:{"id":"reporte"}},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{attrs:{"align":"center"}},[_c('button',{staticClass:"button is-primary",on:{"click":function($event){return _vm.generaReporte()}}},[_vm._v("Generar reporte")]),_vm._v("\n\t\t\t\t\t    \n\t\t\t\t\t"),_c('button',{staticClass:"button is-primary",on:{"click":function($event){return _vm.guardarReporte()}}},[_vm._v("Guardar reporte")]),_vm._v("\n\t\t\t\t\t    \n\t\t\t\t\t\n\t\t\t\t")]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"column is-one-quarter"},[_vm._v("\n\t\t\tFiltro\n\t\t\t"),_c('br'),_c('br'),_vm._v("\n\t\t\tAtencion. Filtrar de la siguiente manera: "+_vm._s(_vm.letreroFiltros)+"\n\t\t\t"),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('select',{staticClass:"select is-primary",attrs:{"id":"cualFiltroUsar"},on:{"change":function($event){return _vm.limpiar()}}}),_vm._v(" "),_c('br'),_vm._v("\n\t\t\tDe"),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtroTexto),expression:"filtroTexto"}],staticClass:"input is-primary",attrs:{"size":"35","type":"text","id":"cualFiltroTexto"},domProps:{"value":(_vm.filtroTexto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filtroTexto=$event.target.value}}}),_vm._v("\n\t\t\tA"),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtroTexto2),expression:"filtroTexto2"}],staticClass:"input is-primary",attrs:{"size":"35","type":"text","id":"cualFiltroTexto2"},domProps:{"value":(_vm.filtroTexto2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filtroTexto2=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"button is-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.filtrar()}}},[_vm._v("\n\t\t\t\tFILTRAR\n\t\t\t")]),_vm._v(" "),_c('button',{staticClass:"button is-primary",on:{"click":function($event){_vm.generaReporte(); _vm.quitarParametros()}}},[_vm._v("\n\t\t\t\tQUITAR FILTROS\n\t\t\t")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-primary",on:{"click":function($event){return _vm.imprimir('reporteAver')}}},[_vm._v("Imprimir reporte")])]),_vm._v(" "),_c('div',{attrs:{"id":"reporteAver","align":"left"}},[_c('br'),_vm._v(" "),_c('h1',[_c('strong',[_vm._v(_vm._s(_vm.nombreDelReporte))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Contenido:"+_vm._s(_vm.banerFiltros))]),_vm._v(" "),_c('br'),_vm._v(" "),(this.registrosTodos !=null)?_c('ul',{attrs:{"id":"todos-lista"}},[_c('table',{staticClass:"table is-striped is-hoverable",attrs:{"align":"left"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.titulo('0'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('1'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('2'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('3'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('4'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('5'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('6'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('7'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('8'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('9'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('10'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('11'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('12'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('13'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('14'))+"\n\t\t \t\t\t\t\t")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.titulo('15'))+"\n\t\t \t\t\t\t\t")])])]),_vm._v(" "),_c('tbody',{attrs:{"id":"registros"}},_vm._l((this.registrosTodos),function(contrat){return _c('tr',{on:{"click":function($event){return _vm.seleccion(contrat.id)}}},[_c('td',[_vm._v(_vm._s(_vm.colum('0',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('1',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('2',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('3',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('4',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('5',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('6',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('7',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('8',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('9',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('10',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('11',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('12',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('13',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('14',contrat)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.colum('15',contrat)))])])}),0),_vm._v(" "),_c('tfoot',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.total("0")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("1")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("2")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("3")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("4")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("5")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("6")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("7")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("8")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("9")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("10")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("11")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("12")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("13")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("14")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total("15")))])])])])]):_c('span',[_vm._v("Cargando ...")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"align":"center"}},[_c('br'),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"2px solid aquamarine"},attrs:{"id":"elReporte"}},[_vm._v("\n\t\t\t\t\tCampos incluidos:\n\t\t\t\t\t"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"2px solid aquamarine"},attrs:{"id":"elOrden"}},[_vm._v("\n\t\t\t\t\tOrden:\n\t\t\t\t\t"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"2px solid aquamarine"},attrs:{"id":"elFiltro"}},[_vm._v("\n\t\t\t\t\tFiltros:\n\t\t\t\t\t"),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js